
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb604"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb604"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eShmq", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $ad4393542232627c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $ad4393542232627c$export$66e4520cdb265d18);
$parcel$export(module.exports, "bindActionCreators", () => $ad4393542232627c$export$aea084d96e84da92);
$parcel$export(module.exports, "compose", () => $ad4393542232627c$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $ad4393542232627c$export$9ff26e0402cc7b7);

var $d49SP = parcelRequire("d49SP");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ad4393542232627c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $ad4393542232627c$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ad4393542232627c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $ad4393542232627c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ad4393542232627c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ad4393542232627c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ad4393542232627c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ad4393542232627c$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ad4393542232627c$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($ad4393542232627c$var$isDate(val)) return 'date';
    if ($ad4393542232627c$var$isError(val)) return 'error';
    var constructorName = $ad4393542232627c$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $ad4393542232627c$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $ad4393542232627c$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $ad4393542232627c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $ad4393542232627c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ad4393542232627c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(1));
        return enhancer($ad4393542232627c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ad4393542232627c$var$isPlainObject(action)) throw new Error($ad4393542232627c$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ad4393542232627c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ad4393542232627c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ad4393542232627c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ad4393542232627c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ad4393542232627c$export$8928921ea2d3b126 = $ad4393542232627c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ad4393542232627c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ad4393542232627c$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ad4393542232627c$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $ad4393542232627c$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ad4393542232627c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $ad4393542232627c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ad4393542232627c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $ad4393542232627c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ad4393542232627c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $ad4393542232627c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ad4393542232627c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ad4393542232627c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ad4393542232627c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $d49SP.default)((0, $d49SP.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("d49SP", function(module, exports) {

$parcel$export(module.exports, "default", () => $983350b7b3960a26$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");
function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kSlfw.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4ZreY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : i + "";
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, e) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var r;
    if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) {
        var i = r.call(t, e || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === e ? String : Number)(t);
}

});





parcelRegister("jHTLJ", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("iStRg")).default);
$parcel$export(module.exports, "createDispatchHook", () => (parcelRequire("2OPjR")).createDispatchHook);
$parcel$export(module.exports, "createSelectorHook", () => (parcelRequire("iD0SF")).createSelectorHook);
$parcel$export(module.exports, "createStoreHook", () => (parcelRequire("4TSkt")).createStoreHook);
$parcel$export(module.exports, "Provider", () => (parcelRequire("4hUQH")).default);
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $hfliI = parcelRequire("hfliI");

var $9b0Yv = parcelRequire("9b0Yv");
parcelRequire("7c7i6");
var $1u0KT = parcelRequire("1u0KT");

var $lnBci = parcelRequire("lnBci");

var $iD0SF = parcelRequire("iD0SF");

var $iStRg = parcelRequire("iStRg");
parcelRequire("gCPmi");
(0, $iD0SF.initializeUseSelector)((0, $9b0Yv.useSyncExternalStoreWithSelector));
(0, $iStRg.initializeConnect)((0, $hfliI.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $lnBci.setBatch)((0, $1u0KT.unstable_batchedUpdates));

});
parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hkKGc"));

});
parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});


parcelRegister("9b0Yv", function(module, exports) {
'use strict';

module.exports = (parcelRequire("i5mAx"));

});
parcelRegister("i5mAx", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d2aa372f85a97975$export$bf730a2d8bf68b42, (v) => $d2aa372f85a97975$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2aa372f85a97975$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $d2aa372f85a97975$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2aa372f85a97975$var$objectIs = "function" === typeof Object.is ? Object.is : $d2aa372f85a97975$var$is, $d2aa372f85a97975$var$useSyncExternalStore = $hfliI.useSyncExternalStore, $d2aa372f85a97975$var$useRef = $acw62.useRef, $d2aa372f85a97975$var$useEffect = $acw62.useEffect, $d2aa372f85a97975$var$useMemo = $acw62.useMemo, $d2aa372f85a97975$var$useDebugValue = $acw62.useDebugValue;
$d2aa372f85a97975$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2aa372f85a97975$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2aa372f85a97975$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2aa372f85a97975$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2aa372f85a97975$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2aa372f85a97975$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2aa372f85a97975$var$useDebugValue(value);
    return value;
};

});


parcelRegister("7c7i6", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("1u0KT")).unstable_batchedUpdates);

var $1u0KT = parcelRequire("1u0KT");

});

parcelRegister("lnBci", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $f9089991fdc24c9c$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $f9089991fdc24c9c$var$defaultNoopBatch(callback) {
    callback();
}
let $f9089991fdc24c9c$var$batch = $f9089991fdc24c9c$var$defaultNoopBatch; // Allow injecting another batching function later
const $f9089991fdc24c9c$export$4b9874722d0da7bc = (newBatch)=>$f9089991fdc24c9c$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6 = ()=>$f9089991fdc24c9c$var$batch;

});

parcelRegister("iD0SF", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", () => $d8fc8d639f906efc$export$e2e6e3f3f3b782e3);
$parcel$export(module.exports, "createSelectorHook", () => $d8fc8d639f906efc$export$2b53f90d2bd1cbfb);

var $acw62 = parcelRequire("acw62");

var $1ubyh = parcelRequire("1ubyh");

var $7iEsg = parcelRequire("7iEsg");

var $i41js = parcelRequire("i41js");
let $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector = (0, $i41js.notInitialized);
const $d8fc8d639f906efc$export$e2e6e3f3f3b782e3 = (fn)=>{
    $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector = fn;
};
const $d8fc8d639f906efc$var$refEquality = (a, b)=>a === b;
function $d8fc8d639f906efc$export$2b53f90d2bd1cbfb(context = (0, $7iEsg.ReactReduxContext)) {
    const useReduxContext = context === (0, $7iEsg.ReactReduxContext) ? (0, $1ubyh.useReduxContext) : (0, $1ubyh.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $d8fc8d639f906efc$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $acw62.useRef)(true);
        const wrappedSelector = (0, $acw62.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $acw62.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $d8fc8d639f906efc$export$2105062e25df4afe = /*#__PURE__*/ $d8fc8d639f906efc$export$2b53f90d2bd1cbfb();

});
parcelRegister("1ubyh", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", () => $11518dc3bb05d381$export$d4d6226d5fc61558);
$parcel$export(module.exports, "useReduxContext", () => $11518dc3bb05d381$export$c1275ca9a6fd3ec5);

var $acw62 = parcelRequire("acw62");

var $7iEsg = parcelRequire("7iEsg");
function $11518dc3bb05d381$export$d4d6226d5fc61558(context = (0, $7iEsg.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $acw62.useContext)(context);
        return contextValue;
    };
}
const $11518dc3bb05d381$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $11518dc3bb05d381$export$d4d6226d5fc61558();

});
parcelRegister("7iEsg", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $55099852ccad0564$export$cc80c08dc91f1c00);

var $acw62 = parcelRequire("acw62");
const $55099852ccad0564$var$ContextKey = Symbol.for(`react-redux-context`);
const $55099852ccad0564$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55099852ccad0564$var$getContext() {
    var _gT$ContextKey;
    if (!$acw62.createContext) return {};
    const contextMap = (_gT$ContextKey = $55099852ccad0564$var$gT[$55099852ccad0564$var$ContextKey]) != null ? _gT$ContextKey : $55099852ccad0564$var$gT[$55099852ccad0564$var$ContextKey] = new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
const $55099852ccad0564$export$cc80c08dc91f1c00 = /*#__PURE__*/ $55099852ccad0564$var$getContext();
var $55099852ccad0564$export$2e2bcd8739ae039 = $55099852ccad0564$export$cc80c08dc91f1c00;

});


parcelRegister("i41js", function(module, exports) {

$parcel$export(module.exports, "notInitialized", () => $d2699e687deeb28e$export$20656a4825650bd0);
const $d2699e687deeb28e$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};

});


parcelRegister("iStRg", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", () => $dbe46e5c642d971b$export$36d45daa6a4925b8);
$parcel$export(module.exports, "default", () => $dbe46e5c642d971b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");

var $cfvvO = parcelRequire("cfvvO");

var $40Fxm = parcelRequire("40Fxm");

var $ih4tx = parcelRequire("ih4tx");

var $kSE8V = parcelRequire("kSE8V");

var $7EQ16 = parcelRequire("7EQ16");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");

var $8PZ7r = parcelRequire("8PZ7r");
parcelRequire("7CByU");

var $7iEsg = parcelRequire("7iEsg");

var $i41js = parcelRequire("i41js");
const $dbe46e5c642d971b$var$_excluded = [
    "reactReduxForwardedRef"
];
let $dbe46e5c642d971b$var$useSyncExternalStore = (0, $i41js.notInitialized);
const $dbe46e5c642d971b$export$36d45daa6a4925b8 = (fn)=>{
    $dbe46e5c642d971b$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $dbe46e5c642d971b$var$EMPTY_ARRAY = [
    null,
    0
];
const $dbe46e5c642d971b$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $dbe46e5c642d971b$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $dbe46e5c642d971b$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $atMb1.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $dbe46e5c642d971b$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $dbe46e5c642d971b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $dbe46e5c642d971b$var$initStateUpdates = ()=>$dbe46e5c642d971b$var$EMPTY_ARRAY;
function $dbe46e5c642d971b$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $dbe46e5c642d971b$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $dbe46e5c642d971b$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $dbe46e5c642d971b$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $8PZ7r.default), areStatePropsEqual: areStatePropsEqual = (0, $8PZ7r.default), areMergedPropsEqual: areMergedPropsEqual = (0, $8PZ7r.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $7iEsg.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $kSE8V.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $ih4tx.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $7EQ16.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $1En50.default)(props, $dbe46e5c642d971b$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $cfvvO.isContextConsumer)(/*#__PURE__*/ $acw62.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $acw62.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $40Fxm.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $dbe46e5c642d971b$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $j4jJy.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $8nd05.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $acw62.useRef();
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef();
            const renderIsScheduled = $acw62.useRef(false);
            const isProcessingDispatch = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef();
            (0, $atMb1.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $dbe46e5c642d971b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $dbe46e5c642d971b$var$useIsomorphicLayoutEffectWithArgs($dbe46e5c642d971b$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $dbe46e5c642d971b$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $atMb1.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $acw62.createElement(WrappedComponent, (0, $8nd05.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $acw62.createElement(Connect, (0, $8nd05.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $dbe46e5c642d971b$export$2e2bcd8739ae039 = $dbe46e5c642d971b$var$connect;

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dNL7g"));

});
parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});



parcelRegister("cfvvO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cgj07"));

});
parcelRegister("cgj07", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $8ed5b7d8837dad8a$export$a7c73072b1a182ae, (v) => $8ed5b7d8837dad8a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8ed5b7d8837dad8a$export$9f27bc3417b4524d, (v) => $8ed5b7d8837dad8a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac, (v) => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35, (v) => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8ed5b7d8837dad8a$export$ffb0004e005737fa, (v) => $8ed5b7d8837dad8a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8ed5b7d8837dad8a$export$b624eff549462981, (v) => $8ed5b7d8837dad8a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8ed5b7d8837dad8a$export$7897aa7841a5380c, (v) => $8ed5b7d8837dad8a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8ed5b7d8837dad8a$export$602eac185826482c, (v) => $8ed5b7d8837dad8a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8ed5b7d8837dad8a$export$e2c29f18771995cb, (v) => $8ed5b7d8837dad8a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8ed5b7d8837dad8a$export$5f8d39834fd61797, (v) => $8ed5b7d8837dad8a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5, (v) => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $8ed5b7d8837dad8a$export$998bcd577473dd93, (v) => $8ed5b7d8837dad8a$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8ed5b7d8837dad8a$export$92387174baf9b227, (v) => $8ed5b7d8837dad8a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8ed5b7d8837dad8a$export$ec112efeb987d9c6, (v) => $8ed5b7d8837dad8a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8ed5b7d8837dad8a$export$b706b080d889d2c9, (v) => $8ed5b7d8837dad8a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8ed5b7d8837dad8a$export$5be5a87408f70ddc, (v) => $8ed5b7d8837dad8a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d, (v) => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8ed5b7d8837dad8a$export$455c2e768291efa6, (v) => $8ed5b7d8837dad8a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8ed5b7d8837dad8a$export$9522e17588c12572, (v) => $8ed5b7d8837dad8a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8ed5b7d8837dad8a$export$2110ac352bb060b9, (v) => $8ed5b7d8837dad8a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8ed5b7d8837dad8a$export$56885ab8b9c456ab, (v) => $8ed5b7d8837dad8a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de, (v) => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8ed5b7d8837dad8a$export$b82d16f27459e05a, (v) => $8ed5b7d8837dad8a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8ed5b7d8837dad8a$export$522c17b4f5e123e8, (v) => $8ed5b7d8837dad8a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6, (v) => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $8ed5b7d8837dad8a$export$3d6c20d97e46b957, (v) => $8ed5b7d8837dad8a$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $8ed5b7d8837dad8a$export$9b621391a187a31a, (v) => $8ed5b7d8837dad8a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f, (v) => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8ed5b7d8837dad8a$export$a7c73072b1a182ae;
var $8ed5b7d8837dad8a$export$9f27bc3417b4524d;
var $8ed5b7d8837dad8a$export$db77ccec0bb4ccac;
var $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35;
var $8ed5b7d8837dad8a$export$ffb0004e005737fa;
var $8ed5b7d8837dad8a$export$b624eff549462981;
var $8ed5b7d8837dad8a$export$7897aa7841a5380c;
var $8ed5b7d8837dad8a$export$602eac185826482c;
var $8ed5b7d8837dad8a$export$e2c29f18771995cb;
var $8ed5b7d8837dad8a$export$5f8d39834fd61797;
var $8ed5b7d8837dad8a$export$74bf444e3cd11ea5;
var $8ed5b7d8837dad8a$export$998bcd577473dd93;
var $8ed5b7d8837dad8a$export$92387174baf9b227;
var $8ed5b7d8837dad8a$export$ec112efeb987d9c6;
var $8ed5b7d8837dad8a$export$b706b080d889d2c9;
var $8ed5b7d8837dad8a$export$5be5a87408f70ddc;
var $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d;
var $8ed5b7d8837dad8a$export$455c2e768291efa6;
var $8ed5b7d8837dad8a$export$9522e17588c12572;
var $8ed5b7d8837dad8a$export$2110ac352bb060b9;
var $8ed5b7d8837dad8a$export$56885ab8b9c456ab;
var $8ed5b7d8837dad8a$export$d927fcb6adf8f9de;
var $8ed5b7d8837dad8a$export$b82d16f27459e05a;
var $8ed5b7d8837dad8a$export$522c17b4f5e123e8;
var $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6;
var $8ed5b7d8837dad8a$export$3d6c20d97e46b957;
var $8ed5b7d8837dad8a$export$9b621391a187a31a;
var $8ed5b7d8837dad8a$export$f5bbd400c2f4426f;
'use strict';
var $8ed5b7d8837dad8a$var$b = Symbol.for("react.element"), $8ed5b7d8837dad8a$var$c = Symbol.for("react.portal"), $8ed5b7d8837dad8a$var$d = Symbol.for("react.fragment"), $8ed5b7d8837dad8a$var$e = Symbol.for("react.strict_mode"), $8ed5b7d8837dad8a$var$f = Symbol.for("react.profiler"), $8ed5b7d8837dad8a$var$g = Symbol.for("react.provider"), $8ed5b7d8837dad8a$var$h = Symbol.for("react.context"), $8ed5b7d8837dad8a$var$k = Symbol.for("react.server_context"), $8ed5b7d8837dad8a$var$l = Symbol.for("react.forward_ref"), $8ed5b7d8837dad8a$var$m = Symbol.for("react.suspense"), $8ed5b7d8837dad8a$var$n = Symbol.for("react.suspense_list"), $8ed5b7d8837dad8a$var$p = Symbol.for("react.memo"), $8ed5b7d8837dad8a$var$q = Symbol.for("react.lazy"), $8ed5b7d8837dad8a$var$t = Symbol.for("react.offscreen"), $8ed5b7d8837dad8a$var$u;
$8ed5b7d8837dad8a$var$u = Symbol.for("react.module.reference");
function $8ed5b7d8837dad8a$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $8ed5b7d8837dad8a$var$b:
                switch(a = a.type, a){
                    case $8ed5b7d8837dad8a$var$d:
                    case $8ed5b7d8837dad8a$var$f:
                    case $8ed5b7d8837dad8a$var$e:
                    case $8ed5b7d8837dad8a$var$m:
                    case $8ed5b7d8837dad8a$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8ed5b7d8837dad8a$var$k:
                            case $8ed5b7d8837dad8a$var$h:
                            case $8ed5b7d8837dad8a$var$l:
                            case $8ed5b7d8837dad8a$var$q:
                            case $8ed5b7d8837dad8a$var$p:
                            case $8ed5b7d8837dad8a$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $8ed5b7d8837dad8a$var$c:
                return r;
        }
    }
}
$8ed5b7d8837dad8a$export$a7c73072b1a182ae = $8ed5b7d8837dad8a$var$h;
$8ed5b7d8837dad8a$export$9f27bc3417b4524d = $8ed5b7d8837dad8a$var$g;
$8ed5b7d8837dad8a$export$db77ccec0bb4ccac = $8ed5b7d8837dad8a$var$b;
$8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = $8ed5b7d8837dad8a$var$l;
$8ed5b7d8837dad8a$export$ffb0004e005737fa = $8ed5b7d8837dad8a$var$d;
$8ed5b7d8837dad8a$export$b624eff549462981 = $8ed5b7d8837dad8a$var$q;
$8ed5b7d8837dad8a$export$7897aa7841a5380c = $8ed5b7d8837dad8a$var$p;
$8ed5b7d8837dad8a$export$602eac185826482c = $8ed5b7d8837dad8a$var$c;
$8ed5b7d8837dad8a$export$e2c29f18771995cb = $8ed5b7d8837dad8a$var$f;
$8ed5b7d8837dad8a$export$5f8d39834fd61797 = $8ed5b7d8837dad8a$var$e;
$8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = $8ed5b7d8837dad8a$var$m;
$8ed5b7d8837dad8a$export$998bcd577473dd93 = $8ed5b7d8837dad8a$var$n;
$8ed5b7d8837dad8a$export$92387174baf9b227 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$ec112efeb987d9c6 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$b706b080d889d2c9 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$h;
};
$8ed5b7d8837dad8a$export$5be5a87408f70ddc = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$g;
};
$8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8ed5b7d8837dad8a$var$b;
};
$8ed5b7d8837dad8a$export$455c2e768291efa6 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$l;
};
$8ed5b7d8837dad8a$export$9522e17588c12572 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$d;
};
$8ed5b7d8837dad8a$export$2110ac352bb060b9 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$q;
};
$8ed5b7d8837dad8a$export$56885ab8b9c456ab = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$p;
};
$8ed5b7d8837dad8a$export$d927fcb6adf8f9de = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$c;
};
$8ed5b7d8837dad8a$export$b82d16f27459e05a = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$f;
};
$8ed5b7d8837dad8a$export$522c17b4f5e123e8 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$e;
};
$8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$m;
};
$8ed5b7d8837dad8a$export$3d6c20d97e46b957 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$n;
};
$8ed5b7d8837dad8a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8ed5b7d8837dad8a$var$d || a === $8ed5b7d8837dad8a$var$f || a === $8ed5b7d8837dad8a$var$e || a === $8ed5b7d8837dad8a$var$m || a === $8ed5b7d8837dad8a$var$n || a === $8ed5b7d8837dad8a$var$t || "object" === typeof a && null !== a && (a.$$typeof === $8ed5b7d8837dad8a$var$q || a.$$typeof === $8ed5b7d8837dad8a$var$p || a.$$typeof === $8ed5b7d8837dad8a$var$g || a.$$typeof === $8ed5b7d8837dad8a$var$h || a.$$typeof === $8ed5b7d8837dad8a$var$l || a.$$typeof === $8ed5b7d8837dad8a$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$8ed5b7d8837dad8a$export$f5bbd400c2f4426f = $8ed5b7d8837dad8a$var$v;

});


parcelRegister("40Fxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb761e6a8ffbe36$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");
parcelRequire("d6Wo0");
const $2eb761e6a8ffbe36$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $2eb761e6a8ffbe36$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $1En50.default)(_ref, $2eb761e6a8ffbe36$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("d6Wo0", function(module, exports) {

var $7CByU = parcelRequire("7CByU");
function $98b92028b84cbd13$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $7CByU.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $98b92028b84cbd13$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $98b92028b84cbd13$var$verify(mapStateToProps, 'mapStateToProps');
    $98b92028b84cbd13$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $98b92028b84cbd13$var$verify(mergeProps, 'mergeProps');
}

});
parcelRegister("7CByU", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c9380df5fc9ad2$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $58c9380df5fc9ad2$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("ih4tx", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", () => $d4dd493c66c4df43$export$b69a785ceac019a6);

var $96XmR = parcelRequire("96XmR");

var $3TktP = parcelRequire("3TktP");

var $kC3dh = parcelRequire("kC3dh");
function $d4dd493c66c4df43$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $3TktP.wrapMapToPropsConstant)((dispatch)=>(0, $96XmR.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $3TktP.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $3TktP.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, $kC3dh.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

});
parcelRegister("96XmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a22b9cec285f673$export$2e2bcd8739ae039);
function $6a22b9cec285f673$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("3TktP", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $2d566511964cb2c4$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $2d566511964cb2c4$export$8d46c7f53c8c602f);
parcelRequire("jKoYp");
function $2d566511964cb2c4$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $2d566511964cb2c4$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $2d566511964cb2c4$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("jKoYp", function(module, exports) {

var $btfXQ = parcelRequire("btfXQ");

var $7CByU = parcelRequire("7CByU");
function $e605af63e5bbc093$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $btfXQ.default)(value)) (0, $7CByU.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("btfXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $859ec94da7aa38c4$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $859ec94da7aa38c4$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("kC3dh", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", () => $f019d9508e58fcb7$export$19ef7b929f7e2559);
function $f019d9508e58fcb7$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("kSE8V", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", () => $f337fd5395077a96$export$e00e93951827eda7);

var $3TktP = parcelRequire("3TktP");

var $kC3dh = parcelRequire("kC3dh");
function $f337fd5395077a96$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $3TktP.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $3TktP.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, $kC3dh.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

});

parcelRegister("7EQ16", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", () => $59349e43bbd01749$export$17457cf6fa742f84);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("jKoYp");

var $kC3dh = parcelRequire("kC3dh");
function $59349e43bbd01749$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $8nd05.default)({}, ownProps, stateProps, dispatchProps);
}
function $59349e43bbd01749$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $59349e43bbd01749$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$59349e43bbd01749$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $59349e43bbd01749$export$5b105939c84b5234(mergeProps) : (0, $kC3dh.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

});

parcelRegister("j4jJy", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $de1db2bafb2c3b5a$export$d567d2b9af322f8f);

var $lnBci = parcelRequire("lnBci");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $de1db2bafb2c3b5a$var$createListenerCollection() {
    const batch = (0, $lnBci.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $de1db2bafb2c3b5a$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $de1db2bafb2c3b5a$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $de1db2bafb2c3b5a$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $de1db2bafb2c3b5a$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $de1db2bafb2c3b5a$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("atMb1", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $7a11fbbe9e9ac5f8$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
const $7a11fbbe9e9ac5f8$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $7a11fbbe9e9ac5f8$export$700979bc83e7db82 = $7a11fbbe9e9ac5f8$export$71594e8a50f746f4 ? $acw62.useLayoutEffect : $acw62.useEffect;

});

parcelRegister("8PZ7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $66f27f2048ec2805$export$2e2bcd8739ae039);
function $66f27f2048ec2805$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $66f27f2048ec2805$export$2e2bcd8739ae039(objA, objB) {
    if ($66f27f2048ec2805$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$66f27f2048ec2805$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("gCPmi", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("4hUQH")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("iStRg")).default);
$parcel$export(module.exports, "createDispatchHook", () => (parcelRequire("2OPjR")).createDispatchHook);
$parcel$export(module.exports, "createSelectorHook", () => (parcelRequire("iD0SF")).createSelectorHook);
$parcel$export(module.exports, "createStoreHook", () => (parcelRequire("4TSkt")).createStoreHook);

var $4hUQH = parcelRequire("4hUQH");

var $iStRg = parcelRequire("iStRg");

var $7iEsg = parcelRequire("7iEsg");

var $2OPjR = parcelRequire("2OPjR");

var $iD0SF = parcelRequire("iD0SF");

var $4TSkt = parcelRequire("4TSkt");

var $8PZ7r = parcelRequire("8PZ7r");
parcelRequire("gKObn");

});
parcelRegister("4hUQH", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f4d8f6ffbbb628$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $7iEsg = parcelRequire("7iEsg");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");
function $31f4d8f6ffbbb628$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $acw62.useMemo(()=>{
        const subscription = (0, $j4jJy.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $atMb1.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $7iEsg.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $31f4d8f6ffbbb628$export$2e2bcd8739ae039 = $31f4d8f6ffbbb628$var$Provider;

});

parcelRegister("2OPjR", function(module, exports) {

$parcel$export(module.exports, "createDispatchHook", () => $20d80f3cecee513e$export$bc9b55530897c558);

var $7iEsg = parcelRequire("7iEsg");

var $4TSkt = parcelRequire("4TSkt");
function $20d80f3cecee513e$export$bc9b55530897c558(context = (0, $7iEsg.ReactReduxContext)) {
    const useStore = context === (0, $7iEsg.ReactReduxContext) ? (0, $4TSkt.useStore) : (0, $4TSkt.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $20d80f3cecee513e$export$8ad76b76a4c905f8 = /*#__PURE__*/ $20d80f3cecee513e$export$bc9b55530897c558();

});
parcelRegister("4TSkt", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $391671225302c365$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $391671225302c365$export$6ccbb43953eebf8);

var $7iEsg = parcelRequire("7iEsg");

var $1ubyh = parcelRequire("1ubyh");
function $391671225302c365$export$671dba69185d0304(context = (0, $7iEsg.ReactReduxContext)) {
    const useReduxContext = context === (0, $7iEsg.ReactReduxContext) ? (0, $1ubyh.useReduxContext) : (0, $1ubyh.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $391671225302c365$export$6ccbb43953eebf8 = /*#__PURE__*/ $391671225302c365$export$671dba69185d0304();

});


parcelRegister("gKObn", function(module, exports) {

});



parcelRegister("eNuyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac5d5956ce0b399b$export$2e2bcd8739ae039);
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $ac5d5956ce0b399b$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $ac5d5956ce0b399b$var$thunk = $ac5d5956ce0b399b$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$ac5d5956ce0b399b$var$thunk.withExtraArgument = $ac5d5956ce0b399b$var$createThunkMiddleware;
var $ac5d5956ce0b399b$export$2e2bcd8739ae039 = $ac5d5956ce0b399b$var$thunk;

});

parcelRegister("f1q41", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("fPryk", function(module, exports) {

module.exports = (parcelRequire("hkvlR"));

});
parcelRegister("hkvlR", function(module, exports) {

$parcel$export(module.exports, "examplePlanMap", () => $c9dc9fb022ef0335$export$eb46979449632d55, (v) => $c9dc9fb022ef0335$export$eb46979449632d55 = v);
$parcel$export(module.exports, "industryCodes", () => $c9dc9fb022ef0335$export$1c2d46c5527ad9b5, (v) => $c9dc9fb022ef0335$export$1c2d46c5527ad9b5 = v);
$parcel$export(module.exports, "profileMap", () => $c9dc9fb022ef0335$export$6e847dc4780c23fa, (v) => $c9dc9fb022ef0335$export$6e847dc4780c23fa = v);
$parcel$export(module.exports, "profileTraitMap", () => $c9dc9fb022ef0335$export$eb4b6ee9a84c97cb, (v) => $c9dc9fb022ef0335$export$eb4b6ee9a84c97cb = v);
$parcel$export(module.exports, "questionUnitMap", () => $c9dc9fb022ef0335$export$108ba8cf295f4da8, (v) => $c9dc9fb022ef0335$export$108ba8cf295f4da8 = v);
$parcel$export(module.exports, "quizOrderInfo", () => $c9dc9fb022ef0335$export$e652ba0acd664716, (v) => $c9dc9fb022ef0335$export$e652ba0acd664716 = v);
$parcel$export(module.exports, "redirectPaths", () => $c9dc9fb022ef0335$export$7a108e1bf0a3c382, (v) => $c9dc9fb022ef0335$export$7a108e1bf0a3c382 = v);
$parcel$export(module.exports, "spaceUnitMap", () => $c9dc9fb022ef0335$export$60fac73f4bb6d651, (v) => $c9dc9fb022ef0335$export$60fac73f4bb6d651 = v);
$parcel$export(module.exports, "suggestedCustomAmenityUnitMap", () => $c9dc9fb022ef0335$export$853570c3a9e0060, (v) => $c9dc9fb022ef0335$export$853570c3a9e0060 = v);
$parcel$export(module.exports, "defaultSpaceProfileTemplates", () => $c9dc9fb022ef0335$export$4fdc4dfc167a8c9d, (v) => $c9dc9fb022ef0335$export$4fdc4dfc167a8c9d = v);
$parcel$export(module.exports, "defaultLocationTemplates", () => $c9dc9fb022ef0335$export$cf059a07b7fdbf82, (v) => $c9dc9fb022ef0335$export$cf059a07b7fdbf82 = v);
$parcel$export(module.exports, "resourceAutofillOptions", () => $c9dc9fb022ef0335$export$b8c2608929054207, (v) => $c9dc9fb022ef0335$export$b8c2608929054207 = v);
$parcel$export(module.exports, "brokerEmailTypeToSubjectMap", () => $c9dc9fb022ef0335$export$50d187b783c8b985, (v) => $c9dc9fb022ef0335$export$50d187b783c8b985 = v);
$parcel$export(module.exports, "sharedFocusAutofillOptions", () => $c9dc9fb022ef0335$export$e648fd378c14cb6d, (v) => $c9dc9fb022ef0335$export$e648fd378c14cb6d = v);
$parcel$export(module.exports, "defaultCollaborationTemplates", () => $c9dc9fb022ef0335$export$8db55702fab76517, (v) => $c9dc9fb022ef0335$export$8db55702fab76517 = v);
var $c9dc9fb022ef0335$export$eb46979449632d55;
var $c9dc9fb022ef0335$export$1c2d46c5527ad9b5;
var $c9dc9fb022ef0335$export$6e847dc4780c23fa;
var $c9dc9fb022ef0335$export$eb4b6ee9a84c97cb;
var $c9dc9fb022ef0335$export$108ba8cf295f4da8;
var $c9dc9fb022ef0335$export$e652ba0acd664716;
var $c9dc9fb022ef0335$export$7a108e1bf0a3c382;
var $c9dc9fb022ef0335$export$60fac73f4bb6d651;
var $c9dc9fb022ef0335$export$853570c3a9e0060;
var $c9dc9fb022ef0335$export$4fdc4dfc167a8c9d;
var $c9dc9fb022ef0335$export$cf059a07b7fdbf82;
var $c9dc9fb022ef0335$export$b8c2608929054207;
var $c9dc9fb022ef0335$export$50d187b783c8b985;
var $c9dc9fb022ef0335$export$e648fd378c14cb6d;
var $c9dc9fb022ef0335$export$8db55702fab76517;

$c9dc9fb022ef0335$export$eb46979449632d55 = (parcelRequire("558qD"));

$c9dc9fb022ef0335$export$1c2d46c5527ad9b5 = (parcelRequire("lQpt8"));

$c9dc9fb022ef0335$export$6e847dc4780c23fa = (parcelRequire("4ICSb"));

$c9dc9fb022ef0335$export$eb4b6ee9a84c97cb = (parcelRequire("egCFH"));

$c9dc9fb022ef0335$export$108ba8cf295f4da8 = (parcelRequire("ktyWi"));

$c9dc9fb022ef0335$export$e652ba0acd664716 = (parcelRequire("9dywM"));

$c9dc9fb022ef0335$export$7a108e1bf0a3c382 = (parcelRequire("71fW4"));

$c9dc9fb022ef0335$export$60fac73f4bb6d651 = (parcelRequire("4Ds5C"));

$c9dc9fb022ef0335$export$853570c3a9e0060 = (parcelRequire("9yvR1"));

$c9dc9fb022ef0335$export$4fdc4dfc167a8c9d = (parcelRequire("j4epO"));

$c9dc9fb022ef0335$export$cf059a07b7fdbf82 = (parcelRequire("72KKs"));

$c9dc9fb022ef0335$export$b8c2608929054207 = (parcelRequire("lhxnV"));

$c9dc9fb022ef0335$export$50d187b783c8b985 = (parcelRequire("jEhAf"));

$c9dc9fb022ef0335$export$e648fd378c14cb6d = (parcelRequire("3w8Fq"));

$c9dc9fb022ef0335$export$8db55702fab76517 = (parcelRequire("3owcF"));

});
parcelRegister("558qD", function(module, exports) {
// Example plans all live in the Spacer Org
// https://plans.cbre.com/#/buildings/ce0f8339-3edd-4ea8-98a7-56ece59f643f
const $3b33f521db8e2242$var$EXAMPLE_PLAN_MAP = {
    link3D: {
        // Optimizer
        efficient: {
            partial_5000: '3ea29d01-3b80-40a9-b823-31a3ce6eb8b3',
            full_5000: '9158be14-1151-4123-af01-63bfc2684558',
            partial_10000: '075fb71e-3332-4572-867c-7902478f8445',
            full_10000: '29bb2619-4640-4b6b-8a26-650c9c78050f',
            partial_15000: '2d63e23b-6c06-4cc4-be9a-e1350d27dbe2',
            full_15000: '557c7a05-fc17-46c5-bfdc-351e9eed19af',
            partial_20000: '8a6ea685-4c26-4e15-87b3-49d7f9a75d7d',
            full_20000: '8a464537-4ddf-47b7-9f0e-d609eed27ff0'
        },
        // Accomodator
        whiteCollar: {
            partial_5000: '0c5aeae7-46cd-4ca9-81c4-f561b49ceb43',
            full_5000: 'd93201af-f42e-4979-839e-431177e831de',
            partial_10000: '748523db-2283-43fa-ba34-937bc355f28f',
            full_10000: '0e0a86c4-2307-4e2d-87a3-5506e5d12903',
            partial_15000: 'cd4409eb-d1e6-42b0-8862-0509fc6ba46e',
            full_15000: '308f1555-fce9-426a-a109-04fe87d2ea5a',
            partial_20000: '1739c9f5-4690-41d2-aaac-ccca5cdd9a25',
            full_20000: 'ef3cba37-2ce0-470f-abd4-f7d957ce7436'
        },
        // Enhancer
        whiteGlove: {
            partial_5000: 'b5b49e23-87f1-4189-8e66-7ace3d5e5a3a',
            full_5000: 'd8940f49-edfa-42a5-ab8f-75592f76e09b',
            partial_10000: '7053fca4-3d8e-42e9-96d6-bf73427f3e36',
            full_10000: '042be30d-5a26-4428-ae73-aa54803350e8',
            partial_15000: 'ecde8012-9155-4b25-b926-91f6a6edaaa2',
            full_15000: '05cfb734-befb-4dde-b595-566f3fc52598',
            partial_20000: '7e53541a-b937-4f82-ba19-f06cf9660293',
            full_20000: '8000d8fc-e4bb-47f4-8c50-d173a94d0b2d'
        },
        // Producer
        openOffice: {
            partial_5000: 'f87173d6-eb46-41b4-ad86-ed74f6b46d3d',
            full_5000: 'dd6f0a13-0942-4af9-8b64-a8ca83acf548',
            partial_10000: '2be799c2-e763-4591-a66c-0fe6f1f36d1c',
            full_10000: '18d241fb-98b1-4dda-9bcd-55b90103901c',
            partial_15000: '0d369132-8180-436a-a663-d3a1536de157',
            full_15000: '8e30c763-3810-4053-9c42-93cce2004130',
            partial_20000: '0c50f989-59db-4a7e-a834-21a8a4940267',
            full_20000: '1add934a-f4b6-4d65-8dc6-ba794941e945'
        },
        // Connector
        workplace360: {
            partial_5000: '17a60ace-196f-4f61-b2fe-c172edefd22f',
            full_5000: '4224309a-fb7c-42a5-a787-076bbfbf7014',
            partial_10000: 'fa10ea7e-cfa9-45c6-ba1f-f034d4e8c295',
            full_10000: 'e4bbdbac-11d8-4042-b698-8ec2c8964f7f',
            partial_15000: 'fbf2f530-f208-453a-9354-9e59174bdac5',
            full_15000: '5dba30b5-22c5-4b22-9264-3309969a55ef',
            partial_20000: 'c5526b33-2ed1-427b-8eda-e1db3dfa8922',
            full_20000: '83cffe4d-f5fb-432c-8b9c-9f6e24f3950e'
        },
        // Differentiator
        campus: {
            partial_5000: 'a81519ed-b8c9-4ff1-af48-ccbf91b11874',
            full_5000: '8b0bd036-d3f9-4a82-8d2e-207942c08fef',
            partial_10000: '64f67022-776d-4b82-8c60-f3b96cb1397c',
            full_10000: 'c9477a03-d1a2-41fc-b780-a2f867e20a67',
            partial_15000: 'a15a851c-3246-4bba-a21d-92fa0b6feac9',
            full_15000: '2ca2376e-6ac2-477c-b5b8-94bc281ad1a1',
            partial_20000: 'f21e1b71-4edc-4434-b24d-369308609913',
            full_20000: '0a94d188-0ba2-4703-85fa-a69375b74cd6'
        },
        // Incubator
        startup: {
            partial_5000: '3815376a-f3a7-45c4-a39e-fe20981f42d7',
            full_5000: 'fc53f387-71c2-4df5-b97f-dc9c90e01ad2',
            partial_10000: 'de9cdc62-14bc-44c2-b1bc-caf7b15e30ea',
            full_10000: 'bfb8b5e3-2585-467c-a4d4-d9611fa86a83',
            partial_15000: '34022700-7452-4ff8-9212-1c1ca5067700',
            full_15000: '34495fb9-0e96-4da1-8995-d55d5685efbb',
            partial_20000: 'a5d9e386-fa43-4e20-90fc-a09128a3c65b',
            full_20000: '24413a74-b82e-40f2-b7ce-d982e99ed6d1'
        },
        // Creator
        engCreative: {
            partial_5000: 'd3500a3c-aaf1-4a8f-91ec-d0798b05dd5e',
            full_5000: '90b495a5-ae68-411d-b935-5cec6e1f98bf',
            partial_10000: '5981faee-ab91-4a4c-9a38-8b45d6f4b7f8',
            full_10000: '033e3fa3-d275-4673-9d96-7d3d5b245bb9',
            partial_15000: '7d92c143-716c-48eb-bb5c-93db1f90e4cb',
            full_15000: 'cffb6ab7-9a12-42e1-b6cf-b1a6a4672e44',
            partial_20000: '4093f4a7-f6c5-4de6-b6e4-4a3191b828a9',
            full_20000: '451def70-0f19-4feb-aac7-4307dc927eb1'
        }
    },
    link2D: {
        // Optimizer
        efficient: {
            partial_5000: '3f7a6d47-d50a-4387-961c-c65d852d23ee',
            full_5000: '1e45b047-e453-4ec8-9a1b-2596e9a4ee2a',
            partial_10000: '6f42eede-840d-41af-9137-cb46074cf0ae',
            full_10000: 'fb6e562e-c6ce-402a-b068-1823004a7e24',
            partial_15000: 'c5792724-34fd-4561-8f21-7df78c87c883',
            full_15000: 'f07f5f89-bc87-4e7b-8a40-1dec7b379c9a',
            partial_20000: '3c1e6be9-1e17-458f-9fd3-c06a08fd6c68',
            full_20000: '759252f2-c734-469a-855e-76dbd5ee8f43'
        },
        // Accomodator
        whiteCollar: {
            partial_5000: '8a9ad240-9298-4aa6-a9db-37139bba6653',
            full_5000: '1d54f61f-826d-451f-89d6-f5f84ced0a09',
            partial_10000: 'dc7a33dc-caa7-45a0-aa36-cf2bcd1c4612',
            full_10000: '25971233-d708-445b-b1cf-74218652a24a',
            partial_15000: 'eeacc42e-8d3a-469b-a3c0-c05bfae59c4a',
            full_15000: 'c42862aa-4a99-4414-8bfa-18e4f5d98c2d',
            partial_20000: 'd0f183b4-7425-49cc-ae74-096ff44de493',
            full_20000: '89e01f33-cd9a-4ee4-a7f6-e556239a385f'
        },
        // Enhancer
        whiteGlove: {
            partial_5000: 'aae0878f-3868-470f-96df-92d563bbb0f1',
            full_5000: '6721c34c-52ca-4f9c-a4bb-26c1bf4a2d0a',
            partial_10000: '62b5a6c4-11b0-4683-b87b-e2cd87b2fbc0',
            full_10000: '0cd09b27-db9b-4ec7-9b41-14123b35a1f0',
            partial_15000: '6fb1e96a-9032-4648-b263-6613b209263b',
            full_15000: '30291fbc-71f1-440f-912b-5b6b6b4b721f',
            partial_20000: '76276dcb-97c8-44b2-b0d5-58992de5b747',
            full_20000: '648cd7f1-09e7-4d56-b406-0ffd0f901364'
        },
        // Producer
        openOffice: {
            partial_5000: '70e5e1fc-e515-4d55-9062-80f1f84e63a8',
            full_5000: 'd988a4ce-e296-42b2-a690-2c281eca19c0',
            partial_10000: '8812d1f1-5e35-4b3b-b06a-e98d5757804b',
            full_10000: 'c13c8c5f-a13e-463a-97e4-0ab324d950d0',
            partial_15000: 'ca611c44-2cb6-4d8e-bd33-07b08e5acccb',
            full_15000: '4fb48f93-6d9d-45bf-8426-325ad7bcc141',
            partial_20000: 'ba57d610-f0cb-4329-8dd1-73dfa410d51c',
            full_20000: '8e9a398c-94ef-4ed3-9aae-15ab7dd5594e'
        },
        // Connector
        workplace360: {
            partial_5000: 'c4048aa2-0f2e-458f-ac67-54c32c5a75e7',
            full_5000: '931ee6a4-ab44-46b3-9d3a-8425857a4daa',
            partial_10000: 'a9d70d02-faf4-48d1-80f2-fcc9264b8868',
            full_10000: '463d3070-d98c-4ae6-9e8c-842cdad5d39a',
            partial_15000: 'ca79f4dd-033e-4a04-a542-47ca2c79b19b',
            full_15000: 'd1847b5d-6255-4003-9344-dd7f1bf35a2e',
            partial_20000: 'f3e9e4d2-a3b6-4570-ba50-843451726cc9',
            full_20000: '86be8ad9-2bc9-401c-8c5b-160c16a59a07'
        },
        // Differentiator
        campus: {
            partial_5000: 'b64c7e7e-7f61-4556-bd3b-7d0612be1fb0',
            full_5000: '11e985f2-3bd0-492b-9f2c-f9324e3f567f',
            partial_10000: '40a10b84-f172-4a7e-aedc-dae2d9180f4c',
            full_10000: 'f43842ec-e3fd-4a1e-9689-b99aba76e9d0',
            partial_15000: 'f7075f35-f8e8-47a8-88e4-aaa14250ba21',
            full_15000: 'c77ea656-106c-40ff-a3c6-dcfcc9087648',
            partial_20000: 'ccccf4a4-31d3-4bd1-adcc-114abb214e1e',
            full_20000: '76cc6204-435c-45cb-8258-8c2865b9daca'
        },
        // Incubator
        startup: {
            partial_5000: '506c9a03-7d53-457d-8eaa-c2c29e7e4889',
            full_5000: '1ab93c17-644f-495c-a857-7254527562bc',
            partial_10000: '702200a9-4b62-407b-b283-99258717cafa',
            full_10000: '5804c1db-cea3-49f8-ae03-a9de919f382d',
            partial_15000: '9e611aac-75b4-4bc8-9d32-bae2f1a4b54e',
            full_15000: 'c81abd7b-90b0-464a-b5b3-ca7f8be3989e',
            partial_20000: 'f35c1c70-3d98-4cf0-8fa4-3aefa26e226a',
            full_20000: '855c9e5e-2dd2-48bb-aa94-03a5c25ea3fc'
        },
        // Creator
        engCreative: {
            partial_5000: 'c963d9d7-7e1f-4cf1-a760-d5d46c4734e3',
            full_5000: 'df4119fe-f484-4f0a-8e53-50e2a1c6166b',
            partial_10000: '273eddfc-c8ff-4734-a521-5d06732fa1ab',
            full_10000: '409ed9d3-aa66-49f2-9938-bff3618099c7',
            partial_15000: 'a3933f32-7a75-456b-94fb-8fa500703310',
            full_15000: '09853faa-0612-4819-a091-12642555c469',
            partial_20000: '1a57f542-829b-4bc7-8d89-78840f93e3e0',
            full_20000: 'acb6c89a-1bc7-49e4-9bad-3db81c6d744d'
        }
    }
};
module.exports = $3b33f521db8e2242$var$EXAMPLE_PLAN_MAP;

});

parcelRegister("lQpt8", function(module, exports) {

var $f1q41 = parcelRequire("f1q41");
const $fe7235eb3e011ca0$var$industryCodeTokensAndValues = {
    112: {
        token: 'animalProd',
        value: 'Animal production and aquaculture'
    },
    113: {
        token: 'forestry',
        value: 'Forestry and logging'
    },
    114: {
        token: 'fishingHunting',
        value: 'Fishing, hunting and trapping'
    },
    115: {
        token: 'agForestSupport',
        value: 'Agriculture and forestry support activities'
    },
    211: {
        token: 'oilGas',
        value: 'Oil and gas extraction'
    },
    2111: {
        token: 'energy',
        value: 'Energy (Gas, Oil, etc.)'
    },
    212: {
        token: 'mining',
        value: 'Mining, except oil and gas'
    },
    213: {
        token: 'supportMining',
        value: 'Support activities for mining'
    },
    221: {
        token: 'utilities',
        value: 'Utilities'
    },
    236: {
        token: 'buildingConstruct',
        value: 'Construction of buildings'
    },
    237: {
        token: 'heavyCivilConstruct',
        value: 'Heavy and civil engineering construction'
    },
    238: {
        token: 'specialtyContract',
        value: 'Specialty trade contractors'
    },
    3119: {
        token: 'foodManufac',
        value: 'Food Manufacturing'
    },
    312: {
        token: 'beverageTobaccoManufac',
        value: 'Beverage and tobacco product manufacturing'
    },
    313: {
        token: 'textile',
        value: 'Textile mills'
    },
    314: {
        token: 'textileProduct',
        value: 'Textile product mills'
    },
    315: {
        token: 'apparelManufac',
        value: 'Apparel manufacturing'
    },
    316: {
        token: 'leatherManufac',
        value: 'Leather and allied product manufacturing'
    },
    321: {
        token: 'woodManufac',
        value: 'Wood product manufacturing'
    },
    322: {
        token: 'paperManufac',
        value: 'Paper manufacturing'
    },
    323: {
        token: 'printingSupport',
        value: 'Printing and related support activities'
    },
    3231: {
        token: 'printingReproduc',
        value: 'Printing/Reproductions'
    },
    324: {
        token: 'petroleumCoal',
        value: 'Petroleum and coal products manufacturing'
    },
    325: {
        token: 'chemicalManufac',
        value: 'Chemical manufacturing'
    },
    3251: {
        token: 'chemicals',
        value: 'Chemicals'
    },
    3254: {
        token: 'pharma',
        value: 'Pharmaceuticals'
    },
    3256: {
        token: 'cleaningManufac',
        value: 'Cleaning Manufacturing'
    },
    326: {
        token: 'plasticsRubberManufac',
        value: 'Plastics and rubber products manufacturing'
    },
    327: {
        token: 'nonmetallicManufac',
        value: 'Nonmetallic mineral product manufacturing'
    },
    331: {
        token: 'primaryMetalManufac',
        value: 'Primary metal manufacturing'
    },
    332: {
        token: 'fabricatedMetalManufac',
        value: 'Fabricated metal product manufacturing'
    },
    333: {
        token: 'machineryManufac',
        value: 'Machinery manufacturing'
    },
    3331: {
        token: 'manufac',
        value: 'Manufacturing'
    },
    334: {
        token: 'computerElectronicManufac',
        value: 'Computer and electronic product manufacturing'
    },
    335: {
        token: 'electricalApplianceManufac',
        value: 'Electrical equipment and appliance mfg.'
    },
    336: {
        token: 'transportEquipManufac',
        value: 'Transportation equipment manufacturing'
    },
    3364: {
        token: 'aerospaceDefense',
        value: 'Aerospace/Defense'
    },
    337: {
        token: 'furnitureManufac',
        value: 'Furniture and related product manufacturing'
    },
    339: {
        token: 'miscManufac',
        value: 'Miscellaneous manufacturing'
    },
    423: {
        token: 'merchantWholesaleDurable',
        value: 'Merchant wholesalers, durable goods'
    },
    424: {
        token: 'merchantWholesaleNondurable',
        value: 'Merchant wholesalers, nondurable goods'
    },
    425: {
        token: 'electronicMarket',
        value: 'Electronic markets and agents and brokers'
    },
    441: {
        token: 'motorVehiclePartsDealers',
        value: 'Motor vehicle and parts dealers'
    },
    442: {
        token: 'furnitureFurnishingStores',
        value: 'Furniture and home furnishings stores'
    },
    443: {
        token: 'electronicApplianceStores',
        value: 'Electronics and appliance stores'
    },
    4431: {
        token: 'electronics',
        value: 'Electronics'
    },
    444: {
        token: 'buildingGardenSupplyStores',
        value: 'Building material and garden supply stores'
    },
    445: {
        token: 'foodBeverageStores',
        value: 'Food and beverage stores'
    },
    4451: {
        token: 'groceryStores',
        value: 'Grocery Stores'
    },
    4453: {
        token: 'beerWineLiquorStores',
        value: 'Beer, Wine, and Liquor Stores'
    },
    446: {
        token: 'healthCareStores',
        value: 'Health and personal care stores'
    },
    447: {
        token: 'gasStations',
        value: 'Gasoline stations'
    },
    448: {
        token: 'clothingAccessoriesStores',
        value: 'Clothing and clothing accessories stores'
    },
    4481: {
        token: 'clothingTextiles',
        value: 'Clothing/Textiles'
    },
    4483: {
        token: 'jewelryFurs',
        value: 'Jewelry & Furs'
    },
    451: {
        token: 'sportsHobbyMusicBookStores',
        value: 'Sports, hobby, music instrument, book stores'
    },
    452: {
        token: 'genMerchandiseStores',
        value: 'General merchandise stores'
    },
    453: {
        token: 'miscStoreRetailers',
        value: 'Miscellaneous store retailers'
    },
    4532: {
        token: 'officeProducts',
        value: 'Office Products'
    },
    4539: {
        token: 'retailSales',
        value: 'Retail Sales'
    },
    454: {
        token: 'nonstoreRetails',
        value: 'Nonstore retailers'
    },
    481: {
        token: 'airTransport',
        value: 'Air transportation'
    },
    4811: {
        token: 'travelRelated',
        value: 'Travel Related (Airlines, Agents, Mass Transit)'
    },
    482: {
        token: 'railTransport',
        value: 'Rail transportation'
    },
    483: {
        token: 'waterTransport',
        value: 'Water transportation'
    },
    484: {
        token: 'truckTransport',
        value: 'Truck transportation'
    },
    485: {
        token: 'transitTransport',
        value: 'Transit and ground passenger transportation'
    },
    486: {
        token: 'pipelineTransport',
        value: 'Pipeline transportation'
    },
    487: {
        token: 'scenicTransport',
        value: 'Scenic and sightseeing transportation'
    },
    488: {
        token: 'supportTransport',
        value: 'Support activities for transportation'
    },
    491: {
        token: 'postalService',
        value: 'Postal service'
    },
    492: {
        token: 'courierMessenger',
        value: 'Couriers and messengers'
    },
    4922: {
        token: 'shippingDelivery',
        value: 'Shipping/Delivery'
    },
    493: {
        token: 'warehousingStorage',
        value: 'Warehousing and storage'
    },
    4931: {
        token: 'warehouseDistrib',
        value: 'Warehouse/Distribution'
    },
    511: {
        token: 'publishingNoInternet',
        value: 'Publishing industries, except Internet'
    },
    5111: {
        token: 'publishing',
        value: 'Publishing'
    },
    512: {
        token: 'motionPicSoundRecordingIndustries',
        value: 'Motion picture and sound recording industries'
    },
    5121: {
        token: 'entertainment',
        value: 'Entertainment (Film, TV, Music, etc.)'
    },
    5141: {
        token: 'infoServicesMarketResearch',
        value: 'Information Services/Market Research'
    },
    515: {
        token: 'broadcastingNoInternet',
        value: 'Broadcasting, except Internet'
    },
    517: {
        token: 'telecom',
        value: 'Telecommunications'
    },
    5170: {
        token: 'tech',
        value: 'Technology'
    },
    518: {
        token: 'dataProcessingHostingServices',
        value: 'Data processing, hosting and related services'
    },
    519: {
        token: 'otherInfoServices',
        value: 'Other information services'
    },
    52: {
        token: 'financeInsurance',
        value: 'Finance and Insurance'
    },
    521: {
        token: 'monetaryAuthorities',
        value: 'Monetary authorities-central bank'
    },
    522: {
        token: 'creditIntermediation',
        value: 'Credit intermediation and related activities'
    },
    5221: {
        token: 'banking',
        value: 'Banking'
    },
    523: {
        token: 'securitiesContractsInvestments',
        value: 'Securities, commodity contracts, investments'
    },
    5239: {
        token: 'financialServicesNoBanking',
        value: 'Financial Services (Non-banking)'
    },
    524: {
        token: 'insuranceCarriersRelated',
        value: 'Insurance carriers and related activities'
    },
    5241: {
        token: 'insurance',
        value: 'Insurance'
    },
    525: {
        token: 'fundsTrustsFinancialVehicles',
        value: 'Funds, trusts, and other financial vehicles'
    },
    531: {
        token: 'realEstate',
        value: 'Real Estate'
    },
    532: {
        token: 'rentalLeasingServices',
        value: 'Rental and leasing services'
    },
    5321: {
        token: 'automotive',
        value: 'Automotive'
    },
    5322: {
        token: 'consumerGoods',
        value: 'Consumer Goods'
    },
    533: {
        token: 'lessorsNonfinancialIntangible',
        value: 'Lessors of nonfinancial intangible assets'
    },
    541: {
        token: 'professionalTechnicalServices',
        value: 'Professional and technical services'
    },
    5411: {
        token: 'legalServices',
        value: 'Legal Services'
    },
    5412: {
        token: 'accounting',
        value: 'Accounting'
    },
    5413: {
        token: 'architectureEngineering',
        value: 'Architecture/Engineering'
    },
    5414: {
        token: 'specializedDesignServices',
        value: 'Specialized Design Services'
    },
    5415: {
        token: 'compRelatedServices',
        value: 'Computer Related Services'
    },
    5416: {
        token: 'mgmtConsulting',
        value: 'Management Consulting'
    },
    5417: {
        token: 'scientificResearch',
        value: 'Scientific Research'
    },
    5418: {
        token: 'adsMarketingPR',
        value: 'Advertising/Marketing/Public Relations'
    },
    5419: {
        token: 'otherProfSciTechServices',
        value: 'Other Professional, Scientific, and Technical Services'
    },
    551: {
        token: 'companyEnterpriseMgmt',
        value: 'Management of companies and enterprises'
    },
    561: {
        token: 'adminSupportServices',
        value: 'Administrative and support services'
    },
    5613: {
        token: 'employmentAgencyRecruiters',
        value: 'Employment Agency/Recruiters'
    },
    5616: {
        token: 'securityPrivateInvestigation',
        value: 'Security/Private Investigation'
    },
    562: {
        token: 'wasteMgmtRemediationServices',
        value: 'Waste management and remediation services'
    },
    611: {
        token: 'educationServices',
        value: 'Educational services'
    },
    6113: {
        token: 'education',
        value: 'Education'
    },
    621: {
        token: 'ambulatoryHealthCareServices',
        value: 'Ambulatory health care services'
    },
    6213: {
        token: 'healthCareRelated',
        value: 'Health Care Related'
    },
    622: {
        token: 'hospitals',
        value: 'Hospitals'
    },
    623: {
        token: 'nursingResidentialCareFacilities',
        value: 'Nursing and residential care facilities'
    },
    624: {
        token: 'socialAssistance',
        value: 'Social assistance'
    },
    711: {
        token: 'performingArtsSpectatorSports',
        value: 'Performing arts and spectator sports'
    },
    712: {
        token: 'museumsHistoricalSitesZoosParks',
        value: 'Museums, historical sites, zoos, and parks'
    },
    7121: {
        token: 'fineArtsGalleriesMuseums',
        value: 'Fine Arts (Galleries, Museums)'
    },
    713: {
        token: 'amusementsGamblingRec',
        value: 'Amusements, gambling, and recreation'
    },
    721: {
        token: 'accommodation',
        value: 'Accommodation'
    },
    722: {
        token: 'foodDrinkingServices',
        value: 'Food services and drinking places'
    },
    7221: {
        token: 'restaurantHotel',
        value: 'Restaurant/Hotel'
    },
    811: {
        token: 'repairMaintenance',
        value: 'Repair and maintenance'
    },
    8113: {
        token: 'industrialProductsHeavy',
        value: 'Industrial Products (Heavy Industry)'
    },
    812: {
        token: 'personalLaundryServices',
        value: 'Personal and laundry services'
    },
    813: {
        token: 'membershipAssocOrgs',
        value: 'Membership associations and organizations'
    },
    8134: {
        token: 'nonprofit',
        value: 'Non-profit'
    },
    814: {
        token: 'privateHouseholds',
        value: 'Private households'
    },
    921: {
        token: 'execLegisGenGvt',
        value: 'Executive, legislative and general government'
    },
    9211: {
        token: 'gvt',
        value: 'Government'
    },
    922: {
        token: 'justicePublicOrderSafetyActivities',
        value: 'Justice, public order, and safety activities'
    },
    923: {
        token: 'hrAdminPrograms',
        value: 'Administration of human resource programs'
    },
    924: {
        token: 'environmentAdminPrograms',
        value: 'Administration of environmental programs'
    },
    9241: {
        token: 'environmental',
        value: 'Environmental'
    },
    925: {
        token: 'communityHousingProgramAdmin',
        value: 'Community and housing program administration'
    },
    926: {
        token: 'econProgramAdmin',
        value: 'Administration of economic programs'
    },
    927: {
        token: 'spaceResearchTech',
        value: 'Space research and technology'
    },
    928: {
        token: 'natlSecurityIntlAffairs',
        value: 'National security and international affairs'
    }
};
function $fe7235eb3e011ca0$var$mapCodeTo(element) {
    const codeElementAssoc = {};
    $f1q41.forEach($fe7235eb3e011ca0$var$industryCodeTokensAndValues, (value, key)=>{
        codeElementAssoc[key] = value[element];
    });
    return codeElementAssoc;
}
// returns { ..., 928: 'natlSecurityIntlAffairs' }
const $fe7235eb3e011ca0$var$industryCodeTokens = $fe7235eb3e011ca0$var$mapCodeTo('token');
// returns { ..., 928: 'National security and international affairs' }
const $fe7235eb3e011ca0$var$industryCodeValues = $fe7235eb3e011ca0$var$mapCodeTo('value');
module.exports = {
    industryCodeTokens: $fe7235eb3e011ca0$var$industryCodeTokens,
    industryCodeValues: $fe7235eb3e011ca0$var$industryCodeValues
};

});

parcelRegister("4ICSb", function(module, exports) {

var $f1q41 = parcelRequire("f1q41");

const $36f96cd4a714b5e2$var$PROFILE_TYPE = (parcelRequire("aB89e")).spacerFree.calculator.PROFILE_TYPE;

const $36f96cd4a714b5e2$var$FLOORPLAN_TYPE = (parcelRequire("aB89e")).spacerFree.profileInfo.FLOORPLAN_TYPE;

var $4MjDQ = parcelRequire("4MjDQ");

var $fTQI0 = parcelRequire("fTQI0");

var $ahytO = parcelRequire("ahytO");
// *************************************
const $36f96cd4a714b5e2$var$profileNameTokens = $4MjDQ.profileNameTokens;
const $36f96cd4a714b5e2$var$profileNameValues = $4MjDQ.profileNameValues;
const $36f96cd4a714b5e2$var$profiles = [
    {
        // 1
        id: 'efficient',
        name: 'Efficient',
        examplePreviewImageNames: {
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_5K]: '/png/example-previews/5000-partial-floor-plan-optimizer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_5K]: '/png/example-previews/5000-floor-plan-optimizer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_10K]: '/png/example-previews/10000-partial-floor-plan-optimizer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_10K]: '/png/example-previews/10000-floor-plan-optimizer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_15K]: '/png/example-previews/15000-partial-floor-plan-optimizer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_15K]: '/png/example-previews/15000-floor-plan-optimizer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_20K]: '/png/example-previews/20000-partial-floor-plan-optimizer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_20K]: '/png/example-previews/20000-floor-plan-optimizer-profile-spacer-by-cbre.png'
        },
        profileHeroImage: '/svg/illustrations/results/profiles/3D-optimizer-office-layout-spacer-by-cbre.svg',
        displayName: $36f96cd4a714b5e2$var$profileNameValues.EFFICIENT,
        displayNameToken: $36f96cd4a714b5e2$var$profileNameTokens.EFFICIENT,
        descriptionToken: 'efficientDesc',
        keyTraitIds: [
            'efficient1',
            'productive1',
            'standardized1',
            'enabled1'
        ],
        kitOfPartsWithMultipliers: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $fTQI0.EFFICIENT.US.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $fTQI0.EFFICIENT.US.SMALL,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $fTQI0.EFFICIENT.UK.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $fTQI0.EFFICIENT.GERMANY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $fTQI0.EFFICIENT.SPAIN.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $fTQI0.EFFICIENT.FRANCE.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $fTQI0.EFFICIENT.APAC.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $fTQI0.EFFICIENT.SLOVAKIA.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $fTQI0.EFFICIENT.POLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $fTQI0.EFFICIENT.HUNGARY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $fTQI0.EFFICIENT.NETHERLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $fTQI0.EFFICIENT.COLOMBIA.REGULAR
        },
        collaborationLevels: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $ahytO.EFFICIENT.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $ahytO.EFFICIENT.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $ahytO.EFFICIENT.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $ahytO.EFFICIENT.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $ahytO.EFFICIENT.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $ahytO.EFFICIENT.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $ahytO.EFFICIENT.APAC,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $ahytO.EFFICIENT.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $ahytO.EFFICIENT.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $ahytO.EFFICIENT.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $ahytO.EFFICIENT.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $ahytO.EFFICIENT.EUROPE
        }
    },
    {
        // 2
        id: 'whiteCollar',
        name: 'White Collar',
        examplePreviewImageNames: {
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_5K]: '/png/example-previews/5000-partial-floor-plan-accommodator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_5K]: '/png/example-previews/5000-floor-plan-accommodator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_10K]: '/png/example-previews/10000-partial-floor-plan-accommodator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_10K]: '/png/example-previews/10000-floor-plan-accommodator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_15K]: '/png/example-previews/15000-partial-floor-plan-accommodator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_15K]: '/png/example-previews/15000-floor-plan-accommodator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_20K]: '/png/example-previews/20000-partial-floor-plan-accommodator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_20K]: '/png/example-previews/20000-floor-plan-accommodator-profile-spacer-by-cbre.png'
        },
        profileHeroImage: '/svg/illustrations/results/profiles/3D-accommodator-office-layout-spacer-by-cbre.svg',
        displayName: $36f96cd4a714b5e2$var$profileNameValues.WHITE_COLLAR,
        displayNameToken: $36f96cd4a714b5e2$var$profileNameTokens.WHITE_COLLAR,
        descriptionToken: 'whiteCollarDesc',
        keyTraitIds: [
            'productive1',
            'efficient2',
            'standardized1',
            'enabled1'
        ],
        kitOfPartsWithMultipliers: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $fTQI0.WHITE_COLLAR.US.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $fTQI0.WHITE_COLLAR.US.SMALL,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $fTQI0.WHITE_COLLAR.UK.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $fTQI0.WHITE_COLLAR.GERMANY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $fTQI0.WHITE_COLLAR.SPAIN.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $fTQI0.WHITE_COLLAR.FRANCE.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $fTQI0.WHITE_COLLAR.APAC.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $fTQI0.WHITE_COLLAR.SLOVAKIA.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $fTQI0.WHITE_COLLAR.POLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $fTQI0.WHITE_COLLAR.HUNGARY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $fTQI0.WHITE_COLLAR.NETHERLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $fTQI0.WHITE_COLLAR.COLOMBIA.REGULAR
        },
        collaborationLevels: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $ahytO.WHITE_COLLAR.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $ahytO.WHITE_COLLAR.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $ahytO.WHITE_COLLAR.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $ahytO.WHITE_COLLAR.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $ahytO.WHITE_COLLAR.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $ahytO.WHITE_COLLAR.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $ahytO.WHITE_COLLAR.APAC,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $ahytO.WHITE_COLLAR.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $ahytO.WHITE_COLLAR.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $ahytO.WHITE_COLLAR.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $ahytO.WHITE_COLLAR.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $ahytO.WHITE_COLLAR.EUROPE
        }
    },
    {
        // 3
        id: 'whiteGlove',
        name: 'White Glove',
        examplePreviewImageNames: {
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_5K]: '/png/example-previews/5000-partial-floor-plan-enhancer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_5K]: '/png/example-previews/5000-floor-plan-enhancer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_10K]: '/png/example-previews/10000-partial-floor-plan-enhancer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_10K]: '/png/example-previews/10000-floor-plan-enhancer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_15K]: '/png/example-previews/15000-partial-floor-plan-enhancer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_15K]: '/png/example-previews/15000-floor-plan-enhancer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_20K]: '/png/example-previews/20000-partial-floor-plan-enhancer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_20K]: '/png/example-previews/20000-floor-plan-enhancer-profile-spacer-by-cbre.png'
        },
        profileHeroImage: '/svg/illustrations/results/profiles/3D-enhancer-office-layout-spacer-by-cbre.svg',
        displayName: $36f96cd4a714b5e2$var$profileNameValues.WHITE_GLOVE,
        displayNameToken: $36f96cd4a714b5e2$var$profileNameTokens.WHITE_GLOVE,
        descriptionToken: 'whiteGloveDesc',
        keyTraitIds: [
            'clientFocused1',
            'standardized2',
            'enabled2',
            'social1'
        ],
        kitOfPartsWithMultipliers: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $fTQI0.WHITE_GLOVE.US.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $fTQI0.WHITE_GLOVE.US.SMALL,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $fTQI0.WHITE_GLOVE.UK.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $fTQI0.WHITE_GLOVE.GERMANY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $fTQI0.WHITE_GLOVE.SPAIN.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $fTQI0.WHITE_GLOVE.FRANCE.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $fTQI0.WHITE_GLOVE.APAC.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $fTQI0.WHITE_GLOVE.SLOVAKIA.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $fTQI0.WHITE_GLOVE.POLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $fTQI0.WHITE_GLOVE.HUNGARY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $fTQI0.WHITE_GLOVE.NETHERLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $fTQI0.WHITE_GLOVE.COLOMBIA.REGULAR
        },
        collaborationLevels: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $ahytO.WHITE_GLOVE.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $ahytO.WHITE_GLOVE.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $ahytO.WHITE_GLOVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $ahytO.WHITE_GLOVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $ahytO.WHITE_GLOVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $ahytO.WHITE_GLOVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $ahytO.WHITE_GLOVE.APAC,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $ahytO.WHITE_GLOVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $ahytO.WHITE_GLOVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $ahytO.WHITE_GLOVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $ahytO.WHITE_GLOVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $ahytO.WHITE_GLOVE.EUROPE
        }
    },
    {
        // 4
        id: 'openOffice',
        name: 'Open Office',
        examplePreviewImageNames: {
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_5K]: '/png/example-previews/5000-partial-floor-plan-producer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_5K]: '/png/example-previews/5000-floor-plan-producer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_10K]: '/png/example-previews/10000-partial-floor-plan-producer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_10K]: '/png/example-previews/10000-floor-plan-producer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_15K]: '/png/example-previews/15000-partial-floor-plan-producer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_15K]: '/png/example-previews/15000-floor-plan-producer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_20K]: '/png/example-previews/20000-partial-floor-plan-producer-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_20K]: '/png/example-previews/20000-floor-plan-producer-profile-spacer-by-cbre.png'
        },
        profileHeroImage: '/svg/illustrations/results/profiles/3D-producer-office-layout-spacer-by-cbre.svg',
        displayName: $36f96cd4a714b5e2$var$profileNameValues.OPEN_OFFICE,
        displayNameToken: $36f96cd4a714b5e2$var$profileNameTokens.OPEN_OFFICE,
        descriptionToken: 'openOfficeDesc',
        keyTraitIds: [
            'productive2',
            'standardized3',
            'enabled3',
            'inclusive1'
        ],
        kitOfPartsWithMultipliers: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $fTQI0.OPEN_OFFICE.US.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $fTQI0.OPEN_OFFICE.US.SMALL,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $fTQI0.OPEN_OFFICE.UK.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $fTQI0.OPEN_OFFICE.GERMANY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $fTQI0.OPEN_OFFICE.SPAIN.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $fTQI0.OPEN_OFFICE.FRANCE.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $fTQI0.OPEN_OFFICE.APAC.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $fTQI0.OPEN_OFFICE.SLOVAKIA.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $fTQI0.OPEN_OFFICE.POLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $fTQI0.OPEN_OFFICE.HUNGARY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $fTQI0.OPEN_OFFICE.NETHERLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $fTQI0.WHITE_GLOVE.COLOMBIA.REGULAR
        },
        collaborationLevels: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $ahytO.OPEN_OFFICE.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $ahytO.OPEN_OFFICE.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $ahytO.OPEN_OFFICE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $ahytO.OPEN_OFFICE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $ahytO.OPEN_OFFICE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $ahytO.OPEN_OFFICE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $ahytO.OPEN_OFFICE.APAC,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $ahytO.OPEN_OFFICE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $ahytO.OPEN_OFFICE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $ahytO.OPEN_OFFICE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $ahytO.OPEN_OFFICE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $ahytO.OPEN_OFFICE.EUROPE
        }
    },
    {
        // 5
        id: 'workplace360',
        name: 'Workplace 360',
        examplePreviewImageNames: {
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_5K]: '/png/example-previews/5000-partial-floor-plan-connector-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_5K]: '/png/example-previews/5000-floor-plan-connector-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_10K]: '/png/example-previews/10000-partial-floor-plan-connector-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_10K]: '/png/example-previews/10000-floor-plan-connector-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_15K]: '/png/example-previews/15000-partial-floor-plan-connector-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_15K]: '/png/example-previews/15000-floor-plan-connector-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_20K]: '/png/example-previews/20000-partial-floor-plan-connector-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_20K]: '/png/example-previews/20000-floor-plan-connector-profile-spacer-by-cbre.png'
        },
        profileHeroImage: '/svg/illustrations/results/profiles/3D-connector-office-layout-spacer-by-cbre.svg',
        displayName: $36f96cd4a714b5e2$var$profileNameValues.WORKPLACE_360,
        displayNameToken: $36f96cd4a714b5e2$var$profileNameTokens.WORKPLACE_360,
        descriptionToken: 'workplace360Desc',
        keyTraitIds: [
            'productive1',
            'inclusive1',
            'flexible1',
            'clientFocused2'
        ],
        kitOfPartsWithMultipliers: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $fTQI0.WORKPLACE_360.US.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $fTQI0.WORKPLACE_360.US.SMALL,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $fTQI0.WORKPLACE_360.UK.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $fTQI0.WORKPLACE_360.GERMANY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $fTQI0.WORKPLACE_360.SPAIN.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $fTQI0.WORKPLACE_360.FRANCE.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $fTQI0.WORKPLACE_360.APAC.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $fTQI0.WORKPLACE_360.SLOVAKIA.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $fTQI0.WORKPLACE_360.POLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $fTQI0.WORKPLACE_360.HUNGARY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $fTQI0.WORKPLACE_360.NETHERLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $fTQI0.WORKPLACE_360.COLOMBIA.REGULAR
        },
        collaborationLevels: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $ahytO.WORKPLACE_360.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $ahytO.WORKPLACE_360.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $ahytO.WORKPLACE_360.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $ahytO.WORKPLACE_360.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $ahytO.WORKPLACE_360.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $ahytO.WORKPLACE_360.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $ahytO.WORKPLACE_360.APAC,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $ahytO.WORKPLACE_360.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $ahytO.WORKPLACE_360.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $ahytO.WORKPLACE_360.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $ahytO.WORKPLACE_360.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $ahytO.WORKPLACE_360.EUROPE
        }
    },
    {
        // 6
        id: 'campus',
        name: 'Campus',
        examplePreviewImageNames: {
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_5K]: '/png/example-previews/5000-partial-floor-plan-differentiator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_5K]: '/png/example-previews/5000-floor-plan-differentiator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_10K]: '/png/example-previews/10000-partial-floor-plan-differentiator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_10K]: '/png/example-previews/10000-floor-plan-differentiator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_15K]: '/png/example-previews/15000-partial-floor-plan-differentiator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_15K]: '/png/example-previews/15000-floor-plan-differentiator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_20K]: '/png/example-previews/20000-partial-floor-plan-differentiator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_20K]: '/png/example-previews/20000-floor-plan-differentiator-profile-spacer-by-cbre.png'
        },
        profileHeroImage: '/svg/illustrations/results/profiles/3D-differentiator-office-layout-spacer-by-cbre.svg',
        displayName: $36f96cd4a714b5e2$var$profileNameValues.CAMPUS,
        displayNameToken: $36f96cd4a714b5e2$var$profileNameTokens.CAMPUS,
        descriptionToken: 'campusDesc',
        keyTraitIds: [
            'inclusive2',
            'social2',
            'clientFocused3',
            'flexible2'
        ],
        kitOfPartsWithMultipliers: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $fTQI0.CAMPUS.US.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $fTQI0.CAMPUS.US.SMALL,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $fTQI0.CAMPUS.UK.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $fTQI0.CAMPUS.GERMANY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $fTQI0.CAMPUS.SPAIN.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $fTQI0.CAMPUS.FRANCE.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $fTQI0.CAMPUS.APAC.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $fTQI0.CAMPUS.SLOVAKIA.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $fTQI0.CAMPUS.POLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $fTQI0.CAMPUS.HUNGARY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $fTQI0.CAMPUS.NETHERLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $fTQI0.CAMPUS.COLOMBIA.REGULAR
        },
        collaborationLevels: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $ahytO.CAMPUS.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $ahytO.CAMPUS.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $ahytO.CAMPUS.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $ahytO.CAMPUS.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $ahytO.CAMPUS.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $ahytO.CAMPUS.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $ahytO.CAMPUS.APAC,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $ahytO.CAMPUS.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $ahytO.CAMPUS.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $ahytO.CAMPUS.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $ahytO.CAMPUS.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $ahytO.CAMPUS.EUROPE
        }
    },
    {
        // 7
        id: 'startup',
        name: 'Startup',
        examplePreviewImageNames: {
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_5K]: '/png/example-previews/5000-partial-floor-plan-incubator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_5K]: '/png/example-previews/5000-floor-plan-incubator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_10K]: '/png/example-previews/10000-partial-floor-plan-incubator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_10K]: '/png/example-previews/10000-floor-plan-incubator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_15K]: '/png/example-previews/15000-partial-floor-plan-incubator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_15K]: '/png/example-previews/15000-floor-plan-incubator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_20K]: '/png/example-previews/20000-partial-floor-plan-incubator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_20K]: '/png/example-previews/20000-floor-plan-incubator-profile-spacer-by-cbre.png'
        },
        profileHeroImage: '/svg/illustrations/results/profiles/3D-incubator-office-layout-spacer-by-cbre.svg',
        displayName: $36f96cd4a714b5e2$var$profileNameValues.STARTUP,
        displayNameToken: $36f96cd4a714b5e2$var$profileNameTokens.STARTUP,
        descriptionToken: 'startupDesc',
        keyTraitIds: [
            'social3',
            'inclusive3',
            'flexible3',
            'enabled4'
        ],
        kitOfPartsWithMultipliers: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $fTQI0.STARTUP.US.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $fTQI0.STARTUP.US.SMALL,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $fTQI0.STARTUP.UK.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $fTQI0.STARTUP.GERMANY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $fTQI0.STARTUP.SPAIN.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $fTQI0.STARTUP.FRANCE.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $fTQI0.STARTUP.APAC.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $fTQI0.STARTUP.SLOVAKIA.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $fTQI0.STARTUP.POLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $fTQI0.STARTUP.HUNGARY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $fTQI0.STARTUP.NETHERLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $fTQI0.STARTUP.COLOMBIA.REGULAR
        },
        collaborationLevels: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $ahytO.STARTUP.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $ahytO.STARTUP.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $ahytO.STARTUP.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $ahytO.STARTUP.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $ahytO.STARTUP.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $ahytO.STARTUP.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $ahytO.STARTUP.APAC,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $ahytO.STARTUP.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $ahytO.STARTUP.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $ahytO.STARTUP.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $ahytO.STARTUP.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $ahytO.STARTUP.EUROPE
        }
    },
    {
        // 8
        id: 'engCreative',
        name: 'Engineering/Creative',
        examplePreviewImageNames: {
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_5K]: '/png/example-previews/5000-partial-floor-plan-creator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_5K]: '/png/example-previews/5000-floor-plan-creator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_10K]: '/png/example-previews/10000-partial-floor-plan-creator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_10K]: '/png/example-previews/10000-floor-plan-creator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_15K]: '/png/example-previews/15000-partial-floor-plan-creator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_15K]: '/png/example-previews/15000-floor-plan-creator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.PARTIAL_20K]: '/png/example-previews/20000-partial-floor-plan-creator-profile-spacer-by-cbre.png',
            [$36f96cd4a714b5e2$var$FLOORPLAN_TYPE.FULL_20K]: '/png/example-previews/20000-floor-plan-creator-profile-spacer-by-cbre.png'
        },
        profileHeroImage: '/svg/illustrations/results/profiles/3D-creator-office-layout-spacer-by-cbre.svg',
        displayName: $36f96cd4a714b5e2$var$profileNameValues.ENG_CREATIVE,
        displayNameToken: $36f96cd4a714b5e2$var$profileNameTokens.ENG_CREATIVE,
        descriptionToken: 'engCreativeDesc',
        keyTraitIds: [
            'enabled5',
            'standardized4',
            'productive3',
            'social4'
        ],
        kitOfPartsWithMultipliers: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $fTQI0.ENG_CREATIVE.US.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $fTQI0.ENG_CREATIVE.US.SMALL,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $fTQI0.ENG_CREATIVE.UK.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $fTQI0.ENG_CREATIVE.GERMANY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $fTQI0.ENG_CREATIVE.SPAIN.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $fTQI0.ENG_CREATIVE.FRANCE.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $fTQI0.ENG_CREATIVE.APAC.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $fTQI0.ENG_CREATIVE.SLOVAKIA.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $fTQI0.ENG_CREATIVE.POLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $fTQI0.ENG_CREATIVE.HUNGARY.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $fTQI0.ENG_CREATIVE.NETHERLAND.REGULAR,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $fTQI0.ENG_CREATIVE.COLOMBIA.REGULAR
        },
        collaborationLevels: {
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_REGULAR]: $ahytO.ENG_CREATIVE.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.US_SMALL]: $ahytO.ENG_CREATIVE.US,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.UK_REGULAR]: $ahytO.ENG_CREATIVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.GERMANY_REGULAR]: $ahytO.ENG_CREATIVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SPAIN_REGULAR]: $ahytO.ENG_CREATIVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.FRANCE_REGULAR]: $ahytO.ENG_CREATIVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.APAC_REGULAR]: $ahytO.ENG_CREATIVE.APAC,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.SLOVAKIA_REGULAR]: $ahytO.ENG_CREATIVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.POLAND_REGULAR]: $ahytO.ENG_CREATIVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.HUNGARY_REGULAR]: $ahytO.ENG_CREATIVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.NETHERLAND_REGULAR]: $ahytO.ENG_CREATIVE.EUROPE,
            [$36f96cd4a714b5e2$var$PROFILE_TYPE.COLOMBIA_REGULAR]: $ahytO.ENG_CREATIVE.EUROPE
        }
    }
];
module.exports = $f1q41.keyBy($36f96cd4a714b5e2$var$profiles, 'id');

});
parcelRegister("4MjDQ", function(module, exports) {

var $f1q41 = parcelRequire("f1q41");
const $37aae1911485ef47$var$profileNameTokensAndValues = {
    EFFICIENT: {
        token: 'efficientName',
        value: 'The Optimizer',
        id: 'efficient'
    },
    WHITE_COLLAR: {
        token: 'whiteCollarName',
        value: 'The Accommodator',
        id: 'whiteCollar'
    },
    WHITE_GLOVE: {
        token: 'whiteGloveName',
        value: 'The Enhancer',
        id: 'whiteGlove'
    },
    OPEN_OFFICE: {
        token: 'openOfficeName',
        value: 'The Producer',
        id: 'openOffice'
    },
    WORKPLACE_360: {
        token: 'workplace360Name',
        value: 'The Connector',
        id: 'workplace360'
    },
    CAMPUS: {
        token: 'campusName',
        value: 'The Differentiator',
        id: 'campus'
    },
    STARTUP: {
        token: 'startupName',
        value: 'The Incubator',
        id: 'startup'
    },
    ENG_CREATIVE: {
        token: 'engCreativeName',
        value: 'The Creator',
        id: 'engCreative'
    }
};
// generic helper function
function $37aae1911485ef47$var$mapNameTo(element) {
    const nameElementAssoc = {};
    $f1q41.forEach($37aae1911485ef47$var$profileNameTokensAndValues, (profileNameObj, profileName)=>{
        nameElementAssoc[profileName] = profileNameObj[element];
    });
    return nameElementAssoc;
}
// returns { EFFICIENT: { 'efficientName' }, ... }
const $37aae1911485ef47$var$profileNameTokens = $37aae1911485ef47$var$mapNameTo('token');
// returns { EFFICIENT: { 'The Optimizer' }, ... }
const $37aae1911485ef47$var$profileNameValues = $37aae1911485ef47$var$mapNameTo('value');
// returns { EFFICIENT: { 'efficient' }, ... }
const $37aae1911485ef47$var$profileNameIds = $37aae1911485ef47$var$mapNameTo('id');
module.exports = {
    profileNameTokens: $37aae1911485ef47$var$profileNameTokens,
    profileNameValues: $37aae1911485ef47$var$profileNameValues,
    profileNameIds: $37aae1911485ef47$var$profileNameIds
};

});

parcelRegister("fTQI0", function(module, exports) {

const { CATEGORY: $b934e0f01196aba3$var$CATEGORY } = (parcelRequire("aB89e")).shared.spaceUnit;
module.exports = {
    EFFICIENT: {
        // OPTIMIZER
        US: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "3",
                        multiplier: 0.88
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SHARED_FOCUS]: [
                    {
                        spaceUnitId: "205",
                        multiplier: 25
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.27
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "11",
                        multiplier: 0.07
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    },
                    {
                        spaceUnitId: "30",
                        multiplier: 1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "25",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "27",
                        multiplier: 3.15
                    },
                    {
                        spaceUnitId: "28",
                        multiplier: 2
                    },
                    {
                        spaceUnitId: "36",
                        multiplier: 0.78
                    },
                    {
                        spaceUnitId: "37",
                        multiplier: 1.4
                    }
                ]
            },
            SMALL: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "3",
                        multiplier: 0.88
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.27
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "11",
                        multiplier: 0.07
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "28",
                        multiplier: 2
                    }
                ]
            }
        },
        UK: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "38",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "40",
                        multiplier: 0.88
                    },
                    {
                        spaceUnitId: "42",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "43",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "44",
                        multiplier: 0.27
                    },
                    {
                        spaceUnitId: "45",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "46",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "47",
                        multiplier: 0.07
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "57",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "58",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "59",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "60",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "61",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "50",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "51",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "52",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "53",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "54",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "55",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "56",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "62"
                    },
                    {
                        spaceUnitId: "63"
                    },
                    {
                        spaceUnitId: "64"
                    },
                    {
                        spaceUnitId: "65"
                    },
                    {
                        spaceUnitId: "66"
                    },
                    {
                        spaceUnitId: "67"
                    },
                    {
                        spaceUnitId: "68"
                    }
                ]
            }
        },
        GERMANY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "70",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "72",
                        multiplier: 0.88
                    },
                    {
                        spaceUnitId: "74",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "75",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "76",
                        multiplier: 0.27
                    },
                    {
                        spaceUnitId: "77",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "78",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "79",
                        multiplier: 0.07
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "82",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "83",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "84",
                        multiplier: 0.89
                    },
                    {
                        spaceUnitId: "85",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "86",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "87",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "88",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "89",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "90",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "91",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "92",
                        multiplier: 1.61
                    },
                    {
                        spaceUnitId: "93",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "94"
                    },
                    {
                        spaceUnitId: "95"
                    },
                    {
                        spaceUnitId: "96"
                    },
                    {
                        spaceUnitId: "97"
                    },
                    {
                        spaceUnitId: "98"
                    },
                    {
                        spaceUnitId: "99"
                    },
                    {
                        spaceUnitId: "100"
                    }
                ]
            }
        },
        SPAIN: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "148",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "150",
                        multiplier: 0.88
                    },
                    {
                        spaceUnitId: "152",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "153",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "154",
                        multiplier: 0.27
                    },
                    {
                        spaceUnitId: "155",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "156",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "157",
                        multiplier: 0.07
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "160",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "161",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "162",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "163",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "164",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "165",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "166",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "167",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "168",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "169",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "170",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "171"
                    },
                    {
                        spaceUnitId: "172"
                    },
                    {
                        spaceUnitId: "173"
                    },
                    {
                        spaceUnitId: "174"
                    },
                    {
                        spaceUnitId: "175"
                    }
                ]
            }
        },
        FRANCE: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "176",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "178",
                        multiplier: 0.88
                    },
                    {
                        spaceUnitId: "180",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "181",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "182",
                        multiplier: 0.27
                    },
                    {
                        spaceUnitId: "183",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "184",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "185",
                        multiplier: 0.07
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "188",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "189",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "190",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "191",
                        multiplier: 0.33
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "192",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "193",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "194",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "195",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "196",
                        multiplier: 1.31
                    },
                    {
                        spaceUnitId: "197",
                        multiplier: 0.57
                    },
                    {
                        spaceUnitId: "198"
                    },
                    {
                        spaceUnitId: "199"
                    },
                    {
                        spaceUnitId: "200"
                    },
                    {
                        spaceUnitId: "201"
                    },
                    {
                        spaceUnitId: "202"
                    },
                    {
                        spaceUnitId: "203"
                    },
                    {
                        spaceUnitId: "204"
                    }
                ]
            }
        },
        APAC: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "101",
                        multiplier: 0.01
                    },
                    {
                        spaceUnitId: "103",
                        multiplier: 0.99
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "107",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "108",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "109",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "111",
                        multiplier: 0.18
                    },
                    {
                        spaceUnitId: "112",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "113",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "114",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "115",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "131",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "132",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "133",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "134",
                        multiplier: 0.35
                    },
                    {
                        spaceUnitId: "135",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "124",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "125",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "126",
                        multiplier: 0.35
                    },
                    {
                        spaceUnitId: "136",
                        multiplier: 2
                    },
                    {
                        spaceUnitId: "128",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "137",
                        multiplier: 0.35
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "139",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "140",
                        multiplier: 1.7
                    },
                    {
                        spaceUnitId: "142",
                        multiplier: 3.5
                    },
                    {
                        spaceUnitId: "143",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "144",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "147",
                        multiplier: 1.4
                    }
                ]
            }
        },
        SLOVAKIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "206",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "208",
                        multiplier: 0.88
                    },
                    {
                        spaceUnitId: "210",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "211",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "212",
                        multiplier: 0.27
                    },
                    {
                        spaceUnitId: "213",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "214",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "215",
                        multiplier: 0.07
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "225",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "226",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "227",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "228",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "229",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "218",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "219",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "220",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "221",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "222",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "223",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "224",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "230"
                    },
                    {
                        spaceUnitId: "231"
                    },
                    {
                        spaceUnitId: "232"
                    },
                    {
                        spaceUnitId: "233"
                    },
                    {
                        spaceUnitId: "234"
                    },
                    {
                        spaceUnitId: "235"
                    },
                    {
                        spaceUnitId: "236"
                    }
                ]
            }
        },
        POLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "238",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "240",
                        multiplier: 0.88
                    },
                    {
                        spaceUnitId: "242",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "243",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "244",
                        multiplier: 0.27
                    },
                    {
                        spaceUnitId: "245",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "246",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "247",
                        multiplier: 0.07
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "257",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "258",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "259",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "260",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "261",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "250",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "251",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "252",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "253",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "254",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "255",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "256",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "262"
                    },
                    {
                        spaceUnitId: "263"
                    },
                    {
                        spaceUnitId: "264"
                    },
                    {
                        spaceUnitId: "265"
                    },
                    {
                        spaceUnitId: "266"
                    },
                    {
                        spaceUnitId: "267"
                    },
                    {
                        spaceUnitId: "268"
                    }
                ]
            }
        },
        HUNGARY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "270",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "272",
                        multiplier: 0.88
                    },
                    {
                        spaceUnitId: "274",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "275",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "276",
                        multiplier: 0.27
                    },
                    {
                        spaceUnitId: "277",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "278",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "279",
                        multiplier: 0.07
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "289",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "290",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "291",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "292",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "293",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "282",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "283",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "284",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "285",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "286",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "287",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "288",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "294"
                    },
                    {
                        spaceUnitId: "295"
                    },
                    {
                        spaceUnitId: "296"
                    },
                    {
                        spaceUnitId: "297"
                    },
                    {
                        spaceUnitId: "298"
                    },
                    {
                        spaceUnitId: "299"
                    },
                    {
                        spaceUnitId: "300"
                    }
                ]
            }
        },
        NETHERLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "334",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "336",
                        multiplier: 0.88
                    },
                    {
                        spaceUnitId: "338",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "339",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "340",
                        multiplier: 0.27
                    },
                    {
                        spaceUnitId: "341",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "342",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "343",
                        multiplier: 0.07
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "355",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "356",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "357",
                        multiplier: 0.5
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "353",
                        multiplier: 1.62
                    },
                    {
                        spaceUnitId: "354",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "346",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "347",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "348",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "349",
                        multiplier: 14.267
                    },
                    {
                        spaceUnitId: "350",
                        multiplier: 1.07
                    },
                    {
                        spaceUnitId: "351",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "352",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "358"
                    },
                    {
                        spaceUnitId: "359"
                    },
                    {
                        spaceUnitId: "360"
                    },
                    {
                        spaceUnitId: "361"
                    },
                    {
                        spaceUnitId: "362"
                    },
                    {
                        spaceUnitId: "363"
                    },
                    {
                        spaceUnitId: "364"
                    }
                ]
            }
        },
        COLOMBIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "302",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "304",
                        multiplier: 0.88
                    },
                    {
                        spaceUnitId: "306",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "307",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "308",
                        multiplier: 0.27
                    },
                    {
                        spaceUnitId: "309",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "310",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "311",
                        multiplier: 0.07
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "321",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "322",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "323",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "324",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "325",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "314",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "315",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "316",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "317",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "318",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "319",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "320",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "326"
                    },
                    {
                        spaceUnitId: "327"
                    },
                    {
                        spaceUnitId: "328"
                    },
                    {
                        spaceUnitId: "329"
                    },
                    {
                        spaceUnitId: "330"
                    },
                    {
                        spaceUnitId: "331"
                    },
                    {
                        spaceUnitId: "332"
                    },
                    {
                        spaceUnitId: "333",
                        multiplier: 12.18
                    }
                ]
            }
        }
    },
    WHITE_COLLAR: {
        // ACCOMODATOR
        US: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "2",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "4",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SHARED_FOCUS]: [
                    {
                        spaceUnitId: "205",
                        multiplier: 20
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "11",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "12",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "13",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "14",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "20",
                        multiplier: 1.5
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    },
                    {
                        spaceUnitId: "30",
                        multiplier: 1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "25",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "26",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "27",
                        multiplier: 3.15
                    },
                    {
                        spaceUnitId: "28",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "33",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "36",
                        multiplier: 0.78
                    },
                    {
                        spaceUnitId: "37",
                        multiplier: 1.4
                    }
                ]
            },
            SMALL: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "2",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "4",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.31
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.36
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.16
                    },
                    {
                        spaceUnitId: "12",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "13",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "14",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "20",
                        multiplier: 1.5
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "28",
                        multiplier: 2.5
                    }
                ]
            }
        },
        UK: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "38",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "39",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "41",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "42",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "43",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "44",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "45",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "46",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "47",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "48",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "49",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "57",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "58",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "59",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "60",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "61",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "50",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "51",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "52",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "53",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "54",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "55",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "56",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "62"
                    },
                    {
                        spaceUnitId: "63"
                    },
                    {
                        spaceUnitId: "64"
                    },
                    {
                        spaceUnitId: "65"
                    },
                    {
                        spaceUnitId: "66"
                    },
                    {
                        spaceUnitId: "67"
                    },
                    {
                        spaceUnitId: "68"
                    }
                ]
            }
        },
        GERMANY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "70",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "71",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "73",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "74",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "75",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "76",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "77",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "78",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "79",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "80",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "81",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "82",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "83",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "84",
                        multiplier: 0.89
                    },
                    {
                        spaceUnitId: "85",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "86",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "87",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "88",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "89",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "90",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "91",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "92",
                        multiplier: 1.61
                    },
                    {
                        spaceUnitId: "93",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "94"
                    },
                    {
                        spaceUnitId: "95"
                    },
                    {
                        spaceUnitId: "96"
                    },
                    {
                        spaceUnitId: "97"
                    },
                    {
                        spaceUnitId: "98"
                    },
                    {
                        spaceUnitId: "99"
                    },
                    {
                        spaceUnitId: "100"
                    }
                ]
            }
        },
        SPAIN: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "148",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "149",
                        multiplier: 0.01
                    },
                    {
                        spaceUnitId: "151",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "152",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "153",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "154",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "155",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "156",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "157",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "158",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "159",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "160",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "161",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "162",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "163",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "164",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "165",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "166",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "167",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "168",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "169",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "170",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "171"
                    },
                    {
                        spaceUnitId: "172"
                    },
                    {
                        spaceUnitId: "173"
                    },
                    {
                        spaceUnitId: "174"
                    },
                    {
                        spaceUnitId: "175"
                    }
                ]
            }
        },
        FRANCE: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "176",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "177",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "179",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "180",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "181",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "182",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "183",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "184",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "185",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "186",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "187",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "188",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "189",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "190",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "191",
                        multiplier: 0.33
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "192",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "193",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "194",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "195",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "196",
                        multiplier: 1.31
                    },
                    {
                        spaceUnitId: "197",
                        multiplier: 0.57
                    },
                    {
                        spaceUnitId: "198"
                    },
                    {
                        spaceUnitId: "199"
                    },
                    {
                        spaceUnitId: "200"
                    },
                    {
                        spaceUnitId: "201"
                    },
                    {
                        spaceUnitId: "202"
                    },
                    {
                        spaceUnitId: "203"
                    },
                    {
                        spaceUnitId: "204"
                    }
                ]
            }
        },
        APAC: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "101",
                        multiplier: 0.01
                    },
                    {
                        spaceUnitId: "102",
                        multiplier: 0.01
                    },
                    {
                        spaceUnitId: "104",
                        multiplier: 0.98
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "107",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "108",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "109",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "111",
                        multiplier: 0.09
                    },
                    {
                        spaceUnitId: "112",
                        multiplier: 0.12
                    },
                    {
                        spaceUnitId: "113",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "114",
                        multiplier: 0.16
                    },
                    {
                        spaceUnitId: "115",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "131",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "132",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "133",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "134",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "135",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "124",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "125",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "126",
                        multiplier: 0.75
                    },
                    {
                        spaceUnitId: "136",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "128",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "137",
                        multiplier: 0.35
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "139",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "140",
                        multiplier: 1.7
                    },
                    {
                        spaceUnitId: "142",
                        multiplier: 4.5
                    },
                    {
                        spaceUnitId: "143",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "144",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "147",
                        multiplier: 1.4
                    }
                ]
            }
        },
        SLOVAKIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "206",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "207",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "209",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "210",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "211",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "212",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "213",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "214",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "215",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "216",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "217",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "225",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "226",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "227",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "228",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "229",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "218",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "219",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "220",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "221",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "222",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "223",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "224",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "230"
                    },
                    {
                        spaceUnitId: "231"
                    },
                    {
                        spaceUnitId: "232"
                    },
                    {
                        spaceUnitId: "233"
                    },
                    {
                        spaceUnitId: "234"
                    },
                    {
                        spaceUnitId: "235"
                    },
                    {
                        spaceUnitId: "236"
                    }
                ]
            }
        },
        POLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "238",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "239",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "241",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "242",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "243",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "244",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "245",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "246",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "247",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "248",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "249",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "257",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "258",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "259",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "260",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "261",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "250",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "251",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "252",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "253",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "254",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "255",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "256",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "262"
                    },
                    {
                        spaceUnitId: "263"
                    },
                    {
                        spaceUnitId: "264"
                    },
                    {
                        spaceUnitId: "265"
                    },
                    {
                        spaceUnitId: "266"
                    },
                    {
                        spaceUnitId: "267"
                    },
                    {
                        spaceUnitId: "268"
                    }
                ]
            }
        },
        HUNGARY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "270",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "271",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "273",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "274",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "275",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "276",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "277",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "278",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "279",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "280",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "281",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "289",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "290",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "291",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "292",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "293",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "282",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "283",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "284",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "285",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "286",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "287",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "288",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "294"
                    },
                    {
                        spaceUnitId: "295"
                    },
                    {
                        spaceUnitId: "296"
                    },
                    {
                        spaceUnitId: "297"
                    },
                    {
                        spaceUnitId: "298"
                    },
                    {
                        spaceUnitId: "299"
                    },
                    {
                        spaceUnitId: "300"
                    }
                ]
            }
        },
        NETHERLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "334",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "335",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "337",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "338",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "339",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "340",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "341",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "342",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "343",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "344",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "345",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "355",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "356",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "357",
                        multiplier: 0.5
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "353",
                        multiplier: 1.62
                    },
                    {
                        spaceUnitId: "354",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "346",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "347",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "348",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "349",
                        multiplier: 14.267
                    },
                    {
                        spaceUnitId: "350",
                        multiplier: 1.07
                    },
                    {
                        spaceUnitId: "351",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "352",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "358"
                    },
                    {
                        spaceUnitId: "359"
                    },
                    {
                        spaceUnitId: "360"
                    },
                    {
                        spaceUnitId: "361"
                    },
                    {
                        spaceUnitId: "362"
                    },
                    {
                        spaceUnitId: "363"
                    },
                    {
                        spaceUnitId: "364"
                    }
                ]
            }
        },
        COLOMBIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "302",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "303",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "305",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "306",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "307",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "308",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "309",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "310",
                        multiplier: 0.26
                    },
                    {
                        spaceUnitId: "311",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "312",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "313",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "321",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "322",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "323",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "324",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "325",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "314",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "315",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "316",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "317",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "318",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "319",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "320",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "326"
                    },
                    {
                        spaceUnitId: "327"
                    },
                    {
                        spaceUnitId: "328"
                    },
                    {
                        spaceUnitId: "329"
                    },
                    {
                        spaceUnitId: "330"
                    },
                    {
                        spaceUnitId: "331"
                    },
                    {
                        spaceUnitId: "332"
                    },
                    {
                        spaceUnitId: "333",
                        multiplier: 12.18
                    }
                ]
            }
        }
    },
    WHITE_GLOVE: {
        // ENHANCER
        US: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "2",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "4",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SHARED_FOCUS]: [
                    {
                        spaceUnitId: "205",
                        multiplier: 20
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "11",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "12",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "13",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "14",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "20",
                        multiplier: 1.5
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    },
                    {
                        spaceUnitId: "30",
                        multiplier: 1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "25",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "26",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "27",
                        multiplier: 4.5
                    },
                    {
                        spaceUnitId: "28",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "29",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "69",
                        multiplier: 12.18
                    },
                    {
                        spaceUnitId: "37",
                        multiplier: 1.4
                    }
                ]
            },
            SMALL: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "2",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "4",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.35
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "12",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "13",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "14",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "20",
                        multiplier: 1.5
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "25",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "28",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "29",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "33",
                        multiplier: 1
                    }
                ]
            }
        },
        UK: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "38",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "39",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "41",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "42",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "43",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "44",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "45",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "46",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "47",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "48",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "49",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "57",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "58",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "59",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "60",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "61",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "50",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "51",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "52",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "53",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "54",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "55",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "56",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "62"
                    },
                    {
                        spaceUnitId: "63"
                    },
                    {
                        spaceUnitId: "64"
                    },
                    {
                        spaceUnitId: "65"
                    },
                    {
                        spaceUnitId: "66"
                    },
                    {
                        spaceUnitId: "67"
                    },
                    {
                        spaceUnitId: "68"
                    }
                ]
            }
        },
        GERMANY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "70",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "71",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "73",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "74",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "75",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "76",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "77",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "78",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "79",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "80",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "81",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "82",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "83",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "84",
                        multiplier: 0.89
                    },
                    {
                        spaceUnitId: "85",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "86",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "87",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "88",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "89",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "90",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "91",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "92",
                        multiplier: 1.61
                    },
                    {
                        spaceUnitId: "93",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "94"
                    },
                    {
                        spaceUnitId: "95"
                    },
                    {
                        spaceUnitId: "96"
                    },
                    {
                        spaceUnitId: "97"
                    },
                    {
                        spaceUnitId: "98"
                    },
                    {
                        spaceUnitId: "99"
                    },
                    {
                        spaceUnitId: "100"
                    }
                ]
            }
        },
        SPAIN: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "148",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "149",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "151",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "152",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "153",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "154",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "155",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "156",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "157",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "158",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "159",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "160",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "161",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "162",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "163",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "164",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "165",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "166",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "167",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "168",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "169",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "170",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "171"
                    },
                    {
                        spaceUnitId: "172"
                    },
                    {
                        spaceUnitId: "173"
                    },
                    {
                        spaceUnitId: "174"
                    },
                    {
                        spaceUnitId: "175"
                    }
                ]
            }
        },
        FRANCE: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "176",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "177",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "179",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "180",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "181",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "182",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "183",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "184",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "185",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "186",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "187",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "188",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "189",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "190",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "191",
                        multiplier: 0.33
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "192",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "193",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "194",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "195",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "196",
                        multiplier: 1.31
                    },
                    {
                        spaceUnitId: "197",
                        multiplier: 0.57
                    },
                    {
                        spaceUnitId: "198"
                    },
                    {
                        spaceUnitId: "199"
                    },
                    {
                        spaceUnitId: "200"
                    },
                    {
                        spaceUnitId: "201"
                    },
                    {
                        spaceUnitId: "202"
                    },
                    {
                        spaceUnitId: "203"
                    },
                    {
                        spaceUnitId: "204"
                    }
                ]
            }
        },
        APAC: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "101",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "102",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "104",
                        multiplier: 0.75
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "107",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "108",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "109",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "110",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "111",
                        multiplier: 0.11
                    },
                    {
                        spaceUnitId: "112",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "113",
                        multiplier: 0.16
                    },
                    {
                        spaceUnitId: "114",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "115",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "131",
                        multiplier: 0.07
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "132",
                        multiplier: 2
                    },
                    {
                        spaceUnitId: "133",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "134",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "135",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "124",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "125",
                        multiplier: 0.6
                    },
                    {
                        spaceUnitId: "126",
                        multiplier: 1.5
                    },
                    {
                        spaceUnitId: "136",
                        multiplier: 6
                    },
                    {
                        spaceUnitId: "128",
                        multiplier: 1.5
                    },
                    {
                        spaceUnitId: "137",
                        multiplier: 0.35
                    },
                    {
                        spaceUnitId: "138",
                        multiplier: 1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "139",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "141",
                        multiplier: 3.5
                    },
                    {
                        spaceUnitId: "142",
                        multiplier: 6
                    },
                    {
                        spaceUnitId: "143",
                        multiplier: 5
                    },
                    {
                        spaceUnitId: "144",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "145",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "146",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "147",
                        multiplier: 1.4
                    }
                ]
            }
        },
        SLOVAKIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "206",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "207",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "209",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "210",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "211",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "212",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "213",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "214",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "215",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "216",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "217",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "225",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "226",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "227",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "228",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "229",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "218",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "219",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "220",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "221",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "222",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "223",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "224",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "230"
                    },
                    {
                        spaceUnitId: "231"
                    },
                    {
                        spaceUnitId: "232"
                    },
                    {
                        spaceUnitId: "233"
                    },
                    {
                        spaceUnitId: "234"
                    },
                    {
                        spaceUnitId: "235"
                    },
                    {
                        spaceUnitId: "236"
                    }
                ]
            }
        },
        POLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "238",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "239",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "241",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "242",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "243",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "244",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "245",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "246",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "247",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "248",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "249",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "257",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "258",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "259",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "260",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "261",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "250",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "251",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "252",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "253",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "254",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "255",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "256",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "262"
                    },
                    {
                        spaceUnitId: "263"
                    },
                    {
                        spaceUnitId: "264"
                    },
                    {
                        spaceUnitId: "265"
                    },
                    {
                        spaceUnitId: "266"
                    },
                    {
                        spaceUnitId: "267"
                    },
                    {
                        spaceUnitId: "268"
                    }
                ]
            }
        },
        HUNGARY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "270",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "271",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "273",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "274",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "275",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "276",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "277",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "278",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "279",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "280",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "281",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "289",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "290",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "291",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "292",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "293",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "282",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "283",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "284",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "285",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "286",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "287",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "288",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "294"
                    },
                    {
                        spaceUnitId: "295"
                    },
                    {
                        spaceUnitId: "296"
                    },
                    {
                        spaceUnitId: "297"
                    },
                    {
                        spaceUnitId: "298"
                    },
                    {
                        spaceUnitId: "299"
                    },
                    {
                        spaceUnitId: "300"
                    }
                ]
            }
        },
        NETHERLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "334",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "335",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "337",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "338",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "339",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "340",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "341",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "342",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "343",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "344",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "345",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "355",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "356",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "357",
                        multiplier: 0.5
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "353",
                        multiplier: 1.62
                    },
                    {
                        spaceUnitId: "354",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "346",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "347",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "348",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "349",
                        multiplier: 14.267
                    },
                    {
                        spaceUnitId: "350",
                        multiplier: 1.07
                    },
                    {
                        spaceUnitId: "351",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "352",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "358"
                    },
                    {
                        spaceUnitId: "359"
                    },
                    {
                        spaceUnitId: "360"
                    },
                    {
                        spaceUnitId: "361"
                    },
                    {
                        spaceUnitId: "362"
                    },
                    {
                        spaceUnitId: "363"
                    },
                    {
                        spaceUnitId: "364"
                    }
                ]
            }
        },
        COLOMBIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "302",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "303",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "305",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "306",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "307",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "308",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "309",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "310",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "311",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "312",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "313",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "321",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "322",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "323",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "324",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "325",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "314",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "315",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "316",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "317",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "318",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "319",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "320",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "326"
                    },
                    {
                        spaceUnitId: "327"
                    },
                    {
                        spaceUnitId: "328"
                    },
                    {
                        spaceUnitId: "329"
                    },
                    {
                        spaceUnitId: "330"
                    },
                    {
                        spaceUnitId: "331"
                    },
                    {
                        spaceUnitId: "332"
                    },
                    {
                        spaceUnitId: "333",
                        multiplier: 12.18
                    }
                ]
            }
        }
    },
    OPEN_OFFICE: {
        // PRODUCER
        US: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "2",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "3",
                        multiplier: 0.86
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SHARED_FOCUS]: [
                    {
                        spaceUnitId: "205",
                        multiplier: 20
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.28
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.19
                    },
                    {
                        spaceUnitId: "11",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "12",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "13",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "14",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "23",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    },
                    {
                        spaceUnitId: "30",
                        multiplier: 1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "25",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "27",
                        multiplier: 4.5
                    },
                    {
                        spaceUnitId: "28",
                        multiplier: 2
                    },
                    {
                        spaceUnitId: "36",
                        multiplier: 0.78
                    },
                    {
                        spaceUnitId: "37",
                        multiplier: 1.4
                    }
                ]
            },
            SMALL: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "2",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "3",
                        multiplier: 0.86
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.28
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.19
                    },
                    {
                        spaceUnitId: "11",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "12",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "13",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "14",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "23",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "28",
                        multiplier: 2
                    }
                ]
            }
        },
        UK: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "38",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "39",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "40",
                        multiplier: 0.86
                    },
                    {
                        spaceUnitId: "42",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "43",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "44",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "45",
                        multiplier: 0.28
                    },
                    {
                        spaceUnitId: "46",
                        multiplier: 0.19
                    },
                    {
                        spaceUnitId: "47",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "48",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "49",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "57",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "58",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "59",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "60",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "61",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "50",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "51",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "52",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "53",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "54",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "55",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "56",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "62"
                    },
                    {
                        spaceUnitId: "63"
                    },
                    {
                        spaceUnitId: "64"
                    },
                    {
                        spaceUnitId: "65"
                    },
                    {
                        spaceUnitId: "66"
                    },
                    {
                        spaceUnitId: "67"
                    },
                    {
                        spaceUnitId: "68"
                    }
                ]
            }
        },
        GERMANY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "70",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "71",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "72",
                        multiplier: 0.86
                    },
                    {
                        spaceUnitId: "74",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "75",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "76",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "77",
                        multiplier: 0.28
                    },
                    {
                        spaceUnitId: "78",
                        multiplier: 0.19
                    },
                    {
                        spaceUnitId: "79",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "80",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "81",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "82",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "83",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "84",
                        multiplier: 0.89
                    },
                    {
                        spaceUnitId: "85",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "86",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "87",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "88",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "89",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "90",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "91",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "92",
                        multiplier: 1.61
                    },
                    {
                        spaceUnitId: "93",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "94"
                    },
                    {
                        spaceUnitId: "95"
                    },
                    {
                        spaceUnitId: "96"
                    },
                    {
                        spaceUnitId: "97"
                    },
                    {
                        spaceUnitId: "98"
                    },
                    {
                        spaceUnitId: "99"
                    },
                    {
                        spaceUnitId: "100"
                    }
                ]
            }
        },
        SPAIN: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "148",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "149",
                        multiplier: 0.01
                    },
                    {
                        spaceUnitId: "150",
                        multiplier: 0.86
                    },
                    {
                        spaceUnitId: "152",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "153",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "154",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "155",
                        multiplier: 0.28
                    },
                    {
                        spaceUnitId: "156",
                        multiplier: 0.19
                    },
                    {
                        spaceUnitId: "157",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "158",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "159",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "160",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "161",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "162",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "163",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "164",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "165",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "166",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "167",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "168",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "169",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "170",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "171"
                    },
                    {
                        spaceUnitId: "172"
                    },
                    {
                        spaceUnitId: "173"
                    },
                    {
                        spaceUnitId: "174"
                    },
                    {
                        spaceUnitId: "175"
                    }
                ]
            }
        },
        FRANCE: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "176",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "177",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "178",
                        multiplier: 0.86
                    },
                    {
                        spaceUnitId: "180",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "181",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "182",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "183",
                        multiplier: 0.28
                    },
                    {
                        spaceUnitId: "184",
                        multiplier: 0.19
                    },
                    {
                        spaceUnitId: "185",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "186",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "187",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "188",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "189",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "190",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "191",
                        multiplier: 0.33
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "192",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "193",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "194",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "195",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "196",
                        multiplier: 1.31
                    },
                    {
                        spaceUnitId: "197",
                        multiplier: 0.57
                    },
                    {
                        spaceUnitId: "198"
                    },
                    {
                        spaceUnitId: "199"
                    },
                    {
                        spaceUnitId: "200"
                    },
                    {
                        spaceUnitId: "201"
                    },
                    {
                        spaceUnitId: "202"
                    },
                    {
                        spaceUnitId: "203"
                    },
                    {
                        spaceUnitId: "204"
                    }
                ]
            }
        },
        APAC: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "101",
                        multiplier: 0.01
                    },
                    {
                        spaceUnitId: "103",
                        multiplier: 0.99
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "107",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "108",
                        multiplier: 0.12
                    },
                    {
                        spaceUnitId: "109",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "110",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "111",
                        multiplier: 0.12
                    },
                    {
                        spaceUnitId: "112",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "113",
                        multiplier: 0.18
                    },
                    {
                        spaceUnitId: "114",
                        multiplier: 0.19
                    },
                    {
                        spaceUnitId: "115",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "131",
                        multiplier: 0.02
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "132",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "133",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "134",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "135",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "124",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "125",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "126",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "136",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "128",
                        multiplier: 0.6
                    },
                    {
                        spaceUnitId: "137",
                        multiplier: 0.35
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "139",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "140",
                        multiplier: 1.7
                    },
                    {
                        spaceUnitId: "142",
                        multiplier: 4.5
                    },
                    {
                        spaceUnitId: "143",
                        multiplier: 1.5
                    },
                    {
                        spaceUnitId: "144",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "147",
                        multiplier: 1.4
                    }
                ]
            }
        },
        SLOVAKIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "206",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "207",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "208",
                        multiplier: 0.86
                    },
                    {
                        spaceUnitId: "210",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "211",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "212",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "213",
                        multiplier: 0.28
                    },
                    {
                        spaceUnitId: "214",
                        multiplier: 0.19
                    },
                    {
                        spaceUnitId: "215",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "216",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "217",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "225",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "226",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "227",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "228",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "229",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "218",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "219",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "220",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "221",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "222",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "223",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "224",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "230"
                    },
                    {
                        spaceUnitId: "231"
                    },
                    {
                        spaceUnitId: "232"
                    },
                    {
                        spaceUnitId: "233"
                    },
                    {
                        spaceUnitId: "234"
                    },
                    {
                        spaceUnitId: "235"
                    },
                    {
                        spaceUnitId: "236"
                    }
                ]
            }
        },
        POLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "238",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "239",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "240",
                        multiplier: 0.86
                    },
                    {
                        spaceUnitId: "242",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "243",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "244",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "245",
                        multiplier: 0.28
                    },
                    {
                        spaceUnitId: "246",
                        multiplier: 0.19
                    },
                    {
                        spaceUnitId: "247",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "248",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "249",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "257",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "258",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "259",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "260",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "261",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "250",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "251",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "252",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "253",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "254",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "255",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "256",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "262"
                    },
                    {
                        spaceUnitId: "263"
                    },
                    {
                        spaceUnitId: "264"
                    },
                    {
                        spaceUnitId: "265"
                    },
                    {
                        spaceUnitId: "266"
                    },
                    {
                        spaceUnitId: "267"
                    },
                    {
                        spaceUnitId: "268"
                    }
                ]
            }
        },
        HUNGARY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "270",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "271",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "272",
                        multiplier: 0.86
                    },
                    {
                        spaceUnitId: "274",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "275",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "276",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "277",
                        multiplier: 0.28
                    },
                    {
                        spaceUnitId: "278",
                        multiplier: 0.19
                    },
                    {
                        spaceUnitId: "279",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "280",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "281",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "289",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "290",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "291",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "292",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "293",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "282",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "283",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "284",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "285",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "286",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "287",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "288",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "294"
                    },
                    {
                        spaceUnitId: "295"
                    },
                    {
                        spaceUnitId: "296"
                    },
                    {
                        spaceUnitId: "297"
                    },
                    {
                        spaceUnitId: "298"
                    },
                    {
                        spaceUnitId: "299"
                    },
                    {
                        spaceUnitId: "300"
                    }
                ]
            }
        },
        NETHERLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "334",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "335",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "336",
                        multiplier: 0.86
                    },
                    {
                        spaceUnitId: "338",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "339",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "340",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "341",
                        multiplier: 0.28
                    },
                    {
                        spaceUnitId: "342",
                        multiplier: 0.19
                    },
                    {
                        spaceUnitId: "343",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "344",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "345",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "355",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "356",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "357",
                        multiplier: 0.5
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "353",
                        multiplier: 1.62
                    },
                    {
                        spaceUnitId: "354",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "346",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "347",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "348",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "349",
                        multiplier: 14.267
                    },
                    {
                        spaceUnitId: "350",
                        multiplier: 1.07
                    },
                    {
                        spaceUnitId: "351",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "352",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "358"
                    },
                    {
                        spaceUnitId: "359"
                    },
                    {
                        spaceUnitId: "360"
                    },
                    {
                        spaceUnitId: "361"
                    },
                    {
                        spaceUnitId: "362"
                    },
                    {
                        spaceUnitId: "363"
                    },
                    {
                        spaceUnitId: "364"
                    }
                ]
            }
        },
        COLOMBIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "302",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "303",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "305",
                        multiplier: 0.86
                    },
                    {
                        spaceUnitId: "306",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "307",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "308",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "309",
                        multiplier: 0.28
                    },
                    {
                        spaceUnitId: "310",
                        multiplier: 0.19
                    },
                    {
                        spaceUnitId: "311",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "312",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "313",
                        multiplier: 0.03
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "321",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "322",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "323",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "324",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "325",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "314",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "315",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "316",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "317",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "318",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "319",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "320",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "326"
                    },
                    {
                        spaceUnitId: "327"
                    },
                    {
                        spaceUnitId: "328"
                    },
                    {
                        spaceUnitId: "329"
                    },
                    {
                        spaceUnitId: "330"
                    },
                    {
                        spaceUnitId: "331"
                    },
                    {
                        spaceUnitId: "332"
                    },
                    {
                        spaceUnitId: "333",
                        multiplier: 12.18
                    }
                ]
            }
        }
    },
    WORKPLACE_360: {
        // CONNECTOR
        US: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "3",
                        multiplier: 0.84
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.08
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SHARED_FOCUS]: [
                    {
                        spaceUnitId: "205",
                        multiplier: 12.5
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "11",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "12",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "13",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "14",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "20",
                        multiplier: 1.5
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    },
                    {
                        spaceUnitId: "30",
                        multiplier: 1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "25",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "26",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "27",
                        multiplier: 4.5
                    },
                    {
                        spaceUnitId: "28",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "33",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "37",
                        multiplier: 1.4
                    }
                ]
            },
            SMALL: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "3",
                        multiplier: 0.84
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.08
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "11",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "12",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "13",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "14",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "20",
                        multiplier: 1.5
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    },
                    {
                        spaceUnitId: "30",
                        multiplier: 1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "28",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "33",
                        multiplier: 1
                    }
                ]
            }
        },
        UK: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "38",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "40",
                        multiplier: 0.84
                    },
                    {
                        spaceUnitId: "42",
                        multiplier: 0.08
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "43",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "44",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "45",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "46",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "47",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "48",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "49",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "57",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "58",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "59",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "60",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "61",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "50",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "51",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "52",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "53",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "54",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "55",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "56",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "62"
                    },
                    {
                        spaceUnitId: "63"
                    },
                    {
                        spaceUnitId: "64"
                    },
                    {
                        spaceUnitId: "65"
                    },
                    {
                        spaceUnitId: "66"
                    },
                    {
                        spaceUnitId: "67"
                    },
                    {
                        spaceUnitId: "68"
                    }
                ]
            }
        },
        GERMANY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "70",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "72",
                        multiplier: 0.84
                    },
                    {
                        spaceUnitId: "74",
                        multiplier: 0.08
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "75",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "76",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "77",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "78",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "79",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "80",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "81",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "82",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "83",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "84",
                        multiplier: 0.89
                    },
                    {
                        spaceUnitId: "85",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "86",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "87",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "88",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "89",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "90",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "91",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "92",
                        multiplier: 1.61
                    },
                    {
                        spaceUnitId: "93",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "94"
                    },
                    {
                        spaceUnitId: "95"
                    },
                    {
                        spaceUnitId: "96"
                    },
                    {
                        spaceUnitId: "97"
                    },
                    {
                        spaceUnitId: "98"
                    },
                    {
                        spaceUnitId: "99"
                    },
                    {
                        spaceUnitId: "100"
                    }
                ]
            }
        },
        SPAIN: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "148",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "150",
                        multiplier: 0.84
                    },
                    {
                        spaceUnitId: "152",
                        multiplier: 0.08
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "153",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "154",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "155",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "156",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "157",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "158",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "159",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "160",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "161",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "162",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "163",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "164",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "165",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "166",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "167",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "168",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "169",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "170",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "171"
                    },
                    {
                        spaceUnitId: "172"
                    },
                    {
                        spaceUnitId: "173"
                    },
                    {
                        spaceUnitId: "174"
                    },
                    {
                        spaceUnitId: "175"
                    }
                ]
            }
        },
        FRANCE: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "176",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "178",
                        multiplier: 0.84
                    },
                    {
                        spaceUnitId: "180",
                        multiplier: 0.08
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "181",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "182",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "183",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "184",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "185",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "186",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "187",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "188",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "189",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "190",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "191",
                        multiplier: 0.33
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "192",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "193",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "194",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "195",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "196",
                        multiplier: 1.31
                    },
                    {
                        spaceUnitId: "197",
                        multiplier: 0.57
                    },
                    {
                        spaceUnitId: "198"
                    },
                    {
                        spaceUnitId: "199"
                    },
                    {
                        spaceUnitId: "200"
                    },
                    {
                        spaceUnitId: "201"
                    },
                    {
                        spaceUnitId: "202"
                    },
                    {
                        spaceUnitId: "203"
                    },
                    {
                        spaceUnitId: "204"
                    }
                ]
            }
        },
        APAC: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "103",
                        multiplier: 1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "107",
                        multiplier: 0.12
                    },
                    {
                        spaceUnitId: "108",
                        multiplier: 0.13
                    },
                    {
                        spaceUnitId: "109",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "110",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "111",
                        multiplier: 0.09
                    },
                    {
                        spaceUnitId: "112",
                        multiplier: 0.12
                    },
                    {
                        spaceUnitId: "113",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "114",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "115",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "131",
                        multiplier: 0.08
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "132",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "133",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "134",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "135",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "124",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "125",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "126",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "136",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "128",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "137",
                        multiplier: 0.35
                    },
                    {
                        spaceUnitId: "138",
                        multiplier: 1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "139",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "141",
                        multiplier: 2.2
                    },
                    {
                        spaceUnitId: "142",
                        multiplier: 5.5
                    },
                    {
                        spaceUnitId: "143",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "144",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "146",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "147",
                        multiplier: 1.4
                    }
                ]
            }
        },
        SLOVAKIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "206",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "208",
                        multiplier: 0.84
                    },
                    {
                        spaceUnitId: "210",
                        multiplier: 0.08
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "211",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "212",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "213",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "214",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "215",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "216",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "217",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "225",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "226",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "227",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "228",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "229",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "218",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "219",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "220",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "221",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "222",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "223",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "224",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "230"
                    },
                    {
                        spaceUnitId: "231"
                    },
                    {
                        spaceUnitId: "232"
                    },
                    {
                        spaceUnitId: "233"
                    },
                    {
                        spaceUnitId: "234"
                    },
                    {
                        spaceUnitId: "235"
                    },
                    {
                        spaceUnitId: "236"
                    }
                ]
            }
        },
        POLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "238",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "240",
                        multiplier: 0.84
                    },
                    {
                        spaceUnitId: "242",
                        multiplier: 0.08
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "243",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "244",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "245",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "246",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "247",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "248",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "249",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "257",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "258",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "259",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "260",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "261",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "250",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "251",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "252",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "253",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "254",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "255",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "256",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "262"
                    },
                    {
                        spaceUnitId: "263"
                    },
                    {
                        spaceUnitId: "264"
                    },
                    {
                        spaceUnitId: "265"
                    },
                    {
                        spaceUnitId: "266"
                    },
                    {
                        spaceUnitId: "267"
                    },
                    {
                        spaceUnitId: "268"
                    }
                ]
            }
        },
        HUNGARY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "270",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "272",
                        multiplier: 0.84
                    },
                    {
                        spaceUnitId: "274",
                        multiplier: 0.08
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "275",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "276",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "277",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "278",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "279",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "280",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "281",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "289",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "290",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "291",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "292",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "293",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "282",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "283",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "284",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "285",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "286",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "287",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "288",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "294"
                    },
                    {
                        spaceUnitId: "295"
                    },
                    {
                        spaceUnitId: "296"
                    },
                    {
                        spaceUnitId: "297"
                    },
                    {
                        spaceUnitId: "298"
                    },
                    {
                        spaceUnitId: "299"
                    },
                    {
                        spaceUnitId: "300"
                    }
                ]
            }
        },
        NETHERLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "334",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "336",
                        multiplier: 0.84
                    },
                    {
                        spaceUnitId: "338",
                        multiplier: 0.08
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "339",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "340",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "341",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "342",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "343",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "344",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "345",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "355",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "356",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "357",
                        multiplier: 0.5
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "353",
                        multiplier: 1.62
                    },
                    {
                        spaceUnitId: "354",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "346",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "347",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "348",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "349",
                        multiplier: 14.267
                    },
                    {
                        spaceUnitId: "350",
                        multiplier: 1.07
                    },
                    {
                        spaceUnitId: "351",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "352",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "358"
                    },
                    {
                        spaceUnitId: "359"
                    },
                    {
                        spaceUnitId: "360"
                    },
                    {
                        spaceUnitId: "361"
                    },
                    {
                        spaceUnitId: "362"
                    },
                    {
                        spaceUnitId: "363"
                    },
                    {
                        spaceUnitId: "364"
                    }
                ]
            }
        },
        COLOMBIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "302",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "304",
                        multiplier: 0.84
                    },
                    {
                        spaceUnitId: "306",
                        multiplier: 0.08
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "307",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "308",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "309",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "310",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "311",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "312",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "313",
                        multiplier: 0.04
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "321",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "322",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "323",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "324",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "325",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "314",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "315",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "316",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "317",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "318",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "319",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "320",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "326"
                    },
                    {
                        spaceUnitId: "327"
                    },
                    {
                        spaceUnitId: "328"
                    },
                    {
                        spaceUnitId: "329"
                    },
                    {
                        spaceUnitId: "330"
                    },
                    {
                        spaceUnitId: "331"
                    },
                    {
                        spaceUnitId: "332"
                    },
                    {
                        spaceUnitId: "333",
                        multiplier: 12.18
                    }
                ]
            }
        }
    },
    CAMPUS: {
        // DIFFERENTIATOR
        US: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "3",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SHARED_FOCUS]: [
                    {
                        spaceUnitId: "205",
                        multiplier: 10
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "11",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "12",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "13",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "14",
                        multiplier: 0.07
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "20",
                        multiplier: 1.5
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    },
                    {
                        spaceUnitId: "30",
                        multiplier: 1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "25",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "26",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "27",
                        multiplier: 4.5
                    },
                    {
                        spaceUnitId: "28",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "33",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "69",
                        multiplier: 12.18
                    },
                    {
                        spaceUnitId: "36",
                        multiplier: 0.78
                    },
                    {
                        spaceUnitId: "37",
                        multiplier: 1.4
                    }
                ]
            },
            SMALL: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "3",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "12",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "13",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "14",
                        multiplier: 0.07
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "20",
                        multiplier: 1.5
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "25",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "28",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "33",
                        multiplier: 1
                    }
                ]
            }
        },
        UK: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "38",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "40",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "42",
                        multiplier: 0.1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "43",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "44",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "45",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "46",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "47",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "48",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "49",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "57",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "58",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "59",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "60",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "61",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "50",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "51",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "52",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "53",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "54",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "55",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "56",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "62"
                    },
                    {
                        spaceUnitId: "63"
                    },
                    {
                        spaceUnitId: "64"
                    },
                    {
                        spaceUnitId: "65"
                    },
                    {
                        spaceUnitId: "66"
                    },
                    {
                        spaceUnitId: "67"
                    },
                    {
                        spaceUnitId: "68"
                    }
                ]
            }
        },
        GERMANY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "70",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "72",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "74",
                        multiplier: 0.1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "75",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "76",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "77",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "78",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "79",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "80",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "81",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "82",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "83",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "84",
                        multiplier: 0.89
                    },
                    {
                        spaceUnitId: "85",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "86",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "87",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "88",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "89",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "90",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "91",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "92",
                        multiplier: 1.61
                    },
                    {
                        spaceUnitId: "93",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "94"
                    },
                    {
                        spaceUnitId: "95"
                    },
                    {
                        spaceUnitId: "96"
                    },
                    {
                        spaceUnitId: "97"
                    },
                    {
                        spaceUnitId: "98"
                    },
                    {
                        spaceUnitId: "99"
                    },
                    {
                        spaceUnitId: "100"
                    }
                ]
            }
        },
        SPAIN: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "148",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "150",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "152",
                        multiplier: 0.1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "153",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "154",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "155",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "156",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "157",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "158",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "159",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "160",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "161",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "162",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "163",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "164",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "165",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "166",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "167",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "168",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "169",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "170",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "171"
                    },
                    {
                        spaceUnitId: "172"
                    },
                    {
                        spaceUnitId: "173"
                    },
                    {
                        spaceUnitId: "174"
                    },
                    {
                        spaceUnitId: "175"
                    }
                ]
            }
        },
        FRANCE: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "176",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "178",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "180",
                        multiplier: 0.1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "181",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "182",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "183",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "184",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "185",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "186",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "187",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "188",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "189",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "190",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "191",
                        multiplier: 0.33
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "192",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "193",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "194",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "195",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "196",
                        multiplier: 1.31
                    },
                    {
                        spaceUnitId: "197",
                        multiplier: 0.57
                    },
                    {
                        spaceUnitId: "198"
                    },
                    {
                        spaceUnitId: "199"
                    },
                    {
                        spaceUnitId: "200"
                    },
                    {
                        spaceUnitId: "201"
                    },
                    {
                        spaceUnitId: "202"
                    },
                    {
                        spaceUnitId: "203"
                    },
                    {
                        spaceUnitId: "204"
                    }
                ]
            }
        },
        APAC: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "101",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "103",
                        multiplier: 0.97
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "107",
                        multiplier: 0.12
                    },
                    {
                        spaceUnitId: "108",
                        multiplier: 0.09
                    },
                    {
                        spaceUnitId: "109",
                        multiplier: 0.09
                    },
                    {
                        spaceUnitId: "110",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "111",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "112",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "113",
                        multiplier: 0.13
                    },
                    {
                        spaceUnitId: "114",
                        multiplier: 0.11
                    },
                    {
                        spaceUnitId: "115",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "131",
                        multiplier: 0.08
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "132",
                        multiplier: 0.7
                    },
                    {
                        spaceUnitId: "133",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "135",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "124",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "125",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "126",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "136",
                        multiplier: 1.3
                    },
                    {
                        spaceUnitId: "128",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "137",
                        multiplier: 0.5
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "139",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "141",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "142",
                        multiplier: 6.5
                    },
                    {
                        spaceUnitId: "143",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "144",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "146",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "147",
                        multiplier: 1.4
                    }
                ]
            }
        },
        SLOVAKIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "206",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "208",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "210",
                        multiplier: 0.1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "211",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "212",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "213",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "214",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "215",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "216",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "217",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "225",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "226",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "227",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "228",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "229",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "218",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "219",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "220",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "221",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "222",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "223",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "224",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "230"
                    },
                    {
                        spaceUnitId: "231"
                    },
                    {
                        spaceUnitId: "232"
                    },
                    {
                        spaceUnitId: "233"
                    },
                    {
                        spaceUnitId: "234"
                    },
                    {
                        spaceUnitId: "235"
                    },
                    {
                        spaceUnitId: "236"
                    }
                ]
            }
        },
        POLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "238",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "240",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "242",
                        multiplier: 0.1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "243",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "244",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "245",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "246",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "247",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "248",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "249",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "257",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "258",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "259",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "260",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "261",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "250",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "251",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "252",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "253",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "254",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "255",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "256",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "262"
                    },
                    {
                        spaceUnitId: "263"
                    },
                    {
                        spaceUnitId: "264"
                    },
                    {
                        spaceUnitId: "265"
                    },
                    {
                        spaceUnitId: "266"
                    },
                    {
                        spaceUnitId: "267"
                    },
                    {
                        spaceUnitId: "268"
                    }
                ]
            }
        },
        HUNGARY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "270",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "272",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "274",
                        multiplier: 0.1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "275",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "276",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "277",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "278",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "279",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "280",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "281",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "289",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "290",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "291",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "292",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "293",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "282",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "283",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "284",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "285",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "286",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "287",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "288",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "294"
                    },
                    {
                        spaceUnitId: "295"
                    },
                    {
                        spaceUnitId: "296"
                    },
                    {
                        spaceUnitId: "297"
                    },
                    {
                        spaceUnitId: "298"
                    },
                    {
                        spaceUnitId: "299"
                    },
                    {
                        spaceUnitId: "300"
                    }
                ]
            }
        },
        NETHERLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "334",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "336",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "338",
                        multiplier: 0.1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "339",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "340",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "341",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "342",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "343",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "344",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "345",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "355",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "356",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "357",
                        multiplier: 0.5
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "353",
                        multiplier: 1.62
                    },
                    {
                        spaceUnitId: "354",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "346",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "347",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "348",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "349",
                        multiplier: 14.267
                    },
                    {
                        spaceUnitId: "350",
                        multiplier: 1.07
                    },
                    {
                        spaceUnitId: "351",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "352",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "358"
                    },
                    {
                        spaceUnitId: "359"
                    },
                    {
                        spaceUnitId: "360"
                    },
                    {
                        spaceUnitId: "361"
                    },
                    {
                        spaceUnitId: "362"
                    },
                    {
                        spaceUnitId: "363"
                    },
                    {
                        spaceUnitId: "364"
                    }
                ]
            }
        },
        COLOMBIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "302",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "304",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "306",
                        multiplier: 0.1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "307",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "308",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "309",
                        multiplier: 0.23
                    },
                    {
                        spaceUnitId: "310",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "311",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "312",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "313",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "321",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "322",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "323",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "324",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "325",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "314",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "315",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "316",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "317",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "318",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "319",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "320",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "326"
                    },
                    {
                        spaceUnitId: "327"
                    },
                    {
                        spaceUnitId: "328"
                    },
                    {
                        spaceUnitId: "329"
                    },
                    {
                        spaceUnitId: "330"
                    },
                    {
                        spaceUnitId: "331"
                    },
                    {
                        spaceUnitId: "332"
                    },
                    {
                        spaceUnitId: "333",
                        multiplier: 12.18
                    }
                ]
            }
        }
    },
    STARTUP: {
        // INCUBATOR
        US: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "3",
                        multiplier: 0.85
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.12
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SHARED_FOCUS]: [
                    {
                        spaceUnitId: "205",
                        multiplier: 8.3
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.24
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "11",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "13",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "14",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    },
                    {
                        spaceUnitId: "30",
                        multiplier: 1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "25",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "27",
                        multiplier: 5.85
                    },
                    {
                        spaceUnitId: "28",
                        multiplier: 2
                    },
                    {
                        spaceUnitId: "33",
                        multiplier: 1.3
                    },
                    {
                        spaceUnitId: "37",
                        multiplier: 1.4
                    }
                ]
            },
            SMALL: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "3",
                        multiplier: 0.85
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "13",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "14",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "28",
                        multiplier: 2
                    },
                    {
                        spaceUnitId: "33",
                        multiplier: 1.3
                    }
                ]
            }
        },
        UK: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "38",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "40",
                        multiplier: 0.85
                    },
                    {
                        spaceUnitId: "42",
                        multiplier: 0.12
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "43",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "44",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "45",
                        multiplier: 0.24
                    },
                    {
                        spaceUnitId: "46",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "47",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "49",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "57",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "58",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "59",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "60",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "61",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "50",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "51",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "52",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "53",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "54",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "55",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "56",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "62"
                    },
                    {
                        spaceUnitId: "63"
                    },
                    {
                        spaceUnitId: "64"
                    },
                    {
                        spaceUnitId: "65"
                    },
                    {
                        spaceUnitId: "66"
                    },
                    {
                        spaceUnitId: "67"
                    },
                    {
                        spaceUnitId: "68"
                    }
                ]
            }
        },
        GERMANY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "70",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "72",
                        multiplier: 0.85
                    },
                    {
                        spaceUnitId: "74",
                        multiplier: 0.12
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "75",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "76",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "77",
                        multiplier: 0.24
                    },
                    {
                        spaceUnitId: "78",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "79",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "81",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "82",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "83",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "84",
                        multiplier: 0.89
                    },
                    {
                        spaceUnitId: "85",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "86",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "87",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "88",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "89",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "90",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "91",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "92",
                        multiplier: 1.61
                    },
                    {
                        spaceUnitId: "93",
                        multiplier: 2.15
                    }
                ]
            }
        },
        SPAIN: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "148",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "150",
                        multiplier: 0.85
                    },
                    {
                        spaceUnitId: "152",
                        multiplier: 0.12
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "153",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "154",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "155",
                        multiplier: 0.24
                    },
                    {
                        spaceUnitId: "156",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "157",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "159",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "160",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "161",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "162",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "163",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "164",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "165",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "166",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "167",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "168",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "169",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "170",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "171"
                    },
                    {
                        spaceUnitId: "172"
                    },
                    {
                        spaceUnitId: "173"
                    },
                    {
                        spaceUnitId: "174"
                    },
                    {
                        spaceUnitId: "175"
                    }
                ]
            }
        },
        FRANCE: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "176",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "178",
                        multiplier: 0.85
                    },
                    {
                        spaceUnitId: "180",
                        multiplier: 0.12
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "181",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "182",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "183",
                        multiplier: 0.24
                    },
                    {
                        spaceUnitId: "184",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "185",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "187",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "188",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "189",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "190",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "191",
                        multiplier: 0.33
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "192",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "193",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "194",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "195",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "196",
                        multiplier: 1.31
                    },
                    {
                        spaceUnitId: "197",
                        multiplier: 0.57
                    },
                    {
                        spaceUnitId: "198"
                    },
                    {
                        spaceUnitId: "199"
                    },
                    {
                        spaceUnitId: "200"
                    },
                    {
                        spaceUnitId: "201"
                    },
                    {
                        spaceUnitId: "202"
                    },
                    {
                        spaceUnitId: "203"
                    },
                    {
                        spaceUnitId: "204"
                    }
                ]
            }
        },
        APAC: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "101",
                        multiplier: 0.02
                    },
                    {
                        spaceUnitId: "103",
                        multiplier: 0.98
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "107",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "108",
                        multiplier: 0.07
                    },
                    {
                        spaceUnitId: "109",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "110",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "111",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "112",
                        multiplier: 0.18
                    },
                    {
                        spaceUnitId: "113",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "114",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "115",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "131",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "132",
                        multiplier: 0.7
                    },
                    {
                        spaceUnitId: "133",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "135",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "124",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "125",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "126",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "136",
                        multiplier: 1.3
                    },
                    {
                        spaceUnitId: "128",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "137",
                        multiplier: 0.5
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "139",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "140",
                        multiplier: 1.7
                    },
                    {
                        spaceUnitId: "142",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "143",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "144",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "147",
                        multiplier: 1.4
                    }
                ]
            }
        },
        SLOVAKIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "206",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "208",
                        multiplier: 0.85
                    },
                    {
                        spaceUnitId: "210",
                        multiplier: 0.12
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "211",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "212",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "213",
                        multiplier: 0.24
                    },
                    {
                        spaceUnitId: "214",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "215",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "217",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "225",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "226",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "227",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "228",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "229",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "218",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "219",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "220",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "221",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "222",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "223",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "224",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "230"
                    },
                    {
                        spaceUnitId: "231"
                    },
                    {
                        spaceUnitId: "232"
                    },
                    {
                        spaceUnitId: "233"
                    },
                    {
                        spaceUnitId: "234"
                    },
                    {
                        spaceUnitId: "235"
                    },
                    {
                        spaceUnitId: "236"
                    }
                ]
            }
        },
        POLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "238",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "240",
                        multiplier: 0.85
                    },
                    {
                        spaceUnitId: "242",
                        multiplier: 0.12
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "243",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "244",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "245",
                        multiplier: 0.24
                    },
                    {
                        spaceUnitId: "246",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "247",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "249",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "257",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "258",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "259",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "260",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "261",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "250",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "251",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "252",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "253",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "254",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "255",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "256",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "262"
                    },
                    {
                        spaceUnitId: "263"
                    },
                    {
                        spaceUnitId: "264"
                    },
                    {
                        spaceUnitId: "265"
                    },
                    {
                        spaceUnitId: "266"
                    },
                    {
                        spaceUnitId: "267"
                    },
                    {
                        spaceUnitId: "268"
                    }
                ]
            }
        },
        HUNGARY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "270",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "272",
                        multiplier: 0.85
                    },
                    {
                        spaceUnitId: "274",
                        multiplier: 0.12
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "275",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "276",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "277",
                        multiplier: 0.24
                    },
                    {
                        spaceUnitId: "278",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "279",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "281",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "289",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "290",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "291",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "292",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "293",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "282",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "283",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "284",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "285",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "286",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "287",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "288",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "294"
                    },
                    {
                        spaceUnitId: "295"
                    },
                    {
                        spaceUnitId: "296"
                    },
                    {
                        spaceUnitId: "297"
                    },
                    {
                        spaceUnitId: "298"
                    },
                    {
                        spaceUnitId: "299"
                    },
                    {
                        spaceUnitId: "300"
                    }
                ]
            }
        },
        NETHERLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "334",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "336",
                        multiplier: 0.85
                    },
                    {
                        spaceUnitId: "338",
                        multiplier: 0.12
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "339",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "340",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "341",
                        multiplier: 0.24
                    },
                    {
                        spaceUnitId: "342",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "343",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "345",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "355",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "356",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "357",
                        multiplier: 0.5
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "353",
                        multiplier: 1.62
                    },
                    {
                        spaceUnitId: "354",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "346",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "347",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "348",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "349",
                        multiplier: 14.267
                    },
                    {
                        spaceUnitId: "350",
                        multiplier: 1.07
                    },
                    {
                        spaceUnitId: "351",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "352",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "358"
                    },
                    {
                        spaceUnitId: "359"
                    },
                    {
                        spaceUnitId: "360"
                    },
                    {
                        spaceUnitId: "361"
                    },
                    {
                        spaceUnitId: "362"
                    },
                    {
                        spaceUnitId: "363"
                    },
                    {
                        spaceUnitId: "364"
                    }
                ]
            }
        },
        COLOMBIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "302",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "304",
                        multiplier: 0.85
                    },
                    {
                        spaceUnitId: "306",
                        multiplier: 0.12
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "307",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "308",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "309",
                        multiplier: 0.24
                    },
                    {
                        spaceUnitId: "310",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "311",
                        multiplier: 0.06
                    },
                    {
                        spaceUnitId: "313",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "321",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "322",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "323",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "324",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "325",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "314",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "315",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "316",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "317",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "318",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "319",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "320",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "326"
                    },
                    {
                        spaceUnitId: "327"
                    },
                    {
                        spaceUnitId: "328"
                    },
                    {
                        spaceUnitId: "329"
                    },
                    {
                        spaceUnitId: "330"
                    },
                    {
                        spaceUnitId: "331"
                    },
                    {
                        spaceUnitId: "332"
                    },
                    {
                        spaceUnitId: "333",
                        multiplier: 12.18
                    }
                ]
            }
        }
    },
    ENG_CREATIVE: {
        // CREATOR
        US: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "3",
                        multiplier: 0.74
                    },
                    {
                        spaceUnitId: "4",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SHARED_FOCUS]: [
                    {
                        spaceUnitId: "205",
                        multiplier: 16.6
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "11",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "13",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "14",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    },
                    {
                        spaceUnitId: "30",
                        multiplier: 1
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "25",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "27",
                        multiplier: 5.85
                    },
                    {
                        spaceUnitId: "28",
                        multiplier: 2
                    },
                    {
                        spaceUnitId: "29",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "33",
                        multiplier: 1.3
                    },
                    {
                        spaceUnitId: "37",
                        multiplier: 1.4
                    }
                ]
            },
            SMALL: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "1",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "3",
                        multiplier: 0.74
                    },
                    {
                        spaceUnitId: "4",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "6",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "7",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "8",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "9",
                        multiplier: 0.35
                    },
                    {
                        spaceUnitId: "10",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "13",
                        multiplier: 0.05
                    },
                    {
                        spaceUnitId: "14",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "15",
                        multiplier: 3
                    },
                    {
                        spaceUnitId: "16",
                        multiplier: 4
                    },
                    {
                        spaceUnitId: "17",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "18",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "19",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "21",
                        multiplier: 80
                    },
                    {
                        spaceUnitId: "22",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "24",
                        multiplier: 0.45
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "28",
                        multiplier: 2
                    },
                    {
                        spaceUnitId: "29",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "33",
                        multiplier: 1.3
                    }
                ]
            }
        },
        UK: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "38",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "40",
                        multiplier: 0.74
                    },
                    {
                        spaceUnitId: "41",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "42",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "43",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "44",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "45",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "46",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "47",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "49",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "57",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "58",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "59",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "60",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "61",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "50",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "51",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "52",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "53",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "54",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "55",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "56",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "62"
                    },
                    {
                        spaceUnitId: "63"
                    },
                    {
                        spaceUnitId: "64"
                    },
                    {
                        spaceUnitId: "65"
                    },
                    {
                        spaceUnitId: "66"
                    },
                    {
                        spaceUnitId: "67"
                    },
                    {
                        spaceUnitId: "68"
                    }
                ]
            }
        },
        GERMANY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "70",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "72",
                        multiplier: 0.74
                    },
                    {
                        spaceUnitId: "73",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "74",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "75",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "76",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "77",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "78",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "79",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "81",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "82",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "83",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "84",
                        multiplier: 0.89
                    },
                    {
                        spaceUnitId: "85",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "86",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "87",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "88",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "89",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "90",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "91",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "92",
                        multiplier: 1.61
                    },
                    {
                        spaceUnitId: "93",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "94"
                    },
                    {
                        spaceUnitId: "95"
                    },
                    {
                        spaceUnitId: "96"
                    },
                    {
                        spaceUnitId: "97"
                    },
                    {
                        spaceUnitId: "98"
                    },
                    {
                        spaceUnitId: "99"
                    },
                    {
                        spaceUnitId: "100"
                    }
                ]
            }
        },
        SPAIN: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "148",
                        multiplier: 0.04
                    },
                    {
                        spaceUnitId: "150",
                        multiplier: 0.74
                    },
                    {
                        spaceUnitId: "151",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "152",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "153",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "154",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "155",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "156",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "157",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "159",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "160",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "161",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "162",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "163",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "164",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "165",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "166",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "167",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "168",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "169",
                        multiplier: 0.55
                    },
                    {
                        spaceUnitId: "170",
                        multiplier: 0.65
                    },
                    {
                        spaceUnitId: "171"
                    },
                    {
                        spaceUnitId: "172"
                    },
                    {
                        spaceUnitId: "173"
                    },
                    {
                        spaceUnitId: "174"
                    },
                    {
                        spaceUnitId: "175"
                    }
                ]
            }
        },
        FRANCE: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "176",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "178",
                        multiplier: 0.74
                    },
                    {
                        spaceUnitId: "179",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "180",
                        multiplier: 0.6
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "181",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "182",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "183",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "184",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "185",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "187",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "188",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "189",
                        multiplier: 0.49
                    },
                    {
                        spaceUnitId: "190",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "191",
                        multiplier: 0.33
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "192",
                        multiplier: 0.66
                    },
                    {
                        spaceUnitId: "193",
                        multiplier: 0.33
                    },
                    {
                        spaceUnitId: "194",
                        multiplier: 0.98
                    },
                    {
                        spaceUnitId: "195",
                        multiplier: 1.64
                    },
                    {
                        spaceUnitId: "196",
                        multiplier: 1.31
                    },
                    {
                        spaceUnitId: "197",
                        multiplier: 0.57
                    },
                    {
                        spaceUnitId: "198"
                    },
                    {
                        spaceUnitId: "199"
                    },
                    {
                        spaceUnitId: "200"
                    },
                    {
                        spaceUnitId: "201"
                    },
                    {
                        spaceUnitId: "202"
                    },
                    {
                        spaceUnitId: "203"
                    },
                    {
                        spaceUnitId: "204"
                    }
                ]
            }
        },
        APAC: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "101",
                        multiplier: 0.03
                    },
                    {
                        spaceUnitId: "104",
                        multiplier: 0.98
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "107",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "108",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "109",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "110",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "111",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "112",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "113",
                        multiplier: 0.17
                    },
                    {
                        spaceUnitId: "114",
                        multiplier: 0.13
                    },
                    {
                        spaceUnitId: "115",
                        multiplier: 0.08
                    },
                    {
                        spaceUnitId: "131",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "132",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "133",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "134",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "135",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "124",
                        multiplier: 0.63
                    },
                    {
                        spaceUnitId: "125",
                        multiplier: 0.4
                    },
                    {
                        spaceUnitId: "126",
                        multiplier: 0.75
                    },
                    {
                        spaceUnitId: "136",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "128",
                        multiplier: 1.2
                    },
                    {
                        spaceUnitId: "137",
                        multiplier: 0.35
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "139",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "141",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "142",
                        multiplier: 4.5
                    },
                    {
                        spaceUnitId: "143",
                        multiplier: 2.5
                    },
                    {
                        spaceUnitId: "144",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "145",
                        multiplier: 0.8
                    },
                    {
                        spaceUnitId: "146",
                        multiplier: 1
                    },
                    {
                        spaceUnitId: "147",
                        multiplier: 1.4
                    }
                ]
            }
        },
        SLOVAKIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "206",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "208",
                        multiplier: 0.74
                    },
                    {
                        spaceUnitId: "209",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "210",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "211",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "212",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "213",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "214",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "215",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "217",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "225",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "226",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "227",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "228",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "229",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "218",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "219",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "220",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "221",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "222",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "223",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "224",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "230"
                    },
                    {
                        spaceUnitId: "231"
                    },
                    {
                        spaceUnitId: "232"
                    },
                    {
                        spaceUnitId: "233"
                    },
                    {
                        spaceUnitId: "234"
                    },
                    {
                        spaceUnitId: "235"
                    },
                    {
                        spaceUnitId: "236"
                    }
                ]
            }
        },
        POLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "238",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "240",
                        multiplier: 0.74
                    },
                    {
                        spaceUnitId: "241",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "242",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "243",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "244",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "245",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "246",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "247",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "249",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "257",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "258",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "259",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "260",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "261",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "250",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "251",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "252",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "253",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "254",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "255",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "256",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "262"
                    },
                    {
                        spaceUnitId: "263"
                    },
                    {
                        spaceUnitId: "264"
                    },
                    {
                        spaceUnitId: "265"
                    },
                    {
                        spaceUnitId: "266"
                    },
                    {
                        spaceUnitId: "267"
                    },
                    {
                        spaceUnitId: "268"
                    }
                ]
            }
        },
        HUNGARY: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "270",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "272",
                        multiplier: 0.74
                    },
                    {
                        spaceUnitId: "273",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "274",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "275",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "276",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "277",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "278",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "279",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "281",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "289",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "290",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "291",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "292",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "293",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "282",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "283",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "284",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "285",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "286",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "287",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "288",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "294"
                    },
                    {
                        spaceUnitId: "295"
                    },
                    {
                        spaceUnitId: "296"
                    },
                    {
                        spaceUnitId: "297"
                    },
                    {
                        spaceUnitId: "298"
                    },
                    {
                        spaceUnitId: "299"
                    },
                    {
                        spaceUnitId: "300"
                    }
                ]
            }
        },
        NETHERLAND: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "334",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "336",
                        multiplier: 0.74
                    },
                    {
                        spaceUnitId: "337",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "338",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "339",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "340",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "341",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "342",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "343",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "345",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "355",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "356",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "357",
                        multiplier: 0.5
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "353",
                        multiplier: 1.62
                    },
                    {
                        spaceUnitId: "354",
                        multiplier: 3.23
                    },
                    {
                        spaceUnitId: "346",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "347",
                        multiplier: 0.5
                    },
                    {
                        spaceUnitId: "348",
                        multiplier: 4.31
                    },
                    {
                        spaceUnitId: "349",
                        multiplier: 14.267
                    },
                    {
                        spaceUnitId: "350",
                        multiplier: 1.07
                    },
                    {
                        spaceUnitId: "351",
                        multiplier: 0.67
                    },
                    {
                        spaceUnitId: "352",
                        multiplier: 2.15
                    },
                    {
                        spaceUnitId: "358"
                    },
                    {
                        spaceUnitId: "359"
                    },
                    {
                        spaceUnitId: "360"
                    },
                    {
                        spaceUnitId: "361"
                    },
                    {
                        spaceUnitId: "362"
                    },
                    {
                        spaceUnitId: "363"
                    },
                    {
                        spaceUnitId: "364"
                    }
                ]
            }
        },
        COLOMBIA: {
            REGULAR: {
                [$b934e0f01196aba3$var$CATEGORY.ME]: [
                    {
                        spaceUnitId: "302",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "304",
                        multiplier: 0.74
                    },
                    {
                        spaceUnitId: "305",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "306",
                        multiplier: 0.06
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.WE]: [
                    {
                        spaceUnitId: "307",
                        multiplier: 0.15
                    },
                    {
                        spaceUnitId: "308",
                        multiplier: 0.2
                    },
                    {
                        spaceUnitId: "309",
                        multiplier: 0.3
                    },
                    {
                        spaceUnitId: "310",
                        multiplier: 0.25
                    },
                    {
                        spaceUnitId: "311",
                        multiplier: 0.1
                    },
                    {
                        spaceUnitId: "313",
                        multiplier: 0.05
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.SUPPORT]: [
                    {
                        spaceUnitId: "321",
                        multiplier: 1.991324
                    },
                    {
                        spaceUnitId: "322",
                        multiplier: 0.430557
                    },
                    {
                        spaceUnitId: "323",
                        multiplier: 2.152783
                    },
                    {
                        spaceUnitId: "324",
                        multiplier: 0.807294
                    },
                    {
                        spaceUnitId: "325",
                        multiplier: 1.614587
                    }
                ],
                [$b934e0f01196aba3$var$CATEGORY.AMENITY]: [
                    {
                        spaceUnitId: "314",
                        multiplier: 0.968752
                    },
                    {
                        spaceUnitId: "315",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "316",
                        multiplier: 5.381958
                    },
                    {
                        spaceUnitId: "317",
                        multiplier: 3.229175
                    },
                    {
                        spaceUnitId: "318",
                        multiplier: 4.921261
                    },
                    {
                        spaceUnitId: "319",
                        multiplier: 0.656168
                    },
                    {
                        spaceUnitId: "320",
                        multiplier: 1.614587
                    },
                    {
                        spaceUnitId: "326"
                    },
                    {
                        spaceUnitId: "327"
                    },
                    {
                        spaceUnitId: "328"
                    },
                    {
                        spaceUnitId: "329"
                    },
                    {
                        spaceUnitId: "330"
                    },
                    {
                        spaceUnitId: "331"
                    },
                    {
                        spaceUnitId: "332"
                    },
                    {
                        spaceUnitId: "333",
                        multiplier: 12.18
                    }
                ]
            }
        }
    }
};

});

parcelRegister("ahytO", function(module, exports) {

var $aB89e = parcelRequire("aB89e");
var $77c63ce7b95586e9$require$constants = $aB89e.spacerFree;
function $77c63ce7b95586e9$var$mapCollaborationValues(low, medium, high) {
    return {
        [$77c63ce7b95586e9$require$constants.calculator.COLLABORATION_LEVEL.LOW]: low,
        [$77c63ce7b95586e9$require$constants.calculator.COLLABORATION_LEVEL.MEDIUM]: medium,
        [$77c63ce7b95586e9$require$constants.calculator.COLLABORATION_LEVEL.HIGH]: high
    };
}
module.exports = {
    EFFICIENT: {
        US: $77c63ce7b95586e9$var$mapCollaborationValues(0.5, 0.65, 0.8),
        EUROPE: $77c63ce7b95586e9$var$mapCollaborationValues(0.3, 0.39, 0.48),
        APAC: $77c63ce7b95586e9$var$mapCollaborationValues(0.3, 0.55, 0.8)
    },
    WHITE_COLLAR: {
        US: $77c63ce7b95586e9$var$mapCollaborationValues(0.55, 0.7, 0.85),
        EUROPE: $77c63ce7b95586e9$var$mapCollaborationValues(0.39, 0.48, 0.6),
        APAC: $77c63ce7b95586e9$var$mapCollaborationValues(0.3, 0.6, 0.9)
    },
    WHITE_GLOVE: {
        US: $77c63ce7b95586e9$var$mapCollaborationValues(0.65, 0.8, 1),
        EUROPE: $77c63ce7b95586e9$var$mapCollaborationValues(0.39, 0.48, 0.6),
        APAC: $77c63ce7b95586e9$var$mapCollaborationValues(0.55, 0.85, 1.1)
    },
    OPEN_OFFICE: {
        US: $77c63ce7b95586e9$var$mapCollaborationValues(0.5, 0.65, 0.8),
        EUROPE: $77c63ce7b95586e9$var$mapCollaborationValues(0.3, 0.39, 0.48),
        APAC: $77c63ce7b95586e9$var$mapCollaborationValues(0.3, 0.5, 0.7)
    },
    WORKPLACE_360: {
        US: $77c63ce7b95586e9$var$mapCollaborationValues(0.65, 0.85, 1.1),
        EUROPE: $77c63ce7b95586e9$var$mapCollaborationValues(0.39, 0.51, 0.66),
        APAC: $77c63ce7b95586e9$var$mapCollaborationValues(0.7, 1, 1.25)
    },
    CAMPUS: {
        US: $77c63ce7b95586e9$var$mapCollaborationValues(0.7, 0.9, 1.1),
        EUROPE: $77c63ce7b95586e9$var$mapCollaborationValues(0.45, 0.54, 0.66),
        APAC: $77c63ce7b95586e9$var$mapCollaborationValues(0.4, 0.7, 1)
    },
    STARTUP: {
        US: $77c63ce7b95586e9$var$mapCollaborationValues(0.5, 0.65, 0.8),
        EUROPE: $77c63ce7b95586e9$var$mapCollaborationValues(0.3, 0.39, 0.48),
        APAC: $77c63ce7b95586e9$var$mapCollaborationValues(0.3, 0.65, 1.1)
    },
    ENG_CREATIVE: {
        US: $77c63ce7b95586e9$var$mapCollaborationValues(0.65, 0.85, 1),
        EUROPE: $77c63ce7b95586e9$var$mapCollaborationValues(0.39, 0.51, 0.6),
        APAC: $77c63ce7b95586e9$var$mapCollaborationValues(0.3, 0.65, 1)
    }
};

});


parcelRegister("egCFH", function(module, exports) {

var $f1q41 = parcelRequire("f1q41");
const $a6308ea8a9379555$var$sharedNames = {
    SOCIAL: 'social',
    EFFICIENT: 'efficient',
    FLEXIBLE: 'flexible',
    ENABLED: 'enabled',
    PRODUCTIVE: 'productive',
    INCLUSIVE: 'inclusive',
    CLIENT_FOCUSED: 'clientFocused',
    STANDARDIZED: 'standardized'
};
function $a6308ea8a9379555$var$getIconObject(iconName) {
    return {
        light: `/svg/icons/${iconName}-white-icon-spacer-by-cbre.svg`,
        dark: `/svg/icons/${iconName}-forest-green-icon-spacer-by-cbre.svg`
    };
}
const $a6308ea8a9379555$var$sharedIcons = {
    SOCIAL: $a6308ea8a9379555$var$getIconObject('thumbs-up'),
    EFFICIENT: $a6308ea8a9379555$var$getIconObject('recycle'),
    FLEXIBLE: $a6308ea8a9379555$var$getIconObject('floorplan'),
    ENABLED: $a6308ea8a9379555$var$getIconObject('supplies'),
    PRODUCTIVE: $a6308ea8a9379555$var$getIconObject('presentation-chart'),
    INCLUSIVE: $a6308ea8a9379555$var$getIconObject('chain-link'),
    CLIENT_FOCUSED: $a6308ea8a9379555$var$getIconObject('plus-person'),
    STANDARDIZED: $a6308ea8a9379555$var$getIconObject('puzzle-piece')
};
const $a6308ea8a9379555$var$profileTraits = [
    // SOCIAL
    {
        id: 'social1',
        name: $a6308ea8a9379555$var$sharedNames.SOCIAL,
        icon: $a6308ea8a9379555$var$sharedIcons.SOCIAL,
        description: 'social1Desc'
    },
    {
        id: 'social2',
        name: $a6308ea8a9379555$var$sharedNames.SOCIAL,
        icon: $a6308ea8a9379555$var$sharedIcons.SOCIAL,
        description: 'social2Desc'
    },
    {
        id: 'social3',
        name: $a6308ea8a9379555$var$sharedNames.SOCIAL,
        icon: $a6308ea8a9379555$var$sharedIcons.SOCIAL,
        description: 'social3Desc'
    },
    {
        id: 'social4',
        name: $a6308ea8a9379555$var$sharedNames.SOCIAL,
        icon: $a6308ea8a9379555$var$sharedIcons.SOCIAL,
        description: 'social4Desc'
    },
    // EFFICIENT
    {
        id: 'efficient1',
        name: $a6308ea8a9379555$var$sharedNames.EFFICIENT,
        icon: $a6308ea8a9379555$var$sharedIcons.EFFICIENT,
        description: 'efficient1Desc'
    },
    {
        id: 'efficient2',
        name: $a6308ea8a9379555$var$sharedNames.EFFICIENT,
        icon: $a6308ea8a9379555$var$sharedIcons.EFFICIENT,
        description: 'efficient2Desc'
    },
    // FLEXIBLE
    {
        id: 'flexible1',
        name: $a6308ea8a9379555$var$sharedNames.FLEXIBLE,
        icon: $a6308ea8a9379555$var$sharedIcons.FLEXIBLE,
        description: 'flexible1Desc'
    },
    {
        id: 'flexible2',
        name: $a6308ea8a9379555$var$sharedNames.FLEXIBLE,
        icon: $a6308ea8a9379555$var$sharedIcons.FLEXIBLE,
        description: 'flexible2Desc'
    },
    {
        id: 'flexible3',
        name: $a6308ea8a9379555$var$sharedNames.FLEXIBLE,
        icon: $a6308ea8a9379555$var$sharedIcons.FLEXIBLE,
        description: 'flexible3Desc'
    },
    // ENABLED
    {
        id: 'enabled1',
        name: $a6308ea8a9379555$var$sharedNames.ENABLED,
        icon: $a6308ea8a9379555$var$sharedIcons.ENABLED,
        description: 'enabled1Desc'
    },
    {
        id: 'enabled2',
        name: $a6308ea8a9379555$var$sharedNames.ENABLED,
        icon: $a6308ea8a9379555$var$sharedIcons.ENABLED,
        description: 'enabled2Desc'
    },
    {
        id: 'enabled3',
        name: $a6308ea8a9379555$var$sharedNames.ENABLED,
        icon: $a6308ea8a9379555$var$sharedIcons.ENABLED,
        description: 'enabled3Desc'
    },
    {
        id: 'enabled4',
        name: $a6308ea8a9379555$var$sharedNames.ENABLED,
        icon: $a6308ea8a9379555$var$sharedIcons.ENABLED,
        description: 'enabled4Desc'
    },
    {
        id: 'enabled5',
        name: $a6308ea8a9379555$var$sharedNames.ENABLED,
        icon: $a6308ea8a9379555$var$sharedIcons.ENABLED,
        description: 'enabled5Desc'
    },
    // PRODUCTIVE
    {
        id: 'productive1',
        name: $a6308ea8a9379555$var$sharedNames.PRODUCTIVE,
        icon: $a6308ea8a9379555$var$sharedIcons.PRODUCTIVE,
        description: 'productive1Desc'
    },
    {
        id: 'productive2',
        name: $a6308ea8a9379555$var$sharedNames.PRODUCTIVE,
        icon: $a6308ea8a9379555$var$sharedIcons.PRODUCTIVE,
        description: 'productive2Desc'
    },
    {
        id: 'productive3',
        name: $a6308ea8a9379555$var$sharedNames.PRODUCTIVE,
        icon: $a6308ea8a9379555$var$sharedIcons.PRODUCTIVE,
        description: 'productive3Desc'
    },
    // INCLUSIVE
    {
        id: 'inclusive1',
        name: $a6308ea8a9379555$var$sharedNames.INCLUSIVE,
        icon: $a6308ea8a9379555$var$sharedIcons.INCLUSIVE,
        description: 'inclusive1Desc'
    },
    {
        id: 'inclusive2',
        name: $a6308ea8a9379555$var$sharedNames.INCLUSIVE,
        icon: $a6308ea8a9379555$var$sharedIcons.INCLUSIVE,
        description: 'inclusive2Desc'
    },
    {
        id: 'inclusive3',
        name: $a6308ea8a9379555$var$sharedNames.INCLUSIVE,
        icon: $a6308ea8a9379555$var$sharedIcons.INCLUSIVE,
        description: 'inclusive3Desc'
    },
    // CLIENT-FOCUSED
    {
        id: 'clientFocused1',
        name: $a6308ea8a9379555$var$sharedNames.CLIENT_FOCUSED,
        icon: $a6308ea8a9379555$var$sharedIcons.CLIENT_FOCUSED,
        description: 'clientFocused1Desc'
    },
    {
        id: 'clientFocused2',
        name: $a6308ea8a9379555$var$sharedNames.CLIENT_FOCUSED,
        icon: $a6308ea8a9379555$var$sharedIcons.CLIENT_FOCUSED,
        description: 'clientFocused2Desc'
    },
    {
        id: 'clientFocused3',
        name: $a6308ea8a9379555$var$sharedNames.CLIENT_FOCUSED,
        icon: $a6308ea8a9379555$var$sharedIcons.CLIENT_FOCUSED,
        description: 'clientFocused3Desc'
    },
    // STANDARDIZED
    {
        id: 'standardized1',
        name: $a6308ea8a9379555$var$sharedNames.STANDARDIZED,
        icon: $a6308ea8a9379555$var$sharedIcons.STANDARDIZED,
        description: 'standardized1Desc'
    },
    {
        id: 'standardized2',
        name: $a6308ea8a9379555$var$sharedNames.STANDARDIZED,
        icon: $a6308ea8a9379555$var$sharedIcons.STANDARDIZED,
        description: 'standardized2Desc'
    },
    {
        id: 'standardized3',
        name: $a6308ea8a9379555$var$sharedNames.STANDARDIZED,
        icon: $a6308ea8a9379555$var$sharedIcons.STANDARDIZED,
        description: 'standardized3Desc'
    },
    {
        id: 'standardized4',
        name: $a6308ea8a9379555$var$sharedNames.STANDARDIZED,
        icon: $a6308ea8a9379555$var$sharedIcons.STANDARDIZED,
        description: 'standardized4Desc'
    }
];
const $a6308ea8a9379555$var$profileTraitsById = $f1q41.keyBy($a6308ea8a9379555$var$profileTraits, 'id');
module.exports = {
    getProfileTraitById (id) {
        return $a6308ea8a9379555$var$profileTraitsById[id];
    }
};

});

parcelRegister("ktyWi", function(module, exports) {

var $f1q41 = parcelRequire("f1q41");

var $aB89e = parcelRequire("aB89e");
var $ee819e44d9a0b03c$require$constants = $aB89e.spacerFree;
const $ee819e44d9a0b03c$var$questionUnits = [
    // "YOUR IDENTITY" QUESTIONS
    {
        id: '1',
        text: 'question1Text',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.PROFILE,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.IDENTITY,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.RANK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION,
        answerText: [
            [
                'q1AnswerText1',
                $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER
            ],
            [
                'q1AnswerText2',
                $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER
            ],
            [
                'q1AnswerText3',
                $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER
            ]
        ],
        emptyAnswerPlaceholder: 'pickOnePlaceholder',
        response: 'q1ResponseText',
        responseIllustrationName: 'quiz-two-people-table-spacer-by-cbre.svg',
        points: [
            2.3,
            2,
            1.7
        ],
        options: {
            1: {
                text: 'q1Option1Text',
                profileIds: [
                    'whiteCollar',
                    'whiteGlove',
                    'campus',
                    'engCreative'
                ]
            },
            2: {
                text: 'q1Option2Text',
                profileIds: [
                    'openOffice',
                    'workplace360',
                    'campus'
                ]
            },
            3: {
                text: 'q1Option3Text',
                profileIds: [
                    'efficient',
                    'whiteCollar',
                    'whiteGlove',
                    'openOffice',
                    'workplace360',
                    'campus',
                    'engCreative'
                ]
            },
            4: {
                text: 'q1Option4Text',
                profileIds: [
                    'whiteCollar',
                    'workplace360',
                    'campus',
                    'startup',
                    'engCreative'
                ]
            },
            5: {
                text: 'q1Option5Text',
                profileIds: [
                    'whiteCollar',
                    'whiteGlove',
                    'workplace360',
                    'campus',
                    'startup',
                    'engCreative'
                ]
            },
            6: {
                text: 'q1Option6Text',
                profileIds: [
                    'whiteCollar',
                    'whiteGlove',
                    'startup',
                    'workplace360'
                ]
            },
            7: {
                text: 'q1Option7Text',
                profileIds: [
                    'whiteCollar',
                    'whiteGlove',
                    'workplace360',
                    'campus',
                    'engCreative',
                    'startup'
                ]
            },
            8: {
                text: 'q1Option8Text',
                profileIds: [
                    'workplace360',
                    'campus',
                    'startup'
                ]
            },
            9: {
                text: 'q1Option9Text',
                profileIds: [
                    'efficient',
                    'openOffice',
                    'startup'
                ]
            }
        }
    },
    {
        id: '2',
        text: 'question2Text',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.PROFILE,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.IDENTITY,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.RANK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION,
        answerText: [
            [
                'q2AnswerText1',
                $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER
            ],
            [
                'q2AnswerText2',
                $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER
            ],
            [
                'q2AnswerText3',
                $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER
            ]
        ],
        emptyAnswerPlaceholder: 'pickOnePlaceholder',
        response: 'q2ResponseText',
        responseIllustrationName: 'quiz-two-people-ping-pong-spacer-by-cbre.svg',
        points: [
            1.3,
            1,
            0.7
        ],
        options: {
            1: {
                text: 'q2Option1Text',
                profileIds: [
                    'whiteCollar',
                    'whiteGlove',
                    'workplace360',
                    'campus',
                    'startup',
                    'engCreative'
                ]
            },
            2: {
                text: 'q2Option2Text',
                profileIds: [
                    'efficient',
                    'whiteGlove',
                    'openOffice',
                    'campus',
                    'engCreative'
                ]
            },
            3: {
                text: 'q2Option3Text',
                profileIds: [
                    'whiteCollar',
                    'whiteGlove',
                    'workplace360',
                    'campus',
                    'engCreative'
                ]
            },
            4: {
                text: 'q2Option4Text',
                profileIds: [
                    'efficient',
                    'openOffice',
                    'campus',
                    'startup'
                ]
            },
            5: {
                text: 'q2Option5Text',
                profileIds: [
                    'openOffice',
                    'workplace360',
                    'startup',
                    'campus'
                ]
            },
            6: {
                text: 'q2Option6Text',
                profileIds: [
                    'efficient',
                    'whiteCollar',
                    'whiteGlove',
                    'workplace360',
                    'campus',
                    'startup',
                    'engCreative'
                ]
            },
            7: {
                text: 'q2Option7Text',
                profileIds: [
                    'whiteGlove',
                    'workplace360',
                    'campus',
                    'engCreative'
                ]
            },
            8: {
                text: 'q2Option8Text',
                profileIds: [
                    'whiteCollar',
                    'openOffice',
                    'startup',
                    'engCreative'
                ]
            }
        }
    },
    {
        id: '3',
        text: 'question3Text',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.PROFILE,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.IDENTITY,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.RANK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION,
        answerText: [
            [
                'q3AnswerText1',
                $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER
            ],
            [
                'q3AnswerText2',
                $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER
            ],
            [
                'q3AnswerText3',
                $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER
            ]
        ],
        emptyAnswerPlaceholder: 'pickOnePlaceholder',
        response: 'q3ResponseText',
        responseIllustrationName: 'quiz-two-people-desk-meeting-spacer-by-cbre.svg',
        points: [
            1.3,
            1,
            0.7
        ],
        options: {
            1: {
                text: 'q3Option1Text',
                profileIds: [
                    'efficient',
                    'whiteCollar',
                    'openOffice',
                    'campus',
                    'startup',
                    'engCreative'
                ]
            },
            2: {
                text: 'q3Option2Text',
                profileIds: [
                    'efficient',
                    'whiteCollar',
                    'whiteGlove',
                    'workplace360',
                    'startup',
                    'engCreative'
                ]
            },
            3: {
                text: 'q3Option3Text',
                profileIds: [
                    'whiteCollar',
                    'whiteGlove',
                    'openOffice',
                    'workplace360',
                    'campus',
                    'startup'
                ]
            },
            4: {
                text: 'q3Option4Text',
                profileIds: [
                    'efficient',
                    'whiteGlove',
                    'workplace360',
                    'engCreative'
                ]
            },
            5: {
                text: 'q3Option5Text',
                profileIds: [
                    'whiteCollar',
                    'whiteGlove',
                    'workplace360'
                ]
            },
            6: {
                text: 'q3Option6Text',
                profileIds: [
                    'whiteGlove',
                    'openOffice',
                    'workplace360',
                    'campus',
                    'startup',
                    'engCreative'
                ]
            }
        }
    },
    // "YOUR ORGANIZATION" QUESTIONS
    {
        id: '4',
        text: 'question4Text',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.PROFILE,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.ORGANIZATION,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION,
        answerInputType: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_INPUT_TYPE.DROPDOWN,
        answerText: [
            'q4AnswerText',
            $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER
        ],
        emptyAnswerPlaceholder: 'selectFromListPlaceholder',
        response: 'q4ResponseText',
        responseIllustrationName: 'quiz-people-calendar-growth-spacer-by-cbre.svg',
        points: 1,
        options: {
            1: {
                text: 'q4Option1Text',
                profileIds: [
                    'efficient',
                    'whiteCollar',
                    'whiteGlove',
                    'openOffice',
                    'workplace360',
                    'campus',
                    'engCreative'
                ]
            },
            2: {
                text: 'q4Option2Text',
                profileIds: [
                    'whiteGlove',
                    'openOffice',
                    'workplace360',
                    'campus',
                    'startup',
                    'engCreative'
                ]
            },
            3: {
                text: 'q4Option3Text',
                profileIds: [
                    'efficient',
                    'whiteCollar',
                    'whiteGlove',
                    'openOffice',
                    'workplace360',
                    'campus',
                    'engCreative'
                ]
            },
            4: {
                text: 'q4Option4Text',
                profileIds: [
                    'openOffice'
                ]
            },
            5: {
                text: 'q4Option5Text',
                profileIds: [
                    'campus',
                    'startup',
                    'engCreative'
                ]
            }
        },
        optionOrder: [
            1,
            2,
            3,
            4,
            5
        ]
    },
    {
        id: '5',
        text: 'question5Text',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.PROFILE,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.ORGANIZATION,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION,
        answerInputType: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_INPUT_TYPE.DROPDOWN,
        answerText: [
            'q5AnswerText',
            $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER
        ],
        emptyAnswerPlaceholder: 'selectFromListPlaceholder',
        points: 1,
        options: {
            1: {
                text: 'q5Option1Text',
                response: 'q5Response1Text',
                responseIllustrationName: 'quiz-girl-desk-working-spacer-by-cbre.svg',
                profileIds: [
                    'efficient',
                    'whiteCollar',
                    'openOffice',
                    'engCreative'
                ]
            },
            2: {
                text: 'q5Option2Text',
                response: 'q5Response2Text',
                responseIllustrationName: 'quiz-girl-desk-working-late-spacer-by-cbre.svg',
                profileIds: [
                    'efficient',
                    'whiteCollar',
                    'whiteGlove',
                    'workplace360',
                    'campus',
                    'startup',
                    'engCreative'
                ]
            },
            3: {
                text: 'q5Option3Text',
                response: 'q5Response3Text',
                responseIllustrationName: 'quiz-desk-working-spacer-by-cbre.svg',
                profileIds: [
                    'whiteCollar',
                    'whiteGlove',
                    'openOffice',
                    'workplace360',
                    'campus'
                ]
            },
            4: {
                text: 'q5Option4Text',
                response: 'q5Response4Text',
                responseIllustrationName: 'quiz-girl-desk-working-spacer-by-cbre.svg',
                profileIds: [
                    'whiteGlove',
                    'workplace360',
                    'startup',
                    'engCreative'
                ]
            }
        },
        optionOrder: [
            1,
            2,
            3,
            4
        ]
    },
    {
        id: '6',
        text: 'question6Text',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.PROFILE,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.ORGANIZATION,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION,
        answerInputType: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_INPUT_TYPE.DROPDOWN,
        answerText: [
            'q6AnswerText',
            $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER
        ],
        emptyAnswerPlaceholder: 'selectFromListPlaceholder',
        points: 1,
        options: {
            1: {
                text: 'q6Option1Text',
                response: 'q6Response1Text',
                responseIllustrationName: 'quiz-girl-individual-desk-spacer-by-cbre.svg',
                profileIds: [
                    'efficient',
                    'whiteCollar',
                    'whiteGlove',
                    'openOffice',
                    'engCreative',
                    'campus'
                ]
            },
            2: {
                text: 'q6Option2Text',
                response: 'q6Response2Text',
                responseIllustrationName: 'quiz-two-people-shared-desk-space-by-cbre.svg',
                profileIds: [
                    'openOffice',
                    'workplace360',
                    'campus',
                    'startup'
                ]
            }
        },
        optionOrder: [
            1,
            2
        ]
    },
    // "YOUR OFFICE" QUESTIONS
    {
        id: '7',
        text: 'question7Text',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.PROFILE,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.OFFICE,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SPECTRUM,
        points: 1,
        options: {
            1: {
                text: 'q7Option1Text',
                profileIds: [
                    'whiteGlove',
                    'efficient'
                ]
            },
            2: {
                text: 'q7Option2Text',
                profileIds: [
                    'whiteCollar',
                    'openOffice'
                ]
            },
            3: {
                text: 'q7Option3Text',
                profileIds: []
            },
            4: {
                text: 'q7Option4Text',
                profileIds: [
                    'startup'
                ]
            },
            5: {
                text: 'q7Option5Text',
                profileIds: [
                    'workplace360',
                    'campus',
                    'engCreative'
                ]
            }
        }
    },
    {
        id: '8',
        text: 'question8Text',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.PROFILE,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.OFFICE,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SPECTRUM,
        points: 1,
        options: {
            1: {
                text: 'q8Option1Text',
                profileIds: [
                    'whiteGlove'
                ]
            },
            2: {
                text: 'q8Option2Text',
                profileIds: [
                    'whiteCollar',
                    'workplace360'
                ]
            },
            3: {
                text: 'q8Option3Text',
                profileIds: [
                    'efficient',
                    'openOffice'
                ]
            },
            4: {
                text: 'q8Option4Text',
                profileIds: [
                    'engCreative'
                ]
            },
            5: {
                text: 'q8Option5Text',
                profileIds: [
                    'campus',
                    'startup'
                ]
            }
        }
    },
    {
        id: '9',
        text: 'question9Text',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.PROFILE,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.OFFICE,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SPECTRUM,
        points: 1,
        options: {
            1: {
                text: 'q9Option1Text',
                profileIds: [
                    'campus',
                    'startup'
                ]
            },
            2: {
                text: 'q9Option2Text',
                profileIds: [
                    'efficient'
                ]
            },
            3: {
                text: 'q9Option3Text',
                profileIds: [
                    'whiteGlove'
                ]
            },
            4: {
                text: 'q9Option4Text',
                profileIds: [
                    'whiteCollar',
                    'startup'
                ]
            },
            5: {
                text: 'q9Option5Text',
                profileIds: [
                    'openOffice',
                    'workplace360'
                ]
            }
        }
    },
    {
        id: '10',
        text: 'question10Text',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.PROFILE,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.OFFICE,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SPECTRUM,
        points: 1,
        options: {
            1: {
                text: 'q10Option1Text',
                profileIds: []
            },
            2: {
                text: 'q10Option2Text',
                profileIds: [
                    'whiteGlove'
                ]
            },
            3: {
                text: 'q10Option3Text',
                profileIds: [
                    'efficient',
                    'whiteCollar'
                ]
            },
            4: {
                text: 'q10Option4Text',
                profileIds: [
                    'workplace360'
                ]
            },
            5: {
                text: 'q10Option5Text',
                profileIds: [
                    'openOffice',
                    'campus',
                    'engCreative',
                    'startup'
                ]
            }
        }
    },
    {
        id: '11',
        text: 'question11Text',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.PROFILE,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.OFFICE,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SPECTRUM,
        points: 1,
        options: {
            1: {
                value: 1,
                text: 'q11Option1Text',
                profileIds: [
                    'efficient',
                    'openOffice'
                ]
            },
            2: {
                text: 'q11Option2Text',
                profileIds: [
                    'whiteCollar'
                ]
            },
            3: {
                text: 'q11Option3Text',
                profileIds: []
            },
            4: {
                text: 'q11Option4Text',
                profileIds: [
                    'workplace360',
                    'startup',
                    'engCreative'
                ]
            },
            5: {
                text: 'q11Option5Text',
                profileIds: [
                    'whiteGlove',
                    'campus'
                ]
            }
        }
    },
    // "YOUR DETAILS" QUESTIONS
    {
        id: '12',
        text: 'question12Text',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.USER_DATA,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.DETAILS,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION,
        answerInputType: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_INPUT_TYPE.DROPDOWN,
        answerText: [
            'q12AnswerText',
            $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER
        ],
        userDataProperty: 'role',
        options: {
            lead: {
                text: 'q12OptionLeadText',
                response: 'q12ResponseLeadText',
                responseIllustrationName: 'quiz-people-conversing-spacer-by-cbre.svg'
            },
            cbreClient: {
                text: 'q12OptionClientText',
                response: 'q12ResponseClientText',
                responseIllustrationName: 'quiz-people-conversing-spacer-by-cbre.svg'
            },
            cbreProfessional: {
                text: 'q12OptionProfessionalText',
                response: 'q12ResponseProfessionalText',
                responseIllustrationName: 'quiz-people-conversing-spacer-by-cbre.svg'
            }
        },
        optionOrder: [
            'cbreProfessional',
            'cbreClient',
            'lead'
        ]
    },
    {
        id: '13',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.ASSUMPTION,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.DETAILS,
        assumptionType: $ee819e44d9a0b03c$require$constants.questionUnit.ASSUMPTION_TYPE.HEADCOUNT,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION,
        answerText: [
            'q13AnswerText1',
            $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER,
            'q13AnswerText2'
        ],
        answerHelperText: 'q13AnswerHelperText'
    },
    {
        id: '14',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.ASSUMPTION,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.DETAILS,
        assumptionType: $ee819e44d9a0b03c$require$constants.questionUnit.ASSUMPTION_TYPE.COLLABORATION,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION,
        answerText: [
            'q14AnswerText1',
            $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER,
            'q14AnswerText2'
        ]
    },
    {
        id: '15',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.ASSUMPTION,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.DETAILS,
        assumptionType: $ee819e44d9a0b03c$require$constants.questionUnit.ASSUMPTION_TYPE.DAYS_IN_OFFICE,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION,
        answerText: [
            'q15AnswerText1',
            $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER,
            'q15AnswerText2'
        ]
    },
    {
        id: '16',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.USER_DATA,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.DETAILS,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION,
        answerInputType: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_INPUT_TYPE.LOCATION_AUTOCOMPLETE,
        answerText: [
            'q16AnswerText1',
            $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER,
            'q16AnswerText2'
        ],
        userDataProperty: 'officeLocation'
    },
    {
        id: '17',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.USER_DATA,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.DETAILS,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION,
        answerInputType: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_INPUT_TYPE.INDUSTRY_AUTOCOMPLETE,
        answerText: [
            'q17AnswerText1',
            $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER,
            'q17AnswerText2'
        ],
        userDataProperty: 'industryCode'
    },
    {
        id: '18',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.USER_DATA,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.DETAILS,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION,
        answerInputType: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_INPUT_TYPE.LOCATION_AUTOCOMPLETE,
        answerText: [
            'q18AnswerText1',
            $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER,
            'q18AnswerText2'
        ],
        userDataProperty: 'currentPersonalLocation'
    },
    {
        id: '19',
        type: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_TYPE.ASSUMPTION,
        category: $ee819e44d9a0b03c$require$constants.questionUnit.QUESTION_CATEGORY.DETAILS,
        assumptionType: $ee819e44d9a0b03c$require$constants.questionUnit.ASSUMPTION_TYPE.DENSITY,
        answerType: $ee819e44d9a0b03c$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK,
        answerFormat: $ee819e44d9a0b03c$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION,
        answerText: [
            'q19AnswerText1',
            $ee819e44d9a0b03c$require$constants.questionUnit.INPUT_PLACEHOLDER,
            'q19AnswerText2'
        ]
    }
];
const $ee819e44d9a0b03c$var$questionUnitsById = $f1q41.keyBy($ee819e44d9a0b03c$var$questionUnits, 'id');
module.exports = {
    getQuestionUnitById (id) {
        return $ee819e44d9a0b03c$var$questionUnitsById[id];
    }
};

});

parcelRegister("9dywM", function(module, exports) {
const $6b601c6d49ca433f$var$quizOrder = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '9',
    '6',
    '7',
    '8',
    '10',
    '11',
    '12',
    '13',
    '14',
    '19',
    '15',
    '16',
    '18',
    '17'
];
const $6b601c6d49ca433f$var$groupedQuestions = [
    '13',
    '14',
    '19',
    '15',
    '16',
    '18',
    '17'
]; // if we ever get more than one chunk of grouped questions, deal with that then
const $6b601c6d49ca433f$var$quizProgressAtQuestion = [
    0,
    10,
    20,
    25,
    30,
    35,
    40,
    45,
    50,
    55,
    60,
    65,
    70,
    75,
    80,
    85,
    90,
    92,
    95
]; // total quiz progress in percentage shown at each question
module.exports = {
    quizOrder: $6b601c6d49ca433f$var$quizOrder,
    groupedQuestions: $6b601c6d49ca433f$var$groupedQuestions,
    quizProgressAtQuestion: $6b601c6d49ca433f$var$quizProgressAtQuestion
};

});

parcelRegister("71fW4", function(module, exports) {
const $51c4fce4179340a2$var$spacerFreeRedirectPaths = [
    {
        from: '/support',
        to: '/'
    },
    {
        from: '/pricing',
        to: '/'
    },
    {
        from: '/squareFootage',
        to: '/'
    },
    {
        from: '/quiz',
        to: '/quiz-spacer-by-cbre'
    },
    {
        from: '/results',
        to: '/program-your-results-spacer-by-cbre'
    },
    {
        from: '/about',
        to: '/about-spacer-by-cbre'
    },
    {
        from: '/topProfiles',
        to: '/profile-comparison-spacer-by-cbre'
    },
    {
        from: '/termsOfService',
        to: '/terms-spacer-by-cbre'
    },
    {
        from: '/home-spacer-by-cbre',
        to: '/'
    },
    {
        from: '/insights-spacer-by-cbre/what-is-rentable-vs-usable-square-feet',
        to: '/space-planning-faqs/difference-between-usable-rentable-square-feet'
    }
];
module.exports = {
    spacerFreeRedirectPaths: $51c4fce4179340a2$var$spacerFreeRedirectPaths
};

});

parcelRegister("4Ds5C", function(module, exports) {

var $f1q41 = parcelRequire("f1q41");

const { CATEGORY: $360097f996698d39$var$CATEGORY, UNIT_LABEL: $360097f996698d39$var$UNIT_LABEL, CIRCULATION_TYPE: $360097f996698d39$var$CIRCULATION_TYPE } = (parcelRequire("aB89e")).shared.spaceUnit;
// spaceUnits 1-37: used for US_SMALL and US_REGULAR profiles
// spaceUnits 38-68: used for UK_REGULAR profiles
// spaceUnits 70-100: used for GERMANY_REGULAR profiles
// spaceUnits 101-147: used for APAC_REGULAR profiles
// spaceUnits 148-175: used for SPAIN_REGULAR profiles
// spaceUnits 176-205: used for FRANCE_REGULAR profiles
// spaceUnits 206-237: used for SLOVAKIA_REGULAR profiles
// spaceUnits 238-269: used for POLAND_REGULAR profiles
// spaceUnits 270-301: used for HUNGARY_REGULAR profiles
// spaceUnits 302-333: used for COLOMBIA_REGULAR profiles
// spaceUnits 334-363: used for NETHERLAND_REGULAR profiles
const $360097f996698d39$var$spaceUnits = [
    // US_SMALL & US_REGULAR space units
    {
        id: '1',
        displayName: 'Office',
        displayNameToken: 'officeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 120,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '2',
        displayName: 'Office (large)',
        displayNameToken: 'lgOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 180,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy. This slightly larger office might be a partner office or might double as a huddle room.',
        descriptionToken: 'lgOfficeDesc'
    },
    {
        id: '3',
        displayName: 'Workstation (small)',
        displayNameToken: 'smWorkstationDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 30,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Workstations are open individual work seats. Smaller workstations can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open workstations are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open workstations have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'smWorkstationDesc'
    },
    {
        id: '4',
        displayName: 'Workstation (medium)',
        displayNameToken: 'mdWorkstationDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 36,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Workstations are open individual work seats. The benefits of a slightly larger space includes more desk storage and privacy. This likely means the larger a desk, the most likely it is to assigned instead of free address. Some advantages of open workstations are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open workstations have plenty of focus and huddle rooms. You will likely find additional communal storage and filing located throughout the floor.',
        descriptionToken: 'mdWorkstationDesc'
    },
    {
        id: '5',
        displayName: 'Workstation (large)',
        displayNameToken: 'lgWorkstationDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 48,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Workstations are open individual work seats. The benefits of a slightly larger space includes more desk storage and privacy. Desks this size are most likely assigned instead of free address. Some advantages of open workstations are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open workstations have plenty of focus and huddle rooms. You will likely find additional communal storage and filing located throughout the floor.',
        descriptionToken: 'lgWorkstationDesc'
    },
    {
        id: '6',
        displayName: 'Focus Room',
        displayNameToken: 'focusRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 60,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Focus Rooms are enclosed spaces intended to support focused and/or confidential work for typically one or two people. Acoustic privacy is paramount in these spaces. Focus Rooms are usually unassigned and can be booked temporarily on an as-needed basis for relevant work.',
        descriptionToken: 'focusRoomDesc'
    },
    {
        id: '7',
        displayName: 'Huddle Room',
        displayNameToken: 'huddleRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 100,
        seats: 3,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Huddle Rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'huddleRoomDesc'
    },
    {
        id: '8',
        displayName: 'Small Meeting Room',
        displayNameToken: 'smMeetingRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 120,
        seats: 5,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'A small conference room is an enclosed meeting space intended to comfortably accommodate 2-6 people at the table. These rooms can be used for both internal and client-facing meetings and should therefore be very user friendly with easy access to power and A/V capabilities.',
        descriptionToken: 'smMeetingConferenceRoomDesc'
    },
    {
        id: '9',
        displayName: 'Medium Meeting Room',
        displayNameToken: 'mdMeetingRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 240,
        seats: 9,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'A medium conference room is an enclosed meeting space intended to comfortably accommodate 6-10 people at the table. These rooms are used for both internal and client-facing meetings and should therefore be very user friendly with easy access to power and A/V capabilities.',
        descriptionToken: 'mdMeetingConferenceRoomDesc'
    },
    {
        id: '10',
        displayName: 'Large Meeting Room',
        displayNameToken: 'lgMeetingRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 480,
        seats: 15,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'A large conference room is an enclosed meeting space intended to comfortably accommodate 12-14 people at the table, overflow seating along the perimeter of the room is desirable. These rooms can be used for both internal and client-facing meetings and are likely to be used for presentations.',
        descriptionToken: 'lgMeetingConferenceRoomDesc'
    },
    {
        id: '11',
        displayName: 'X-Large Meeting Room / Boardroom',
        displayNameToken: 'xlMeetingRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 600,
        seats: 18,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'A boardroom conference room is intended to comfortably accommodate 14-18 people at the table, with overflow seating along the perimeter of the room for at least 10 more. These rooms will most likely be used for large internal formal meetings and large client-facing meetings. As such, they should be equipped with robust A/V technology and should be branded as client facing-space.',
        descriptionToken: 'xlMeetingRoomDesc'
    },
    {
        id: '12',
        displayName: 'Multi-Purpose / Training',
        displayNameToken: 'multiPurpTrainingDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 1000,
        seats: 40,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Multi-purpose rooms are meant to accommodate a large number of people (20+). This space is appropriately named since many different activities can happen here including training, company events, and large presentations. The fit and finish of this space is functional/durable with many people coming and going but client facing as well. This space must have the appropriate A/V support - typically much more than the average conference room.',
        descriptionToken: 'multiPurpTrainingDesc'
    },
    {
        id: '13',
        displayName: 'Informal Collaboration Area',
        displayNameToken: 'informalCollabDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 120,
        seats: 6,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'These areas are meant to support small groups (4-6 person) collaborative activities such as brainstorming and informal conversations between colleagues and with clients.',
        descriptionToken: 'informalCollabDesc'
    },
    {
        id: '14',
        displayName: 'Touchdown / Team Area',
        displayNameToken: 'touchdownTeamDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 120,
        seats: 6,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Touchdowns are individual or small internal team work spaces that are spread throughout the office for employee and visitor use. Touchdowns can be a variety of heights, shapes and sizes but are meant to stand out from individual workstations as a unique place to work for a short period of time. These should be plug-and-play spaces: easy to find and use.',
        descriptionToken: 'touchdownTeamDesc'
    },
    {
        id: '15',
        displayName: 'Dispersed Copy / Print Area',
        displayNameToken: 'dispersedCopyPrintAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 120,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Spread across the floor in open workspace, copy/print areas give employees quick access to multi-function devices from all neighborhoods. Bins for recycling should always be collocated with copy/print areas, as well as small cabinets to house extra paper and supplies. These spaces are for drop-in purposes only and are not intended to double as social/work areas.',
        descriptionToken: 'copyPrintDesc'
    },
    {
        id: '16',
        displayName: 'Pantry / Vending / Coffee Area',
        displayNameToken: 'pantryVendingCoffeeAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 240,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Unlike the central cafe, the pantry/vending/coffee area is meant for employees to grab the quick food and drink essentials need. Buzz and conversation is naturally found in areas with food, but these spaces usually do not contain seating causing people to come and go quickly within spending an extending amount of time socializing.',
        descriptionToken: 'pantryVendingCoffeeDesc'
    },
    {
        id: '17',
        displayName: 'Workplace Storage Room',
        displayNameToken: 'workplaceStorageRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 120,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.',
        descriptionToken: 'storageDesc'
    },
    {
        id: '18',
        displayName: 'Wellness Room',
        displayNameToken: 'wellnessRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 60,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: "Wellness rooms (formerly referred to as Mother\u2019s Rooms) are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Wellness rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'wellnessRoomDesc'
    },
    {
        id: '19',
        displayName: 'Employee Coat Area',
        displayNameToken: 'employeeCoatAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 40,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Employees need a place to store their coats and other bulky items, especially when an office has an open layout with limited personal storage at the desk. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.',
        descriptionToken: 'coatClosetsDesc'
    },
    {
        id: '20',
        displayName: 'Dispersed Mail Area',
        displayNameToken: 'dispersedMailAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 60,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'For larger companies, a mail center is required for organizing incoming and outgoing mail. These space hold specialty production and mail equipment. There are also many surfaces for organizing paper and other materials. Usually manned by a full time staff member.',
        descriptionToken: 'centralisedDispersedMailAreaDesc'
    },
    {
        id: '21',
        displayName: 'File Room',
        displayNameToken: 'fileRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 120,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'This is paper file storage for individuals and teams. As a result of most offices digitization efforts, the need for both individual and team file storage is diminishing greatly. Still, this is a central space for legally required document copies or long term project materials, especially with most open office desks containing little storage.',
        descriptionToken: 'fileRoomDesc'
    },
    {
        id: '22',
        displayName: '3 Drawer Lateral File Unit',
        displayNameToken: 'drawerLateralFileUnitDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.UNITS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 3,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Personal storage for individuals at desks or offices. Contents are usually personal or active project materials.',
        descriptionToken: 'drawerLateralFileDesc'
    },
    {
        id: '23',
        displayName: 'Locker Unit',
        displayNameToken: 'lockerUnitDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.UNITS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 2,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Lockers are provided as another form of individual storage. They give employees a space to lock their valuables, personal effects and working files. Lockers may be assigned to individuals or used on a first come, first served basis.',
        descriptionToken: 'lockerDesc'
    },
    {
        id: '24',
        displayName: 'Server Room',
        displayNameToken: 'serverRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 300,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Primary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.',
        descriptionToken: 'mainITandServerRoomDesc'
    },
    {
        id: '25',
        displayName: 'Front Desk Area',
        displayNameToken: 'frontDeskAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 300,
        description: 'This is first stop when employees and visitors come to the office. The desk should be able to accommodate at least one person with person workspace and storage. There will likely be vistor storage nearby as well. The front desk is placed within the larger reception hub where there will likely be seating and other accommodations.',
        descriptionToken: 'frontDeskAreaDesc'
    },
    {
        id: '26',
        displayName: 'Central Reception Hub',
        displayNameToken: 'centralReceptionHubDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 800,
        maxSF: 3000,
        description: "The reception area is your company\u2019s first opportunity to make an impression on employees, clients and other visitors. It should consistently convey the company\u2019s brand and project the desired appearance. The concierge desk should comfortably house a concierge; soft-seating should be inviting to visitors.",
        descriptionToken: 'centralReceptionHubDesc'
    },
    {
        id: '27',
        displayName: "Central Caf\xe9 Area",
        displayNameToken: 'centralCafeAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 800,
        description: 'The central cafe is intended to be an area for eating, social interaction, individual work and small meetings. Functional eating furniture and a branded color palette should be considered in the design of this space.',
        descriptionToken: 'cafeFoodServiceDesc'
    },
    {
        id: '28',
        displayName: 'Mail Center Area',
        displayNameToken: 'mailCenterAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 80,
        description: 'For larger organizations, a mail center is required to centralize all mail services. This will include large sorting and organization space, along with space for charts and equipment. This space likely looks very different for each organization since it is often fit between other program items.',
        descriptionToken: 'mailCenterAreaDesc'
    },
    {
        id: '29',
        displayName: 'Commercial Print Room',
        displayNameToken: 'commercialPrintRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 300,
        description: 'Often combined with the mailroom, companies provide in house capabilities to print, bind, and compile presentations in the print room. There will be several printers, and might include large format printers. Spaces will include storage space for supplies, and will also include counter space for smaller equipment but also space to layout prints.',
        descriptionToken: 'commercialPrintRoomDesc'
    },
    {
        id: '30',
        displayName: 'Internal Stair',
        displayNameToken: 'internalStairDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 500,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Internal stairs can be activated stairwells in the core that provide access between floors, or it can be additional feature elements that connect floors of an office. Can often be a gather space within the office and can be centralized for cafe, reception, or meeting spaces.',
        descriptionToken: 'internalStairDesc'
    },
    {
        id: '31',
        displayName: 'Kitchen Area',
        displayNameToken: 'kitchenAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 150,
        description: 'For spaces that will have an in-office dining service, a kitchen is required to support this amenity. The requirements of a kitchen will vary from organization to organization, but you can expect to find cooking appliances and refrigerator storage. There will also be dry goods and equipment storage. The kitchen will be adjacent to the servery and likely the conferencing/client amenities center.',
        descriptionToken: 'kitchenAreaDesc'
    },
    {
        id: '32',
        displayName: 'Servery Area',
        displayNameToken: 'serveryAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 150,
        description: 'The servery is the area where people get their food. It is likely connected to the kitchen and a dining area with tables and seating. The planning of a servery is very precise to manage queues and traffic. This size and shape of this space will likely vary between organizations.',
        descriptionToken: 'serveryAreaDesc'
    },
    {
        id: '33',
        displayName: 'Juice Bar / Coffee Shop Area',
        displayNameToken: 'juiceBarCoffeeShopAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 100,
        description: 'While a company might not have a full kitchen and servery, it may provide a coffee shop or juice bar as part of the food/drink amenities in the space. An organization might also have this kind of space in addition to its main dining services, especially if the office is large. This space will likely look like your local Starbucks with a working area for a staffer person separated by a serving counter.',
        descriptionToken: 'juiceBarCoffeeShopDesc'
    },
    {
        id: '34',
        displayName: 'Dining Support Space Area',
        displayNameToken: 'diningSupportAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'An organization that has robust dining services will likely have additional support spaces like storage in other parts of the building that need to be accounted for in the overall program. The space will vary between organizations.',
        descriptionToken: 'diningSupportAreaDesc'
    },
    {
        id: '35',
        displayName: 'Dining Area',
        displayNameToken: 'diningAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Dining near kitchen should provide a variety of choice for people to sit and eat lunch. Providing several different types of seating also allows the space to be utilized for meetings and collaboration outside of lunch time. Providing soft and hard seating along with bar and seated height settings gives users choice.',
        descriptionToken: 'diningAreaDesc'
    },
    {
        id: '36',
        displayName: 'Grab-N-Go Area',
        displayNameToken: 'grabNGoAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 100,
        description: 'A small convenience area with several fridges, shelves for chips and snacks, and a checkout machine. These Grab-N-Go spaces are typically monitored for security by camera. These spaces are often combined with a small pantry with fridges and freezers and prep area for food.',
        descriptionToken: 'grabNGoDesc'
    },
    {
        id: '37',
        displayName: 'Building Support Services Area',
        displayNameToken: 'buildingSupportServicesAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 100,
        description: 'This is a catch all for additional support spaces that might occur in an office. One could be a security desk or facilities while another could be a utilities space. This varies across organizations, but as the size of the office increases, ancillary spaces like this become more likely and necessary.',
        descriptionToken: 'specialResourceBuildingSupportAreaDesc'
    },
    // UK_REGULAR space units
    {
        id: '38',
        displayName: 'Small Office',
        displayNameToken: 'smOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 118.4,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '39',
        displayName: 'Regular Office',
        displayNameToken: 'regOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 161.5,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '40',
        displayName: "5\u2019 Bench Desk",
        displayNameToken: 'benchDesk5Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 29.1,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '41',
        displayName: "6\u2019 Bench Desk",
        displayNameToken: 'benchDesk6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 35.5,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '42',
        displayName: 'Focus Room',
        displayNameToken: 'focusRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 75.3,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Focus Rooms are enclosed spaces intended to support focused and/or confidential work for typically one or two people. Acoustic privacy is paramount in these spaces. Focus Rooms are usually unassigned and can be booked temporarily on an as-needed basis for relevant work.',
        descriptionToken: 'focusRoomDesc'
    },
    {
        id: '43',
        displayName: 'Meeting Room (4 people)',
        displayNameToken: 'meetingRoom4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 118.4,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc'
    },
    {
        id: '44',
        displayName: 'Meeting Room (6 people)',
        displayNameToken: 'meetingRoom6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 161.5,
        seats: 6,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc6'
    },
    {
        id: '45',
        displayName: 'Meeting Room (8 people)',
        displayNameToken: 'meetingRoom8Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 218,
        seats: 8,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc8'
    },
    {
        id: '46',
        displayName: 'Meeting Room (12 people)',
        displayNameToken: 'meetingRoom12Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 387.5,
        seats: 12,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc12'
    },
    {
        id: '47',
        displayName: 'Meeting Room (15 people)',
        displayNameToken: 'meetingRoom15Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 538.2,
        seats: 15,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc15'
    },
    {
        id: '48',
        displayName: 'Semi-Enclosed Meeting Booth (4 people)',
        displayNameToken: 'semiEnclosedMeetingBooth4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 43.1,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN
    },
    {
        id: '49',
        displayName: 'Open Collaboration Space (4-6 people)',
        displayNameToken: 'openCollabSpace4to6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 236.8,
        seats: 5,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'These areas are meant to support small groups (4-6 person) collaborative activities such as brainstorming and informal conversations between colleagues and with clients.',
        descriptionToken: 'openCollabSpace4to6Desc'
    },
    {
        id: '50',
        displayName: 'Contemplation Space',
        displayNameToken: 'contemplationSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 161.4587,
        maxSF: 290.6257
    },
    {
        id: '51',
        displayName: 'Main IT Server / Equipment Room',
        displayNameToken: 'mainITEquipRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 236.8061,
        maxSF: 505.904,
        description: 'Primary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.',
        descriptionToken: 'mainITandServerRoomDesc'
    },
    {
        id: '52',
        displayName: 'Reception Area',
        displayNameToken: 'receptionAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 236.8061,
        maxSF: 505.904,
        description: "The reception area is your company\u2019s first opportunity to make an impression on employees, clients and other visitors. It should consistently convey the company\u2019s brand and project the desired appearance. The concierge desk should comfortably house a concierge; soft-seating should be inviting to visitors.",
        descriptionToken: 'centralReceptionHubDesc'
    },
    {
        id: '53',
        displayName: "Caf\xe9 / Food Service",
        displayNameToken: 'cafeFoodServiceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 200,
        maxSF: 1000,
        description: 'The central cafe is intended to be an area for eating, social interaction, individual work and small meetings. Functional eating furniture and a branded color palette should be considered in the design of this space.',
        descriptionToken: 'cafeFoodServiceDesc'
    },
    {
        id: '54',
        displayName: 'Team Storage',
        displayNameToken: 'teamStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 120,
        maxSF: 500,
        description: 'Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.',
        descriptionToken: 'storageDesc'
    },
    {
        id: '55',
        displayName: 'Coat Closets',
        displayNameToken: 'coatClosetsDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 40,
        maxSF: 150,
        description: 'Employees need a place to store their coats and other bulky items, especially when an office has an open layout with limited personal storage at the desk. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.',
        descriptionToken: 'coatClosetsDesc'
    },
    {
        id: '56',
        displayName: 'General Storage (stores and goods in/out)',
        displayNameToken: 'genStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 80,
        maxSF: 500,
        description: 'Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.',
        descriptionToken: 'storageDesc'
    },
    {
        id: '57',
        displayName: 'Centralised Copy, Print & Mail',
        displayNameToken: 'centralisedCopyPrintMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 199.1324,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Spread across the floor in open workspace, copy/print areas give employees quick access to multi-function devices from all neighborhoods. Bins for recycling should always be collocated with copy/print areas, as well as small cabinets to house extra paper and supplies. These spaces are for drop-in purposes only and are not intended to double as social/work areas.',
        descriptionToken: 'copyPrintDesc'
    },
    {
        id: '58',
        displayName: 'Special Resource Area',
        displayNameToken: 'specialResourceAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 86.11132,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'This is a catch all for additional support spaces that might occur in an office. One could be a security desk or facilities while another could be a utilities space. This varies across organizations, but as the size of the office increases, ancillary spaces like this become more likely and necessary.',
        descriptionToken: 'specialResourceBuildingSupportAreaDesc'
    },
    {
        id: '59',
        displayName: 'Personal Storage (lockers)',
        displayNameToken: 'personalStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 2.152783,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Lockers are provided as another form of individual storage. They give employees a space to lock their valuables, personal effects and working files. Lockers may be assigned to individuals or used on a first come, first served basis.',
        descriptionToken: 'lockerDesc'
    },
    {
        id: '60',
        displayName: 'IT Storage Space',
        displayNameToken: 'storageITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '61',
        displayName: 'Secondary Server / Telecom Room',
        displayNameToken: 'secondaryServerRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Secondary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.',
        descriptionToken: 'secondaryServerRoomDesc'
    },
    {
        id: '62',
        displayName: "Mothers\u2019 Room",
        displayNameToken: 'mothersRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: "Mothers rooms are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Mothers rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'mothersRoomDesc'
    },
    {
        id: '63',
        displayName: 'Wellness Room',
        displayNameToken: 'wellnessRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: "Wellness rooms (formerly referred to as Mother\u2019s Rooms) are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Wellness rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'wellnessRoomDesc'
    },
    {
        id: '64',
        displayName: 'IT Build Space',
        displayNameToken: 'buildITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '65',
        displayName: 'Worker Council Office (2 people)',
        displayNameToken: 'workerCouncilOffice2Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '66',
        displayName: 'Security Control Room',
        displayNameToken: 'securityCtrlRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 217.9693,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '67',
        displayName: 'Centralised Mail',
        displayNameToken: 'centralisedMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 269.0979,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'For larger companies, a mail center is required for organizing incoming and outgoing mail. These space hold specialty production and mail equipment. There are also many surfaces for organizing paper and other materials. Usually manned by a full time staff member.',
        descriptionToken: 'centralisedDispersedMailAreaDesc'
    },
    {
        id: '68',
        displayName: 'Visitor Coat / Luggage Room',
        displayNameToken: 'visitorCoatLuggageRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 96.87524,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Visitors need a place to store their coats and other bulky items. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.',
        descriptionToken: 'visitorCoatLuggageRoomDesc'
    },
    {
        id: '69',
        displayName: 'Full Food Service',
        displayNameToken: 'fullFoodServiceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 300,
        maxSF: 2000,
        description: 'When providing an in-office dining service, there are multiple functions that come together to support this amenity including a kitchen, servery, dining room (seating), and dining support (storage). The kitchen and servery work together to prepare and serve the food made in-house. Dining is the place where employees and guests can sit and eat but often this space acts as a social and collaboration hub. Just like at home, there is a lot of equipment and food storage required to provide dining services, which is why dining support is included in the Full Food Service space type.',
        descriptionToken: 'fullFoodServiceDesc'
    },
    // GERMANY_REGULAR space units
    {
        id: '70',
        displayName: 'Small office',
        displayNameToken: 'smOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 107.6,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        // NOTE: this is a duplicate of space unit 39
        id: '71',
        displayName: 'Regular Office',
        displayNameToken: 'regOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 161.5,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '72',
        displayName: "5\u2019 Bench Desk",
        displayNameToken: 'benchDesk5Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 32.3,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '73',
        displayName: "6\u2019 Bench Desk",
        displayNameToken: 'benchDesk6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 43.1,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '74',
        displayName: 'Focus Room',
        displayNameToken: 'focusRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 86.1,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Focus Rooms are enclosed spaces intended to support focused and/or confidential work for typically one or two people. Acoustic privacy is paramount in these spaces. Focus Rooms are usually unassigned and can be booked temporarily on an as-needed basis for relevant work.',
        descriptionToken: 'focusRoomDesc'
    },
    {
        id: '75',
        displayName: 'Meeting Room (4 people)',
        displayNameToken: 'meetingRoom4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 215.3,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc'
    },
    {
        id: '76',
        displayName: 'Meeting Room (6 people)',
        displayNameToken: 'meetingRoom6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 301.4,
        seats: 6,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc6'
    },
    {
        id: '77',
        displayName: 'Meeting Room (8 people)',
        displayNameToken: 'meetingRoom8Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 376.7,
        seats: 8,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc8'
    },
    {
        id: '78',
        displayName: 'Meeting Room (12 people)',
        displayNameToken: 'meetingRoom12Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 409,
        seats: 12,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc12'
    },
    {
        id: '79',
        displayName: 'Meeting Room (15 people)',
        displayNameToken: 'meetingRoom15Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 430.6,
        seats: 15,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc15'
    },
    {
        // NOTE: this is a duplicate of space unit 48
        // the German team might want to change the size
        // the initial size they gave (193.8 sf) seemed like a typo, so we stuck with the UK size
        id: '80',
        displayName: 'Semi-Enclosed Meeting Booth (4 people)',
        displayNameToken: 'semiEnclosedMeetingBooth4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 43.1,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN
    },
    {
        id: '81',
        displayName: 'Open Collaboration Space (4-6 people)',
        displayNameToken: 'openCollabSpace4to6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 269.1,
        seats: 5,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'These areas are meant to support small groups (4-6 person) collaborative activities such as brainstorming and informal conversations between colleagues and with clients.',
        descriptionToken: 'openCollabSpace4to6Desc'
    },
    {
        id: '82',
        displayName: 'Centralised Copy, Print & Mail',
        displayNameToken: 'centralisedCopyPrintMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 107.64,
        maxSF: 1291.668
    },
    {
        id: '83',
        displayName: 'Special Resource Area',
        displayNameToken: 'specialResourceAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 161.46,
        maxSF: 1506.946
    },
    {
        id: '84',
        displayName: 'Personal Storage (lockers)',
        displayNameToken: 'personalStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 0
    },
    {
        id: '85',
        displayName: 'IT Storage Space',
        displayNameToken: 'storageITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 107.64,
        maxSF: 861.112
    },
    {
        id: '86',
        displayName: 'Secondary Server / Telecom Room',
        displayNameToken: 'secondaryServerRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 107.64,
        maxSF: 322.917
    },
    {
        id: '87',
        displayName: 'Contemplation Space',
        displayNameToken: 'contemplationSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 161.46,
        maxSF: 861.112
    },
    {
        id: '88',
        displayName: 'Main IT Server / Equipment Room',
        displayNameToken: 'mainITEquipRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 134.55,
        maxSF: 430.556
    },
    {
        id: '89',
        displayName: 'Reception Area',
        displayNameToken: 'receptionAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 430.56,
        maxSF: 2152.78
    },
    {
        id: '90',
        displayName: "Caf\xe9 / Food Service",
        displayNameToken: 'cafeFoodServiceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 215.28,
        maxSF: 4305.56
    },
    {
        id: '91',
        displayName: 'Team Storage',
        displayNameToken: 'teamStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 107.64,
        maxSF: 1076.39
    },
    {
        id: '92',
        displayName: 'Coat Closets',
        displayNameToken: 'coatClosetsDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 0
    },
    {
        id: '93',
        displayName: 'General Storage (stores and goods in/out)',
        displayNameToken: 'genStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 107.64,
        maxSF: 1076.39
    },
    {
        id: '94',
        displayName: "Mothers\u2019 Room",
        displayNameToken: 'mothersRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.46,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '95',
        displayName: 'Wellness Room',
        displayNameToken: 'wellnessRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 134.55,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '96',
        displayName: 'IT Build Space',
        displayNameToken: 'buildITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 86.11,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '97',
        displayName: 'Worker Council Office (2 people)',
        displayNameToken: 'workerCouncilOffice2Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 193.75,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '98',
        displayName: 'Security Control Room',
        displayNameToken: 'securityCtrlRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 107.64,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '99',
        displayName: 'Centralised Mail',
        displayNameToken: 'centralisedMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.46,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '100',
        displayName: 'Visitor Coat / Luggage Room',
        displayNameToken: 'visitorCoatLuggageRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 107.64,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    // APAC_REGULAR space units
    {
        id: '101',
        displayName: 'Office (Work/Meet)',
        displayNameToken: 'officeWorkMeetDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 118.4,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '102',
        displayName: 'Large Office (Work/Meet)',
        displayNameToken: 'lgOfficeWorkMeetDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 161.5,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '103',
        displayName: '1.6 Bench',
        displayNameToken: 'bench1pt6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 34.4,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '104',
        displayName: '1.8 Bench',
        displayNameToken: 'bench1pt8Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 40.9,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        // This space unit is not included in any KOPWMs
        id: '105',
        displayName: "1.8 \u2019L\u2019 Workstation",
        displayNameToken: 'bench1pt8LDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 38,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN
    },
    {
        // NOTE: this is a duplicate of space unit 6
        // Deprecated in favor of space unit 131
        id: '106',
        displayName: 'Focus',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 60,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Focus Rooms are enclosed spaces intended to support focused and/or confidential work for typically one or two people. Acoustic privacy is paramount in these spaces. Focus Rooms are usually unassigned and can be booked temporarily on an as-needed basis for relevant work.'
    },
    {
        id: '107',
        displayName: 'Banquet - Work/Meet (2p)',
        displayNameToken: 'banquetWorkMeetDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 30,
        seats: 2,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN
    },
    {
        id: '108',
        displayName: "Caf\xe9 Table (4p)",
        displayNameToken: 'cafeTable4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 60,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN
    },
    {
        id: '109',
        displayName: 'Kitchen Table (8-10p)',
        displayNameToken: 'kitchenTable8to10Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 100,
        seats: 8,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN
    },
    {
        id: '110',
        displayName: 'Standing Whiteboard',
        displayNameToken: 'standingWhiteboardDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 35,
        seats: 3,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN
    },
    {
        id: '111',
        displayName: 'Huddle Room (3p)',
        displayNameToken: 'huddleRoom3Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 80,
        seats: 3,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Huddle Rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'huddleRoomDesc'
    },
    {
        // NOTE: this is a duplicate of space unit 8
        id: '112',
        displayName: 'Sm Meeting Room (5p)',
        displayNameToken: 'smMeetingRoom5Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 120,
        seats: 5,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'A small conference room is an enclosed meeting space intended to comfortably accommodate 2-6 people at the table. These rooms can be used for both internal and client-facing meetings and should therefore be very user friendly with easy access to power and A/V capabilities.',
        descriptionToken: 'smMeetingConferenceRoomDesc'
    },
    {
        id: '113',
        displayName: 'M Meeting Room (8p)',
        displayNameToken: 'mdMeetingRoom8Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 200,
        seats: 8,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'A medium conference room is an enclosed meeting space intended to comfortably accommodate 6-10 people at the table. These rooms are used for both internal and client-facing meetings and should therefore be very user friendly with easy access to power and A/V capabilities.',
        descriptionToken: 'mdMeetingConferenceRoomDesc'
    },
    {
        id: '114',
        displayName: 'L Meeting Room (20p)',
        displayNameToken: 'lgMeetingRoom20Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 450,
        seats: 20,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'A large conference room is an enclosed meeting space intended to comfortably accommodate 12-14 people at the table, overflow seating along the perimeter of the room is desirable. These rooms can be used for both internal and client-facing meetings and are likely to be used for presentations.',
        descriptionToken: 'lgMeetingConferenceRoomDesc'
    },
    {
        id: '115',
        displayName: 'X-Large / Boardroom',
        displayNameToken: 'xlBoardroom',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 750,
        seats: 30,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'A boardroom conference room is intended to comfortably accommodate 14-18 people at the table, with overflow seating along the perimeter of the room for at least 10 more. These rooms will most likely be used for large internal formal meetings and large client-facing meetings. As such, they should be equipped with robust A/V technology and should be branded as client facing-space.',
        descriptionToken: 'xlMeetingRoomDesc'
    },
    {
        // NOTE: this is a duplicate of space unit 25
        // Deprecated
        id: '116',
        displayName: 'Front Desk',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 300,
        description: 'This is first stop when employees and visitors come to the office. The desk should be able to accommodate at least one person with person workspace and storage. There will likely be vistor storage nearby as well. The front desk is placed within the larger reception hub where there will likely be seating and other accommodations.'
    },
    {
        // NOTE: this is a duplicate of space unit 26
        // Deprecated in favor of space unit 141
        id: '117',
        displayName: 'Central Reception Hub',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 800,
        maxSF: 3000,
        description: "The reception area is your company\u2019s first opportunity to make an impression on employees, clients and  other visitors. It should consistently convey the company\u2019s brand and project the desired appearance. The concierge desk should comfortably house a concierge; soft-seating should be inviting to visitors."
    },
    {
        // NOTE: this is a duplicate of space unit 33
        // Deprecated in favor of space unit 146
        id: '118',
        displayName: 'Juice Bar / Coffee Shop',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 100,
        description: 'While a company might not have a full kitchen and servery, it may provide a coffee shop or juice bar as part of the food/drink amenities in the space. An organization might also have this kind of space in addition to its main dining services, especially if the office is large. This space will likely look like your local Starbucks with a working area for a staffer person separated by a serving counter.'
    },
    {
        // NOTE: this is a duplicate of space unit 36
        // Deprecated
        id: '119',
        displayName: 'Grab-N-Go',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 100,
        description: 'A small convenience area with several fridges, shelves for chips and snacks, and a checkout machine.  These Grab-N-Go spaces are typically monitored for security by camera. These spaces are often combined with a small pantry with fridges and freezers and prep area for food.'
    },
    {
        // NOTE: this is a duplicate of space unit 15
        // Deprecated in favor of space unit 132
        id: '120',
        displayName: 'Dispersed Copy / Print Area',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 120,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Spread across the floor in open workspace, copy/print areas give employees quick access to multi-function devices from all neighborhoods. Bins for recycling should always be collocated with copy/print areas, as well as small cabinets to house extra paper and supplies. These spaces are for drop-in purposes only and are not intended to double as social/work areas.'
    },
    {
        // NOTE: this is a duplicate of space unit 16
        // Deprecated in favor of space unit 133
        id: '121',
        displayName: 'Pantry / Vending / Coffee',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 240,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Unlike the central cafe, the pantry/vending/coffee area is meant for employees to grab the quick food and drink essentials that they need. Buzz and conversation is naturally found in areas with food, but these spaces usually do not contain seating, causing people to come and go quickly without spending an extensive amount of time socializing.'
    },
    {
        // NOTE: this is a duplicate of space unit 17
        // Deprecated
        id: '122',
        displayName: 'Workplace Storage',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 120,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.'
    },
    {
        // NOTE: this is a duplicate of space unit 18
        // Deprecated in favor of space unit 135
        id: '123',
        displayName: 'Wellness Rooms',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 60,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: "Wellness rooms (formerly referred to as Mother\u2019s Rooms) are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Wellness rooms are a usually a requirement for all new offices, regardless of size or headcount."
    },
    {
        // NOTE: this is a duplicate of space unit 19, with a different displayName
        id: '124',
        displayName: 'Employee Coats / Gym Lockers',
        displayNameToken: 'employeeCoatsGymLockersDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 40,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Employees need a place to store their coats and other bulky items, especially when an office has an open layout with limited personal storage at the desk. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.',
        descriptionToken: 'coatClosetsDesc'
    },
    {
        // NOTE: this is a duplicate of space unit 20
        id: '125',
        displayName: 'Dispersed Mail Area',
        displayNameToken: 'dispersedMailAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 60,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'For larger companies, a mail center is required for organizing incoming and outgoing mail. These space hold specialty production and mail equipment. There are also many surfaces for organizing paper and other materials. Usually manned by a full time staff member.',
        descriptionToken: 'centralisedDispersedMailAreaDesc'
    },
    {
        // NOTE: this is a duplicate of space unit 21
        id: '126',
        displayName: 'File Room',
        displayNameToken: 'fileRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 120,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'This is paper file storage for individuals and teams. As a result of most offices digitization efforts, the need for both individual and team file storage is diminishing greatly. Still, this is a central space for legally required document copies or long term project materials, especially with most open office desks containing little storage.',
        descriptionToken: 'fileRoomDesc'
    },
    {
        // NOTE: this is a duplicate of space unit 22
        // Deprecated in favor of space unit 136
        id: '127',
        displayName: '3 Drawer Lateral File',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 3,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Personal storage for individuals at desks or offices. Contents are usually personal or active project materials.'
    },
    {
        // NOTE: this is a duplicate of space unit 23
        id: '128',
        displayName: 'Lockers',
        displayNameToken: 'lockersDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 2,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Lockers are provided as another form of individual storage. They give employees a space to lock their valuables, personal effects and working files. Lockers may be assigned to individuals or used on a first come, first served basis.',
        descriptionToken: 'lockerDesc'
    },
    {
        // Deprecated in favor of space unit 137
        id: '129',
        displayName: 'Server Room (central)',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 30,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Primary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.'
    },
    {
        // Deprecated in favor of space unit 137
        id: '130',
        displayName: 'Hub Room (per floor)',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 40,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED
    },
    {
        // NOTE: this is similar to space unit 6, but is a WE space, and doesn't include "Room" in the displayName
        id: '131',
        displayName: 'Focus',
        displayNameToken: 'focusDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 60,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Focus Rooms are enclosed spaces intended to support focused and/or confidential work for typically one or two people. Acoustic privacy is paramount in these spaces. Focus Rooms are usually unassigned and can be booked temporarily on an as-needed basis for relevant work.',
        descriptionToken: 'focusRoomDesc'
    },
    {
        id: '132',
        displayName: 'Dispersed Copy / Print / Scan Area',
        displayNameToken: 'dispersedCopyPrintScanAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 80,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED
    },
    {
        id: '133',
        displayName: 'Hydration Point (Water / Tea / Coffee)',
        displayNameToken: 'hydrationPointDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 50,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED
    },
    {
        id: '134',
        displayName: 'Central High Density Storage',
        displayNameToken: 'centralHighDensityStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 60,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED
    },
    {
        id: '135',
        displayName: "Wellness / Mothers\u2019 Room",
        displayNameToken: 'wellnessMothersRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 70,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED
    },
    {
        id: '136',
        displayName: '3 Drawer Lateral File',
        displayNameToken: 'drawerLateralFileDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.UNITS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 10,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Personal storage for individuals at desks or offices. Contents are usually personal or active project materials.',
        descriptionToken: 'drawerLateralFileDesc'
    },
    {
        id: '137',
        displayName: 'Server / Hub Rooms',
        displayNameToken: 'serverHubRoomsDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 50,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED
    },
    {
        // NOTE: this is a duplicate of space unit 30
        id: '138',
        displayName: 'Internal Stair',
        displayNameToken: 'internalStairDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 500,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.BLENDED,
        description: 'Internal stairs can be activated stairwells in the core that provide access between floors, or it can be additional feature elements that connect floors of an office. Can often be a gather space within the office and can be centralized for cafe, reception, or meeting spaces.',
        descriptionToken: 'internalStairDesc'
    },
    {
        id: '139',
        displayName: 'IT Build / Store Room',
        displayNameToken: 'buildITStoreRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 80,
        maxSF: 250
    },
    {
        id: '140',
        displayName: 'Simple Reception + Wait',
        displayNameToken: 'simpleReceptionWaitDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        maxSF: 500
    },
    {
        id: '141',
        displayName: 'Central Reception Hub',
        displayNameToken: 'centralReceptionHubDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        maxSF: 1200,
        description: "The reception area is your company\u2019s first opportunity to make an impression on employees, clients and other visitors. It should consistently convey the company\u2019s brand and project the desired appearance. The concierge desk should comfortably house a concierge; soft-seating should be inviting to visitors.",
        descriptionToken: 'centralReceptionHubDesc'
    },
    {
        id: '142',
        displayName: "Central Caf\xe9 Social Hub",
        displayNameToken: 'centralCafeSocialHubDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        maxSF: 1200,
        description: 'The central cafe is intended to be an area for eating, social interaction, individual work and small meetings. Functional eating furniture and a branded color palette should be considered in the design of this space.',
        descriptionToken: 'cafeFoodServiceDesc'
    },
    {
        id: '143',
        displayName: 'Mail Centre',
        displayNameToken: 'mailCentreDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 80,
        maxSF: 250
    },
    {
        id: '144',
        displayName: 'Utility Store Room',
        displayNameToken: 'utilityStoreRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 30,
        maxSF: 60
    },
    {
        id: '144',
        displayName: 'Utility Store Room',
        displayNameToken: 'utilityStoreRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 30,
        maxSF: 60
    },
    {
        id: '145',
        displayName: 'Commercial Print Room',
        displayNameToken: 'commercialPrintRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        maxSF: 500,
        description: 'Often combined with the mailroom, companies provide in house capabilities to print, bind, and compile presentations in the print room. There will be several printers, and might include large format printers. Spaces will include storage space for supplies, and will also include counter space for smaller equipment but also space to layout prints.',
        descriptionToken: 'commercialPrintRoomDesc'
    },
    {
        id: '146',
        displayName: 'Juice Bar / Coffee Shop',
        displayNameToken: 'juiceBarCoffeeShopDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        maxSF: 300,
        description: 'While a company might not have a full kitchen and servery, it may provide a coffee shop or juice bar as part of the food/drink amenities in the space. An organization might also have this kind of space in addition to its main dining services, especially if the office is large. This space will likely look like your local Starbucks with a working area for a staffer person separated by a serving counter.',
        descriptionToken: 'juiceBarCoffeeShopDesc'
    },
    {
        id: '147',
        displayName: 'Building Support Services',
        displayNameToken: 'buildingSupportServicesDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 100,
        maxSF: 200,
        description: 'This is a catch all for additional support spaces that might occur in an office. One could be a security desk or facilities while another could be a utilities space. This varies across organizations, but as the size of the office increases, ancillary spaces like this become more likely and necessary.',
        descriptionToken: 'specialResourceBuildingSupportAreaDesc'
    },
    // SPAIN_REGULAR space units
    {
        id: '148',
        displayName: 'Small office',
        displayNameToken: 'smOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 129.17,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        // NOTE: this is a duplicate of space unit 39
        id: '149',
        displayName: 'Regular Office',
        displayNameToken: 'regOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 172.22,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '150',
        displayName: "5\u2019 Bench Desk",
        displayNameToken: 'benchDesk5Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 24.11,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '151',
        displayName: "6\u2019 Bench Desk",
        displayNameToken: 'benchDesk6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 27.56,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '152',
        displayName: 'Focus Room',
        displayNameToken: 'focusRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 64.58,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Focus Rooms are enclosed spaces intended to support focused and/or confidential work for typically one or two people. Acoustic privacy is paramount in these spaces. Focus Rooms are usually unassigned and can be booked temporarily on an as-needed basis for relevant work.',
        descriptionToken: 'focusRoomDesc'
    },
    {
        id: '153',
        displayName: 'Meeting Room (4 people)',
        displayNameToken: 'meetingRoom4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 107.64,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc'
    },
    {
        id: '154',
        displayName: 'Meeting Room (6 people)',
        displayNameToken: 'meetingRoom6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 172.22,
        seats: 6,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc6'
    },
    {
        id: '155',
        displayName: 'Meeting Room (8 people)',
        displayNameToken: 'meetingRoom8Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 215.28,
        seats: 8,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc8'
    },
    {
        id: '156',
        displayName: 'Meeting Room (12 people)',
        displayNameToken: 'meetingRoom12Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 387.5,
        seats: 12,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc12'
    },
    {
        id: '157',
        displayName: 'Meeting Room (15 people)',
        displayNameToken: 'meetingRoom15Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 538.2,
        seats: 15,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc15'
    },
    {
        id: '158',
        displayName: 'Semi-Enclosed Meeting Booth (4 people)',
        displayNameToken: 'semiEnclosedMeetingBooth4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 129.17,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN
    },
    {
        id: '159',
        displayName: 'Open Collaboration Space (4-6 people)',
        displayNameToken: 'openCollabSpace4to6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 107.64,
        seats: 5,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'These areas are meant to support small groups (4-6 person) collaborative activities such as brainstorming and informal conversations between colleagues and with clients.',
        descriptionToken: 'openCollabSpace4to6Desc'
    },
    {
        id: '160',
        displayName: 'Centralised Copy, Print & Mail',
        displayNameToken: 'centralisedCopyPrintMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '161',
        displayName: 'Special Resource Area',
        displayNameToken: 'specialResourceAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '162',
        displayName: 'Personal Storage (lockers)',
        displayNameToken: 'personalStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 0
    },
    {
        id: '163',
        displayName: 'IT Storage Space',
        displayNameToken: 'storageITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 161.46,
        maxSF: 430.56
    },
    {
        id: '164',
        displayName: 'Secondary Server / Telecom Room',
        displayNameToken: 'secondaryServerRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '165',
        displayName: 'Main IT Server / Equipment Room',
        displayNameToken: 'mainITEquipRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 236.81,
        maxSF: 505.9
    },
    {
        id: '166',
        displayName: 'Reception Area',
        displayNameToken: 'receptionAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 236.81,
        maxSF: 505.9
    },
    {
        id: '167',
        displayName: "Caf\xe9 / Food Service",
        displayNameToken: 'cafeFoodServiceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 200,
        maxSF: 1000
    },
    {
        id: '168',
        displayName: 'Team Storage',
        displayNameToken: 'teamStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 107.64,
        maxSF: 322.92
    },
    {
        id: '169',
        displayName: 'Coat Closets',
        displayNameToken: 'coatClosetsDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 43.06,
        maxSF: 322.92
    },
    {
        id: '170',
        displayName: 'General Storage (stores and goods in/out)',
        displayNameToken: 'genStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 53.82,
        maxSF: 2317.23
    },
    {
        id: '171',
        displayName: "Mothers\u2019/Medical Room",
        displayNameToken: 'mothersRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 134.5,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '172',
        displayName: 'IT Build Space',
        displayNameToken: 'buildITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 86,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '173',
        displayName: 'Security Control Room',
        displayNameToken: 'securityCtrlRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 107.6,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '174',
        displayName: 'Centralised Mail',
        displayNameToken: 'centralisedMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.4,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '175',
        displayName: 'Visitor Coat / Luggage Room',
        displayNameToken: 'visitorCoatLuggageRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 86,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    // FRANCE_REGULAR space units
    {
        id: '176',
        displayName: 'Small office',
        displayNameToken: 'smOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 129.17,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        // NOTE: this is a duplicate of space unit 39
        id: '177',
        displayName: 'Regular Office',
        displayNameToken: 'regOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 172.22,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '178',
        displayName: "5\u2019 Bench Desk",
        displayNameToken: 'benchDesk5Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 24.11,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '179',
        displayName: "6\u2019 Bench Desk",
        displayNameToken: 'benchDesk6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 27.56,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '180',
        displayName: 'Focus Room',
        displayNameToken: 'focusRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 64.58,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Focus Rooms are enclosed spaces intended to support focused and/or confidential work for typically one or two people. Acoustic privacy is paramount in these spaces. Focus Rooms are usually unassigned and can be booked temporarily on an as-needed basis for relevant work.',
        descriptionToken: 'focusRoomDesc'
    },
    {
        id: '181',
        displayName: 'Meeting Room (4 people)',
        displayNameToken: 'meetingRoom4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 86.1,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc'
    },
    {
        id: '182',
        displayName: 'Meeting Room (6 people)',
        displayNameToken: 'meetingRoom6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 129.2,
        seats: 6,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc6'
    },
    {
        id: '183',
        displayName: 'Meeting Room (8 people)',
        displayNameToken: 'meetingRoom8Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 172.2,
        seats: 8,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc8'
    },
    {
        id: '184',
        displayName: 'Meeting Room (12 people)',
        displayNameToken: 'meetingRoom12Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 258.3,
        seats: 12,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc12'
    },
    {
        id: '185',
        displayName: 'Meeting Room (15 people)',
        displayNameToken: 'meetingRoom15Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 322.9,
        seats: 15,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc15'
    },
    {
        id: '186',
        displayName: 'Semi-Enclosed Meeting Booth (4 people)',
        displayNameToken: 'semiEnclosedMeetingBooth4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 107.6,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN
    },
    {
        id: '187',
        displayName: 'Open Collaboration Space (4-6 people)',
        displayNameToken: 'openCollabSpace4to6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 161.5,
        seats: 5,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'These areas are meant to support small groups (4-6 person) collaborative activities such as brainstorming and informal conversations between colleagues and with clients.',
        descriptionToken: 'openCollabSpace4to6Desc'
    },
    {
        id: '188',
        displayName: 'Centralised Copy, Print & Mail',
        displayNameToken: 'centralisedCopyPrintMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 172.22,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '189',
        displayName: 'Personal Storage (lockers)',
        displayNameToken: 'personalStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 538.2,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '190',
        displayName: 'IT Storage Space',
        displayNameToken: 'storageITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 269.1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '191',
        displayName: 'Secondary Server / Telecom Room',
        displayNameToken: 'secondaryServerRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 161.46,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '192',
        displayName: 'Contemplation Space',
        displayNameToken: 'contemplationSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 215.28,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 161.46,
        maxSF: 290.63
    },
    {
        id: '193',
        displayName: 'Main IT Server / Equipment Room',
        displayNameToken: 'mainITEquipRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 376.74,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 236.81,
        maxSF: 505.9
    },
    {
        id: '194',
        displayName: 'Reception Area',
        displayNameToken: 'receptionAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 430.56,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 236.81,
        maxSF: 505.9
    },
    {
        id: '195',
        displayName: "Caf\xe9 / Food Service",
        displayNameToken: 'cafeFoodServiceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 645.83,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 200,
        maxSF: 1000
    },
    {
        id: '196',
        displayName: 'Team Storage',
        displayNameToken: 'teamStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 129.17,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 120,
        maxSF: 500
    },
    {
        id: '197',
        displayName: 'Coat Closets',
        displayNameToken: 'coatClosetsDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 172.22,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 40,
        maxSF: 150
    },
    {
        id: '198',
        displayName: "Mothers\u2019 Room",
        displayNameToken: 'mothersRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 129.2,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: "Mothers rooms are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Mothers rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'mothersRoomDesc'
    },
    {
        id: '199',
        displayName: 'Wellness Room',
        displayNameToken: 'wellnessRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 172.2,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: "Wellness rooms (formerly referred to as Mother\u2019s Rooms) are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Wellness rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'wellnessRoomDesc'
    },
    {
        id: '200',
        displayName: 'IT Build Space',
        displayNameToken: 'buildITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 86.1,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '201',
        displayName: 'Worker Council Office (2 people)',
        displayNameToken: 'workerCouncilOffice2Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 129.2,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '202',
        displayName: 'Security Control Room',
        displayNameToken: 'securityCtrlRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 172.2,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '203',
        displayName: 'Centralised Mail',
        displayNameToken: 'centralisedMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.5,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '204',
        displayName: 'Visitor Coat / Luggage Room',
        displayNameToken: 'visitorCoatLuggageRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 86.1,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '205',
        displayName: 'Focus Room',
        displayNameToken: 'focusRoomSharedFocus',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SHARED_FOCUS,
        sf: 60,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED
    },
    // SLOVAKIA_REGULAR space units
    {
        id: '206',
        displayName: 'Small Office',
        displayNameToken: 'smOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 107.6,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '207',
        displayName: 'Regular Office',
        displayNameToken: 'regOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 150.7,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '208',
        displayName: "5\u2019 Bench Desk",
        displayNameToken: 'benchDesk5Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 32.3,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '209',
        displayName: "6\u2019 Bench Desk",
        displayNameToken: 'benchDesk6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 32.3,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '210',
        displayName: 'Focus Room',
        displayNameToken: 'focusRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 64.6,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Focus Rooms are enclosed spaces intended to support focused and/or confidential work for typically one or two people. Acoustic privacy is paramount in these spaces. Focus Rooms are usually unassigned and can be booked temporarily on an as-needed basis for relevant work.',
        descriptionToken: 'focusRoomDesc'
    },
    {
        id: '211',
        displayName: 'Meeting Room (4 people)',
        displayNameToken: 'meetingRoom4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 107.6,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc'
    },
    {
        id: '212',
        displayName: 'Meeting Room (6 people)',
        displayNameToken: 'meetingRoom6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 150.7,
        seats: 6,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc6'
    },
    {
        id: '213',
        displayName: 'Meeting Room (8 people)',
        displayNameToken: 'meetingRoom8Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 215.3,
        seats: 8,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc8'
    },
    {
        id: '214',
        displayName: 'Meeting Room (12 people)',
        displayNameToken: 'meetingRoom12Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 323,
        seats: 12,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc12'
    },
    {
        id: '215',
        displayName: 'Meeting Room (15 people)',
        displayNameToken: 'meetingRoom15Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 430.6,
        seats: 15,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc15'
    },
    {
        id: '216',
        displayName: 'Semi-Enclosed Meeting Booth (4 people)',
        displayNameToken: 'semiEnclosedMeetingBooth4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 64.6,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN
    },
    {
        id: '217',
        displayName: 'Open Collaboration Space (4-6 people)',
        displayNameToken: 'openCollabSpace4to6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 150.7,
        seats: 5,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'These areas are meant to support small groups (4-6 person) collaborative activities such as brainstorming and informal conversations between colleagues and with clients.',
        descriptionToken: 'openCollabSpace4to6Desc'
    },
    {
        id: '218',
        displayName: 'Contemplation Space',
        displayNameToken: 'contemplationSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 107.639,
        maxSF: 161.459
    },
    {
        id: '219',
        displayName: 'Main IT Server / Equipment Room',
        displayNameToken: 'mainITEquipRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 215.278,
        maxSF: 322.917,
        description: 'Primary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.',
        descriptionToken: 'mainITandServerRoomDesc'
    },
    {
        id: '220',
        displayName: 'Reception Area',
        displayNameToken: 'receptionAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 269.098,
        maxSF: 538.196,
        description: "The reception area is your company\u2019s first opportunity to make an impression on employees, clients and other visitors. It should consistently convey the company\u2019s brand and project the desired appearance. The concierge desk should comfortably house a concierge; soft-seating should be inviting to visitors.",
        descriptionToken: 'centralReceptionHubDesc'
    },
    {
        id: '221',
        displayName: "Caf\xe9 / Food Service",
        displayNameToken: 'cafeFoodServiceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 161.459,
        maxSF: 645.835,
        description: 'The central cafe is intended to be an area for eating, social interaction, individual work and small meetings. Functional eating furniture and a branded color palette should be considered in the design of this space.',
        descriptionToken: 'cafeFoodServiceDesc'
    },
    {
        id: '222',
        displayName: 'Team Storage',
        displayNameToken: 'teamStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 86.1113,
        maxSF: 215.278,
        description: 'Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.',
        descriptionToken: 'storageDesc'
    },
    {
        id: '223',
        displayName: 'Coat Closets',
        displayNameToken: 'coatClosetsDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 32.2917,
        maxSF: 107.639,
        description: 'Employees need a place to store their coats and other bulky items, especially when an office has an open layout with limited personal storage at the desk. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.',
        descriptionToken: 'coatClosetsDesc'
    },
    {
        id: '224',
        displayName: 'General Storage (stores and goods in/out)',
        displayNameToken: 'genStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 86.1113,
        maxSF: 322.917,
        description: 'Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.',
        descriptionToken: 'storageDesc'
    },
    {
        id: '225',
        displayName: 'Centralised Copy, Print & Mail',
        displayNameToken: 'centralisedCopyPrintMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 86.1113,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Spread across the floor in open workspace, copy/print areas give employees quick access to multi-function devices from all neighborhoods. Bins for recycling should always be collocated with copy/print areas, as well as small cabinets to house extra paper and supplies. These spaces are for drop-in purposes only and are not intended to double as social/work areas.',
        descriptionToken: 'copyPrintDesc'
    },
    {
        id: '226',
        displayName: 'Special Resource Area',
        displayNameToken: 'specialResourceAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 86.1113,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'This is a catch all for additional support spaces that might occur in an office. One could be a security desk or facilities while another could be a utilities space. This varies across organizations, but as the size of the office increases, ancillary spaces like this become more likely and necessary.',
        descriptionToken: 'specialResourceBuildingSupportAreaDesc'
    },
    {
        id: '227',
        displayName: 'Personal Storage (lockers)',
        displayNameToken: 'personalStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 2.152783,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Lockers are provided as another form of individual storage. They give employees a space to lock their valuables, personal effects and working files. Lockers may be assigned to individuals or used on a first come, first served basis.',
        descriptionToken: 'lockerDesc'
    },
    {
        id: '228',
        displayName: 'IT Storage Space',
        displayNameToken: 'storageITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 129.167,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '229',
        displayName: 'Secondary Server / Telecom Room',
        displayNameToken: 'secondaryServerRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 129.167,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Secondary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.',
        descriptionToken: 'secondaryServerRoomDesc'
    },
    {
        id: '230',
        displayName: "Mothers\u2019 Room",
        displayNameToken: 'mothersRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 129.167,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: "Mothers rooms are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Mothers rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'mothersRoomDesc'
    },
    {
        id: '231',
        displayName: 'Wellness Room',
        displayNameToken: 'wellnessRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 150.695,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: "Wellness rooms (formerly referred to as Mother\u2019s Rooms) are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Wellness rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'wellnessRoomDesc'
    },
    {
        id: '232',
        displayName: 'IT Build Space',
        displayNameToken: 'buildITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 107.639,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '233',
        displayName: 'Worker Council Office (2 people)',
        displayNameToken: 'workerCouncilOffice2Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 107.639,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '234',
        displayName: 'Security Control Room',
        displayNameToken: 'securityCtrlRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 129.167,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '235',
        displayName: 'Centralised Mail',
        displayNameToken: 'centralisedMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 215.278,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'For larger companies, a mail center is required for organizing incoming and outgoing mail. These space hold specialty production and mail equipment. There are also many surfaces for organizing paper and other materials. Usually manned by a full time staff member.',
        descriptionToken: 'centralisedDispersedMailAreaDesc'
    },
    {
        id: '236',
        displayName: 'Visitor Coat / Luggage Room',
        displayNameToken: 'visitorCoatLuggageRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 86.1113,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Visitors need a place to store their coats and other bulky items. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.',
        descriptionToken: 'visitorCoatLuggageRoomDesc'
    },
    {
        id: '237',
        displayName: 'Full Food Service',
        displayNameToken: 'fullFoodServiceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 269.098,
        maxSF: 1291.67,
        description: 'When providing an in-office dining service, there are multiple functions that come together to support this amenity including a kitchen, servery, dining room (seating), and dining support (storage). The kitchen and servery work together to prepare and serve the food made in-house. Dining is the place where employees and guests can sit and eat but often this space acts as a social and collaboration hub. Just like at home, there is a lot of equipment and food storage required to provide dining services, which is why dining support is included in the Full Food Service space type.',
        descriptionToken: 'fullFoodServiceDesc'
    },
    // POLAND_REGULAR space units
    {
        id: '238',
        displayName: 'Small Office',
        displayNameToken: 'smOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 1,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        minSF: 86.1113,
        maxSF: 118.403,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '239',
        displayName: 'Regular Office',
        displayNameToken: 'regOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 161.459,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '240',
        displayName: "5\u2019 Bench Desk",
        displayNameToken: 'benchDesk5Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 53.8196,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '241',
        displayName: "6\u2019 Bench Desk",
        displayNameToken: 'benchDesk6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 53.8196,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '242',
        displayName: 'Focus Room',
        displayNameToken: 'focusRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 1,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        minSF: 53.8196,
        maxSF: 75.3474,
        description: 'Focus Rooms are enclosed spaces intended to support focused and/or confidential work for typically one or two people. Acoustic privacy is paramount in these spaces. Focus Rooms are usually unassigned and can be booked temporarily on an as-needed basis for relevant work.',
        descriptionToken: 'focusRoomDesc'
    },
    {
        id: '243',
        displayName: 'Meeting Room (4 people)',
        displayNameToken: 'meetingRoom4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 86.1113,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc'
    },
    {
        id: '244',
        displayName: 'Meeting Room (6 people)',
        displayNameToken: 'meetingRoom6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 129.167,
        seats: 6,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc6'
    },
    {
        id: '245',
        displayName: 'Meeting Room (8 people)',
        displayNameToken: 'meetingRoom8Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 172.223,
        seats: 8,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc8'
    },
    {
        id: '246',
        displayName: 'Meeting Room (12 people)',
        displayNameToken: 'meetingRoom12Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 258.334,
        seats: 12,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc12'
    },
    {
        id: '247',
        displayName: 'Meeting Room (15 people)',
        displayNameToken: 'meetingRoom15Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 322.917,
        seats: 15,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc15'
    },
    {
        id: '248',
        displayName: 'Semi-Enclosed Meeting Booth (4 people)',
        displayNameToken: 'semiEnclosedMeetingBooth4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 43.0556,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN
    },
    {
        id: '249',
        displayName: 'Open Collaboration Space (4-6 people)',
        displayNameToken: 'openCollabSpace4to6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 236.806,
        seats: 5,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'These areas are meant to support small groups (4-6 person) collaborative activities such as brainstorming and informal conversations between colleagues and with clients.',
        descriptionToken: 'openCollabSpace4to6Desc'
    },
    {
        id: '250',
        displayName: 'Contemplation Space',
        displayNameToken: 'contemplationSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 161.4587,
        maxSF: 290.6257
    },
    {
        id: '251',
        displayName: 'Main IT Server / Equipment Room',
        displayNameToken: 'mainITEquipRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 236.8061,
        maxSF: 505.904,
        description: 'Primary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.',
        descriptionToken: 'mainITandServerRoomDesc'
    },
    {
        id: '252',
        displayName: 'Reception Area',
        displayNameToken: 'receptionAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 236.8061,
        maxSF: 505.904,
        description: "The reception area is your company\u2019s first opportunity to make an impression on employees, clients and other visitors. It should consistently convey the company\u2019s brand and project the desired appearance. The concierge desk should comfortably house a concierge; soft-seating should be inviting to visitors.",
        descriptionToken: 'centralReceptionHubDesc'
    },
    {
        id: '253',
        displayName: "Caf\xe9 / Food Service",
        displayNameToken: 'cafeFoodServiceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 200,
        maxSF: 1000,
        description: 'The central cafe is intended to be an area for eating, social interaction, individual work and small meetings. Functional eating furniture and a branded color palette should be considered in the design of this space.',
        descriptionToken: 'cafeFoodServiceDesc'
    },
    {
        id: '254',
        displayName: 'Team Storage',
        displayNameToken: 'teamStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 120,
        maxSF: 500,
        description: 'Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.',
        descriptionToken: 'storageDesc'
    },
    {
        id: '255',
        displayName: 'Coat Closets',
        displayNameToken: 'coatClosetsDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 40,
        maxSF: 150,
        description: 'Employees need a place to store their coats and other bulky items, especially when an office has an open layout with limited personal storage at the desk. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.',
        descriptionToken: 'coatClosetsDesc'
    },
    {
        id: '256',
        displayName: 'General Storage (stores and goods in/out)',
        displayNameToken: 'genStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 80,
        maxSF: 500,
        description: 'Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.',
        descriptionToken: 'storageDesc'
    },
    {
        id: '257',
        displayName: 'Centralised Copy, Print & Mail',
        displayNameToken: 'centralisedCopyPrintMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 199.1324,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Spread across the floor in open workspace, copy/print areas give employees quick access to multi-function devices from all neighborhoods. Bins for recycling should always be collocated with copy/print areas, as well as small cabinets to house extra paper and supplies. These spaces are for drop-in purposes only and are not intended to double as social/work areas.',
        descriptionToken: 'copyPrintDesc'
    },
    {
        id: '258',
        displayName: 'Special Resource Area',
        displayNameToken: 'specialResourceAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 86.11132,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'This is a catch all for additional support spaces that might occur in an office. One could be a security desk or facilities while another could be a utilities space. This varies across organizations, but as the size of the office increases, ancillary spaces like this become more likely and necessary.',
        descriptionToken: 'specialResourceBuildingSupportAreaDesc'
    },
    {
        id: '259',
        displayName: 'Personal Storage (lockers)',
        displayNameToken: 'personalStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 2.152783,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Lockers are provided as another form of individual storage. They give employees a space to lock their valuables, personal effects and working files. Lockers may be assigned to individuals or used on a first come, first served basis.',
        descriptionToken: 'lockerDesc'
    },
    {
        id: '260',
        displayName: 'IT Storage Space',
        displayNameToken: 'storageITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '261',
        displayName: 'Secondary Server / Telecom Room',
        displayNameToken: 'secondaryServerRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Secondary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.',
        descriptionToken: 'secondaryServerRoomDesc'
    },
    {
        id: '262',
        displayName: "Mothers\u2019 Room",
        displayNameToken: 'mothersRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 86.1113,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: "Mothers rooms are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Mothers rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'mothersRoomDesc'
    },
    {
        id: '263',
        displayName: 'Wellness Room',
        displayNameToken: 'wellnessRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: "Wellness rooms (formerly referred to as Mother\u2019s Rooms) are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Wellness rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'wellnessRoomDesc'
    },
    {
        id: '264',
        displayName: 'IT Build Space',
        displayNameToken: 'buildITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '265',
        displayName: 'Worker Council Office (2 people)',
        displayNameToken: 'workerCouncilOffice2Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '266',
        displayName: 'Security Control Room',
        displayNameToken: 'securityCtrlRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 269.098,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '267',
        displayName: 'Centralised Mail',
        displayNameToken: 'centralisedMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 269.0979,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'For larger companies, a mail center is required for organizing incoming and outgoing mail. These space hold specialty production and mail equipment. There are also many surfaces for organizing paper and other materials. Usually manned by a full time staff member.',
        descriptionToken: 'centralisedDispersedMailAreaDesc'
    },
    {
        id: '268',
        displayName: 'Visitor Coat / Luggage Room',
        displayNameToken: 'visitorCoatLuggageRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 86.1113,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Visitors need a place to store their coats and other bulky items. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.',
        descriptionToken: 'visitorCoatLuggageRoomDesc'
    },
    {
        id: '269',
        displayName: 'Full Food Service',
        displayNameToken: 'fullFoodServiceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 300,
        maxSF: 2000,
        description: 'When providing an in-office dining service, there are multiple functions that come together to support this amenity including a kitchen, servery, dining room (seating), and dining support (storage). The kitchen and servery work together to prepare and serve the food made in-house. Dining is the place where employees and guests can sit and eat but often this space acts as a social and collaboration hub. Just like at home, there is a lot of equipment and food storage required to provide dining services, which is why dining support is included in the Full Food Service space type.',
        descriptionToken: 'fullFoodServiceDesc'
    },
    // HUNGARY_REGULAR space units
    {
        id: '270',
        displayName: 'Small Office',
        displayNameToken: 'smOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 107.639,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '271',
        displayName: 'Regular Office',
        displayNameToken: 'regOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 150.695,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '272',
        displayName: "5\u2019 Bench Desk",
        displayNameToken: 'benchDesk5Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 29.1,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '273',
        displayName: "6\u2019 Bench Desk",
        displayNameToken: 'benchDesk6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 35.5,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '274',
        displayName: 'Focus Room',
        displayNameToken: 'focusRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 64.6,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Focus Rooms are enclosed spaces intended to support focused and/or confidential work for typically one or two people. Acoustic privacy is paramount in these spaces. Focus Rooms are usually unassigned and can be booked temporarily on an as-needed basis for relevant work.',
        descriptionToken: 'focusRoomDesc'
    },
    {
        id: '275',
        displayName: 'Meeting Room (4 people)',
        displayNameToken: 'meetingRoom4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 118.4,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc'
    },
    {
        id: '276',
        displayName: 'Meeting Room (6 people)',
        displayNameToken: 'meetingRoom6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 172.223,
        seats: 6,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc6'
    },
    {
        id: '277',
        displayName: 'Meeting Room (8 people)',
        displayNameToken: 'meetingRoom8Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 218,
        seats: 8,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc8'
    },
    {
        id: '278',
        displayName: 'Meeting Room (12 people)',
        displayNameToken: 'meetingRoom12Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 387.5,
        seats: 12,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc12'
    },
    {
        id: '279',
        displayName: 'Meeting Room (15 people)',
        displayNameToken: 'meetingRoom15Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 538.2,
        seats: 15,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc'
    },
    {
        id: '280',
        displayName: 'Semi-Enclosed Meeting Booth (4 people)',
        displayNameToken: 'semiEnclosedMeetingBooth4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 64.6,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN
    },
    {
        id: '281',
        displayName: 'Open Collaboration Space (4-6 people)',
        displayNameToken: 'openCollabSpace4to6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 193.8,
        seats: 5,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'These areas are meant to support small groups (4-6 person) collaborative activities such as brainstorming and informal conversations between colleagues and with clients.',
        descriptionToken: 'openCollabSpace4to6Desc'
    },
    {
        id: '282',
        displayName: 'Contemplation Space',
        displayNameToken: 'contemplationSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 161.4587,
        maxSF: 290.6257
    },
    {
        id: '283',
        displayName: 'Main IT Server / Equipment Room',
        displayNameToken: 'mainITEquipRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 236.8061,
        maxSF: 505.904,
        description: 'Primary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.',
        descriptionToken: 'mainITandServerRoomDesc'
    },
    {
        id: '284',
        displayName: 'Reception Area',
        displayNameToken: 'receptionAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 236.8061,
        maxSF: 505.904,
        description: "The reception area is your company\u2019s first opportunity to make an impression on employees, clients and other visitors. It should consistently convey the company\u2019s brand and project the desired appearance. The concierge desk should comfortably house a concierge; soft-seating should be inviting to visitors.",
        descriptionToken: 'centralReceptionHubDesc'
    },
    {
        id: '285',
        displayName: "Caf\xe9 / Food Service",
        displayNameToken: 'cafeFoodServiceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 200,
        maxSF: 1000,
        description: 'The central cafe is intended to be an area for eating, social interaction, individual work and small meetings. Functional eating furniture and a branded color palette should be considered in the design of this space.',
        descriptionToken: 'cafeFoodServiceDesc'
    },
    {
        id: '286',
        displayName: 'Team Storage',
        displayNameToken: 'teamStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 120,
        maxSF: 500,
        description: 'Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.',
        descriptionToken: 'storageDesc'
    },
    {
        id: '287',
        displayName: 'Coat Closets',
        displayNameToken: 'coatClosetsDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 40,
        maxSF: 150,
        description: 'Employees need a place to store their coats and other bulky items, especially when an office has an open layout with limited personal storage at the desk. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.',
        descriptionToken: 'coatClosetsDesc'
    },
    {
        id: '288',
        displayName: 'General Storage (stores and goods in/out)',
        displayNameToken: 'genStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 80,
        maxSF: 500,
        description: 'Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.',
        descriptionToken: 'storageDesc'
    },
    {
        id: '289',
        displayName: 'Centralised Copy, Print & Mail',
        displayNameToken: 'centralisedCopyPrintMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 199.1324,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Spread across the floor in open workspace, copy/print areas give employees quick access to multi-function devices from all neighborhoods. Bins for recycling should always be collocated with copy/print areas, as well as small cabinets to house extra paper and supplies. These spaces are for drop-in purposes only and are not intended to double as social/work areas.',
        descriptionToken: 'copyPrintDesc'
    },
    {
        id: '290',
        displayName: 'Special Resource Area',
        displayNameToken: 'specialResourceAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 86.11132,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'This is a catch all for additional support spaces that might occur in an office. One could be a security desk or facilities while another could be a utilities space. This varies across organizations, but as the size of the office increases, ancillary spaces like this become more likely and necessary.',
        descriptionToken: 'specialResourceBuildingSupportAreaDesc'
    },
    {
        id: '291',
        displayName: 'Personal Storage (lockers)',
        displayNameToken: 'personalStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 1.7,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Lockers are provided as another form of individual storage. They give employees a space to lock their valuables, personal effects and working files. Lockers may be assigned to individuals or used on a first come, first served basis.',
        descriptionToken: 'lockerDesc'
    },
    {
        id: '292',
        displayName: 'IT Storage Space',
        displayNameToken: 'storageITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '293',
        displayName: 'Secondary Server / Telecom Room',
        displayNameToken: 'secondaryServerRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Secondary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.',
        descriptionToken: 'secondaryServerRoomDesc'
    },
    {
        id: '294',
        displayName: "Mothers\u2019 Room",
        displayNameToken: 'mothersRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 86.1113,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: "Mothers rooms are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Mothers rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'mothersRoomDesc'
    },
    {
        id: '295',
        displayName: 'Wellness Room',
        displayNameToken: 'wellnessRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 129.167,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: "Wellness rooms (formerly referred to as Mother\u2019s Rooms) are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Wellness rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'wellnessRoomDesc'
    },
    {
        id: '296',
        displayName: 'IT Build Space',
        displayNameToken: 'buildITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '297',
        displayName: 'Worker Council Office (2 people)',
        displayNameToken: 'workerCouncilOffice2Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '298',
        displayName: 'Security Control Room',
        displayNameToken: 'securityCtrlRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 217.9693,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '299',
        displayName: 'Centralised Mail',
        displayNameToken: 'centralisedMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 215.278,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'For larger companies, a mail center is required for organizing incoming and outgoing mail. These space hold specialty production and mail equipment. There are also many surfaces for organizing paper and other materials. Usually manned by a full time staff member.',
        descriptionToken: 'centralisedDispersedMailAreaDesc'
    },
    {
        id: '300',
        displayName: 'Visitor Coat / Luggage Room',
        displayNameToken: 'visitorCoatLuggageRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 96.87524,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Visitors need a place to store their coats and other bulky items. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.',
        descriptionToken: 'visitorCoatLuggageRoomDesc'
    },
    {
        id: '301',
        displayName: 'Full Food Service',
        displayNameToken: 'fullFoodServiceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 300,
        maxSF: 2000,
        description: 'When providing an in-office dining service, there are multiple functions that come together to support this amenity including a kitchen, servery, dining room (seating), and dining support (storage). The kitchen and servery work together to prepare and serve the food made in-house. Dining is the place where employees and guests can sit and eat but often this space acts as a social and collaboration hub. Just like at home, there is a lot of equipment and food storage required to provide dining services, which is why dining support is included in the Full Food Service space type.',
        descriptionToken: 'fullFoodServiceDesc'
    },
    //COLOMBIA_REGULAR_PROFILES
    {
        id: '302',
        displayName: 'Small Office',
        displayNameToken: 'smOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 96.9,
        seats: 2,
        sf: 118.4,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '303',
        displayName: 'Regular Office',
        displayNameToken: 'regOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 161.5,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '304',
        displayName: "5\u2019 Bench Desk",
        displayNameToken: 'benchDesk5Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 29.1,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '305',
        displayName: "6\u2019 Bench Desk",
        displayNameToken: 'benchDesk6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 35.5,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '306',
        displayName: 'Focus Room',
        displayNameToken: 'focusRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 75.3,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Focus Rooms are enclosed spaces intended to support focused and/or confidential work for typically one or two people. Acoustic privacy is paramount in these spaces. Focus Rooms are usually unassigned and can be booked temporarily on an as-needed basis for relevant work.',
        descriptionToken: 'focusRoomDesc'
    },
    {
        id: '307',
        displayName: 'Meeting Room (4 people)',
        displayNameToken: 'meetingRoom4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 118.4,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc'
    },
    {
        id: '308',
        displayName: 'Meeting Room (6 people)',
        displayNameToken: 'meetingRoom6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 161.5,
        seats: 6,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc6'
    },
    {
        id: '309',
        displayName: 'Meeting Room (8 people)',
        displayNameToken: 'meetingRoom8Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 218,
        seats: 8,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc8'
    },
    {
        id: '310',
        displayName: 'Meeting Room (12 people)',
        displayNameToken: 'meetingRoom12Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 387.5,
        seats: 12,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc12'
    },
    {
        id: '311',
        displayName: 'Meeting Room (15 people)',
        displayNameToken: 'meetingRoom15Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 538.2,
        seats: 15,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc15'
    },
    {
        id: '312',
        displayName: 'Semi-Enclosed Meeting Booth (4 people)',
        displayNameToken: 'semiEnclosedMeetingBooth4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 43.1,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN
    },
    {
        id: '313',
        displayName: 'Open Collaboration Space (4-6 people)',
        displayNameToken: 'openCollabSpace4to6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 236.8,
        seats: 5,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'These areas are meant to support small groups (4-6 person) collaborative activities such as brainstorming and informal conversations between colleagues and with clients.',
        descriptionToken: 'openCollabSpace4to6Desc'
    },
    {
        id: '314',
        displayName: 'Contemplation Space',
        displayNameToken: 'contemplationSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 161.4587,
        maxSF: 290.6257
    },
    {
        id: '315',
        displayName: 'Main IT Server / Equipment Room',
        displayNameToken: 'mainITEquipRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 236.8061,
        maxSF: 505.904,
        description: 'Primary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.',
        descriptionToken: 'mainITandServerRoomDesc'
    },
    {
        id: '316',
        displayName: 'Reception Area',
        displayNameToken: 'receptionAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 236.8061,
        maxSF: 505.904,
        description: "The reception area is your company\u2019s first opportunity to make an impression on employees, clients and other visitors. It should consistently convey the company\u2019s brand and project the desired appearance. The concierge desk should comfortably house a concierge; soft-seating should be inviting to visitors.",
        descriptionToken: 'centralReceptionHubDesc'
    },
    {
        id: '317',
        displayName: "Caf\xe9 / Food Service",
        displayNameToken: 'cafeFoodServiceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 200,
        maxSF: 1000,
        description: 'The central cafe is intended to be an area for eating, social interaction, individual work and small meetings. Functional eating furniture and a branded color palette should be considered in the design of this space.',
        descriptionToken: 'cafeFoodServiceDesc'
    },
    {
        id: '318',
        displayName: 'Team Storage',
        displayNameToken: 'teamStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 120,
        maxSF: 500,
        description: 'Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.',
        descriptionToken: 'storageDesc'
    },
    {
        id: '319',
        displayName: 'Coat Closets',
        displayNameToken: 'coatClosetsDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 40,
        maxSF: 150,
        description: 'Employees need a place to store their coats and other bulky items, especially when an office has an open layout with limited personal storage at the desk. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.',
        descriptionToken: 'coatClosetsDesc'
    },
    {
        id: '320',
        displayName: 'General Storage (stores and goods in/out)',
        displayNameToken: 'genStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 80,
        maxSF: 500,
        description: 'Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.',
        descriptionToken: 'storageDesc'
    },
    {
        id: '321',
        displayName: 'Centralised Copy, Print & Mail',
        displayNameToken: 'centralisedCopyPrintMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 199.1324,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Spread across the floor in open workspace, copy/print areas give employees quick access to multi-function devices from all neighborhoods. Bins for recycling should always be collocated with copy/print areas, as well as small cabinets to house extra paper and supplies. These spaces are for drop-in purposes only and are not intended to double as social/work areas.',
        descriptionToken: 'copyPrintDesc'
    },
    {
        id: '322',
        displayName: 'Special Resource Area',
        displayNameToken: 'specialResourceAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 86.11132,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'This is a catch all for additional support spaces that might occur in an office. One could be a security desk or facilities while another could be a utilities space. This varies across organizations, but as the size of the office increases, ancillary spaces like this become more likely and necessary.',
        descriptionToken: 'specialResourceBuildingSupportAreaDesc'
    },
    {
        id: '323',
        displayName: 'Personal Storage (lockers)',
        displayNameToken: 'personalStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 2.152783,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Lockers are provided as another form of individual storage. They give employees a space to lock their valuables, personal effects and working files. Lockers may be assigned to individuals or used on a first come, first served basis.',
        descriptionToken: 'lockerDesc'
    },
    {
        id: '324',
        displayName: 'IT Storage Space',
        displayNameToken: 'storageITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '325',
        displayName: 'Secondary Server / Telecom Room',
        displayNameToken: 'secondaryServerRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Secondary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.',
        descriptionToken: 'secondaryServerRoomDesc'
    },
    {
        id: '326',
        displayName: "Mothers\u2019 Room",
        displayNameToken: 'mothersRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: "Mothers rooms are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Mothers rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'mothersRoomDesc'
    },
    {
        id: '327',
        displayName: 'Wellness Room',
        displayNameToken: 'wellnessRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: "Wellness rooms (formerly referred to as Mother\u2019s Rooms) are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Wellness rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'wellnessRoomDesc'
    },
    {
        id: '328',
        displayName: 'IT Build Space',
        displayNameToken: 'buildITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '329',
        displayName: 'Worker Council Office (2 people)',
        displayNameToken: 'workerCouncilOffice2Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.4587,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '330',
        displayName: 'Security Control Room',
        displayNameToken: 'securityCtrlRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 217.9693,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '331',
        displayName: 'Centralised Mail',
        displayNameToken: 'centralisedMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 269.0979,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'For larger companies, a mail center is required for organizing incoming and outgoing mail. These space hold specialty production and mail equipment. There are also many surfaces for organizing paper and other materials. Usually manned by a full time staff member.',
        descriptionToken: 'centralisedDispersedMailAreaDesc'
    },
    {
        id: '332',
        displayName: 'Visitor Coat / Luggage Room',
        displayNameToken: 'visitorCoatLuggageRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 96.87524,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Visitors need a place to store their coats and other bulky items. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.',
        descriptionToken: 'visitorCoatLuggageRoomDesc'
    },
    {
        id: '333',
        displayName: 'Full Food Service',
        displayNameToken: 'fullFoodServiceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 300,
        maxSF: 2000,
        description: 'When providing an in-office dining service, there are multiple functions that come together to support this amenity including a kitchen, servery, dining room (seating), and dining support (storage). The kitchen and servery work together to prepare and serve the food made in-house. Dining is the place where employees and guests can sit and eat but often this space acts as a social and collaboration hub. Just like at home, there is a lot of equipment and food storage required to provide dining services, which is why dining support is included in the Full Food Service space type.',
        descriptionToken: 'fullFoodServiceDesc'
    },
    // Netherlands space units
    {
        id: '334',
        displayName: 'Small Office',
        displayNameToken: 'smOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 96.9,
        seats: 2,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '335',
        displayName: 'Regular Office',
        displayNameToken: 'regOfficeDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 193.8,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.',
        descriptionToken: 'officeDesc'
    },
    {
        id: '336',
        displayName: "5\u2019 Bench Desk",
        displayNameToken: 'benchDesk5Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 59.2,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '337',
        displayName: "6\u2019 Bench Desk",
        displayNameToken: 'benchDesk6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.SEATS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 64.6,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.',
        descriptionToken: 'benchDeskDesc'
    },
    {
        id: '338',
        displayName: 'Focus Room',
        displayNameToken: 'focusRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.ME,
        sf: 64.6,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Focus Rooms are enclosed spaces intended to support focused and/or confidential work for typically one or two people. Acoustic privacy is paramount in these spaces. Focus Rooms are usually unassigned and can be booked temporarily on an as-needed basis for relevant work.',
        descriptionToken: 'focusRoomDesc'
    },
    {
        id: '339',
        displayName: 'Meeting Room (4 people)',
        displayNameToken: 'meetingRoom4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 107.6,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc'
    },
    {
        id: '340',
        displayName: 'Meeting Room (6 people)',
        displayNameToken: 'meetingRoom6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 161.5,
        seats: 6,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 6 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc6'
    },
    {
        id: '341',
        displayName: 'Meeting Room (8 people)',
        displayNameToken: 'meetingRoom8Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 193.8,
        seats: 8,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 8 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc8'
    },
    {
        id: '342',
        displayName: 'Meeting Room (12 people)',
        displayNameToken: 'meetingRoom12Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 258.3,
        seats: 12,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 12 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc12'
    },
    {
        id: '343',
        displayName: 'Meeting Room (15 people)',
        displayNameToken: 'meetingRoom15Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 322.9,
        seats: 15,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.ENCLOSED,
        description: 'Meeting rooms are enclosed spaces intended to support small group meetings of 15 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).',
        descriptionToken: 'meetingRoomDesc15'
    },
    {
        id: '344',
        displayName: 'Semi-Enclosed Meeting Booth (4 people)',
        displayNameToken: 'semiEnclosedMeetingBooth4Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 86.1,
        seats: 4,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN
    },
    {
        id: '345',
        displayName: 'Open Collaboration Space (4-6 people)',
        displayNameToken: 'openCollabSpace4to6Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.WE,
        sf: 129.2,
        seats: 5,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.OPEN,
        description: 'These areas are meant to support small groups (4-6 person) collaborative activities such as brainstorming and informal conversations between colleagues and with clients.',
        descriptionToken: 'openCollabSpace4to6Desc'
    },
    {
        id: '346',
        displayName: 'Contemplation Space',
        displayNameToken: 'contemplationSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 161.46,
        maxSF: 861.112
    },
    {
        id: '347',
        displayName: 'Main IT Server / Equipment Room',
        displayNameToken: 'mainITEquipRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 134.55,
        maxSF: 430.556,
        description: 'Primary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.',
        descriptionToken: 'mainITandServerRoomDesc'
    },
    {
        id: '348',
        displayName: 'Reception Area',
        displayNameToken: 'receptionAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 430.86,
        maxSF: 2152.78,
        description: "The reception area is your company\u2019s first opportunity to make an impression on employees, clients and other visitors. It should consistently convey the company\u2019s brand and project the desired appearance. The concierge desk should comfortably house a concierge; soft-seating should be inviting to visitors.",
        descriptionToken: 'centralReceptionHubDesc'
    },
    {
        id: '349',
        displayName: "Caf\xe9 / Food Service",
        displayNameToken: 'cafeFoodServiceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minsf: 215.28,
        description: 'The central cafe is intended to be an area for eating, social interaction, individual work and small meetings. Functional eating furniture and a branded color palette should be considered in the design of this space.',
        descriptionToken: 'cafeFoodServiceDesc'
    },
    {
        id: '350',
        displayName: 'Team Storage',
        displayNameToken: 'teamStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 107.64,
        maxSF: 1076.39,
        description: 'Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.',
        descriptionToken: 'storageDesc'
    },
    {
        id: '351',
        displayName: 'Coat Closets',
        displayNameToken: 'coatClosetsDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Employees need a place to store their coats and other bulky items, especially when an office has an open layout with limited personal storage at the desk. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.',
        descriptionToken: 'coatClosetsDesc'
    },
    {
        id: '352',
        displayName: 'General Storage (stores and goods in/out)',
        displayNameToken: 'genStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 107.64,
        maxSF: 1076.39,
        description: 'Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.',
        descriptionToken: 'storageDesc'
    },
    {
        id: '353',
        displayName: 'Centralised Copy, Print & Mail',
        displayNameToken: 'centralisedCopyPrintMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 107.64,
        maxSF: 645.5,
        description: 'Spread across the floor in open workspace, copy/print areas give employees quick access to multi-function devices from all neighborhoods. Bins for recycling should always be collocated with copy/print areas, as well as small cabinets to house extra paper and supplies. These spaces are for drop-in purposes only and are not intended to double as social/work areas.',
        descriptionToken: 'copyPrintDesc'
    },
    {
        id: '354',
        displayName: 'Special Resource Area',
        displayNameToken: 'specialResourceAreaDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 161.46,
        maxSF: 1506.946,
        description: 'This is a catch all for additional support spaces that might occur in an office. One could be a security desk or facilities while another could be a utilities space. This varies across organizations, but as the size of the office increases, ancillary spaces like this become more likely and necessary.',
        descriptionToken: 'specialResourceBuildingSupportAreaDesc'
    },
    {
        id: '355',
        displayName: 'Personal Storage (lockers)',
        displayNameToken: 'personalStorageDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Lockers are provided as another form of individual storage. They give employees a space to lock their valuables, personal effects and working files. Lockers may be assigned to individuals or used on a first come, first served basis.',
        descriptionToken: 'lockerDesc'
    },
    {
        id: '356',
        displayName: 'IT Storage Space',
        displayNameToken: 'storageITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 107.64,
        maxSF: 861.112
    },
    {
        id: '357',
        displayName: 'Secondary Server / Telecom Room',
        displayNameToken: 'secondaryServerRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.SUPPORT,
        sf: 1,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        minSF: 107.64,
        maxSF: 322.917,
        description: 'Secondary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.',
        descriptionToken: 'secondaryServerRoomDesc'
    },
    {
        id: '358',
        displayName: "Mothers\u2019 Room",
        displayNameToken: 'mothersRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 129.2,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: "Mothers rooms are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Mothers rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'mothersRoomDesc'
    },
    {
        id: '359',
        displayName: 'Wellness Room',
        displayNameToken: 'wellnessRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 134.55,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: "Wellness rooms (formerly referred to as Mother\u2019s Rooms) are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Wellness rooms are a usually a requirement for all new offices, regardless of size or headcount.",
        descriptionToken: 'wellnessRoomDesc'
    },
    {
        id: '360',
        displayName: 'IT Build Space',
        displayNameToken: 'buildITSpaceDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.AREAS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 86.11,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '361',
        displayName: 'Worker Council Office (2 people)',
        displayNameToken: 'workerCouncilOffice2Defined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 193.75,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '362',
        displayName: 'Security Control Room',
        displayNameToken: 'securityCtrlRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 107.64,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY
    },
    {
        id: '363',
        displayName: 'Centralised Mail',
        displayNameToken: 'centralisedMailDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 161.46,
        seats: 0,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'For larger companies, a mail center is required for organizing incoming and outgoing mail. These space hold specialty production and mail equipment. There are also many surfaces for organizing paper and other materials. Usually manned by a full time staff member.',
        descriptionToken: 'centralisedDispersedMailAreaDesc'
    },
    {
        id: '364',
        displayName: 'Visitor Coat / Luggage Room',
        displayNameToken: 'visitorCoatLuggageRoomDefined',
        displayUnit: $360097f996698d39$var$UNIT_LABEL.ROOMS,
        category: $360097f996698d39$var$CATEGORY.AMENITY,
        sf: 107.64,
        seats: 1,
        circulationType: $360097f996698d39$var$CIRCULATION_TYPE.AMENITY,
        description: 'Visitors need a place to store their coats and other bulky items. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.',
        descriptionToken: 'visitorCoatLuggageRoomDesc'
    }
];
module.exports = $f1q41.keyBy($360097f996698d39$var$spaceUnits, 'id');

});

parcelRegister("9yvR1", function(module, exports) {

var $f1q41 = parcelRequire("f1q41");

const { CATEGORY: $6f4fff9d2c7dec3b$var$CATEGORY, UNIT_LABEL: $6f4fff9d2c7dec3b$var$UNIT_LABEL, CIRCULATION_TYPE: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE } = (parcelRequire("aB89e")).shared.spaceUnit;
// custom amenities can be added multiple times to the program (e.g. there can be two "Auditorium" instances on the program).
// therefore they are added with custom ids, and matched to their unit by name (e.g. the string "auditorium")
// from here: https://docs.google.com/spreadsheets/d/1SYkapQcA0-FbiezVzTQCk4iTToY333A0p_Sy71YyE_U
const $6f4fff9d2c7dec3b$var$suggestedCustomAmenities = [
    {
        dataKey: '1',
        displayName: 'audioVisualCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.ROOMS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 0.5,
        minSF: 150
    },
    {
        dataKey: '2',
        displayName: 'dataCenterCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.ROOMS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 3,
        minSF: 1000
    },
    {
        dataKey: '3',
        displayName: 'buildingSupportCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.ROOMS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 2.1
    },
    {
        dataKey: '4',
        displayName: 'foodServiceCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.AREAS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 10.6
    },
    {
        dataKey: '5',
        displayName: 'kitchenCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.ROOMS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 2.58
    },
    {
        dataKey: '6',
        displayName: 'serveryCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.AREAS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 3.19
    },
    {
        dataKey: '7',
        displayName: 'execDiningCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.AREAS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 0.6
    },
    {
        dataKey: '8',
        displayName: 'grabNGoCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.AREAS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 0.78
    },
    {
        dataKey: '9',
        displayName: 'juiceCoffeeBarCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.AREAS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 1
    },
    {
        dataKey: '10',
        displayName: 'childCareCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.ROOMS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 5
    },
    {
        dataKey: '11',
        displayName: 'fitnessCenterCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.ROOMS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 6.25
    },
    {
        dataKey: '12',
        displayName: 'healthCenterCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.ROOMS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 0.8
    },
    {
        dataKey: '13',
        displayName: 'mailCenterCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.ROOMS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 2.5,
        minSF: 200
    },
    {
        dataKey: '14',
        displayName: 'commercialPrintCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.ROOMS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 0.8,
        minSF: 400
    },
    {
        dataKey: '15',
        displayName: 'centralCafeCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.AREAS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 4.5,
        minSF: 1200
    },
    {
        dataKey: '16',
        displayName: 'securityCtrlCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.ROOMS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 0.8
    },
    {
        dataKey: '17',
        displayName: 'auditoriumCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.ROOMS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 4.7,
        minSF: 1500,
        maxSF: 8000
    },
    {
        dataKey: '18',
        displayName: 'dryCleaningLaundryCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.ROOMS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 0.8
    },
    {
        dataKey: '19',
        displayName: 'confCenterCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.ROOMS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.AMENITY,
        multiplier: 6,
        minSF: 1500,
        maxSF: 10000
    },
    {
        dataKey: '20',
        displayName: 'multiPurpTrainingCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.ROOMS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.ENCLOSED,
        sf: 1000
    },
    {
        dataKey: '21',
        displayName: 'informalCollabCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.AREAS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.OPEN,
        sf: 120
    },
    {
        dataKey: '22',
        displayName: 'touchdownTeamCustom',
        displayUnit: $6f4fff9d2c7dec3b$var$UNIT_LABEL.AREAS,
        category: $6f4fff9d2c7dec3b$var$CATEGORY.CUSTOM_AMENITY,
        circulationType: $6f4fff9d2c7dec3b$var$CIRCULATION_TYPE.OPEN,
        sf: 120
    }
];
module.exports = $f1q41.keyBy($6f4fff9d2c7dec3b$var$suggestedCustomAmenities, (unit)=>unit.displayName.toLowerCase());

});

parcelRegister("j4epO", function(module, exports) {

var $f1q41 = parcelRequire("f1q41");

var $4Ds5C = parcelRequire("4Ds5C");

var $4ICSb = parcelRequire("4ICSb");

var $4MjDQ = parcelRequire("4MjDQ");
var $de19929da7609a73$require$profileNameIds = $4MjDQ.profileNameIds;

const { CIRCULATION_TYPE: $de19929da7609a73$var$CIRCULATION_TYPE, CATEGORY: $de19929da7609a73$var$CATEGORY } = (parcelRequire("aB89e")).shared.spaceUnit;

const { US_REGULAR: $de19929da7609a73$var$US_REGULAR } = (parcelRequire("aB89e")).spacerFree.calculator.PROFILE_TYPE; // TODO: will move this to shared

const { MEDIUM: $de19929da7609a73$var$MEDIUM } = (parcelRequire("aB89e")).spacerFree.calculator.COLLABORATION_LEVEL;

const { POPULATION_BLANK_TEMPLATE: $de19929da7609a73$var$POPULATION_BLANK_TEMPLATE } = (parcelRequire("aB89e")).spacerPro.blankTemplatePopulationLocation;
const $de19929da7609a73$var$profileMap = $f1q41.cloneDeep($4ICSb);
// updates to KOP in spacer pro
$f1q41.forEach($de19929da7609a73$var$profileMap, (profile)=>{
    const usRegularKop = profile.kitOfPartsWithMultipliers[$de19929da7609a73$var$US_REGULAR];
    $f1q41.forEach(usRegularKop, (category)=>{
        $f1q41.forEach(category, (unit)=>{
            // update multiplier of file rooms
            if (unit.spaceUnitId === '21' && unit.multiplier === 80) unit.multiplier = 1.2;
            // exculde focus room from ME section
            if (unit.spaceUnitId === '6') category.splice(category.indexOf(unit), 1);
        });
    });
});
function $de19929da7609a73$var$getSpaceUnit(spaceUnitWithMultiplier) {
    const id = spaceUnitWithMultiplier.spaceUnitId;
    return $4Ds5C[id];
}
function $de19929da7609a73$var$getMeKitOfPartsWithMultiplier(meKitOfParts, program) {
    $f1q41.forEach(meKitOfParts, (spaceUnitWithMultiplier)=>{
        const spaceUnit = $de19929da7609a73$var$getSpaceUnit(spaceUnitWithMultiplier);
        const meUnit = {
            name: spaceUnit.displayName,
            category: spaceUnit.category,
            sf: spaceUnit.sf,
            circulationType: spaceUnit.circulationType,
            multiplier: spaceUnitWithMultiplier.multiplier
        };
        program.me.push(meUnit);
    });
}
function $de19929da7609a73$var$getSharedFocusKitOfPartsWithMultiplier(sharedFocusKitOfParts, program) {
    $f1q41.forEach(sharedFocusKitOfParts, (spaceUnitWithMultiplier)=>{
        const spaceUnit = $de19929da7609a73$var$getSpaceUnit(spaceUnitWithMultiplier);
        const sharedFocusUnit = {
            name: spaceUnit.displayName,
            category: spaceUnit.category,
            sf: spaceUnit.sf,
            circulationType: spaceUnit.circulationType,
            ratio: spaceUnitWithMultiplier.multiplier,
            seats: spaceUnit.seats
        };
        program.sharedFocus.push(sharedFocusUnit);
    });
}
function $de19929da7609a73$var$getSupportKitOfPartsWithMultiplier(supportKitOfParts, program) {
    $f1q41.forEach(supportKitOfParts, (spaceUnitWithMultiplier)=>{
        const spaceUnit = $de19929da7609a73$var$getSpaceUnit(spaceUnitWithMultiplier);
        const supportUnit = {
            name: spaceUnit.displayName,
            category: spaceUnit.category,
            sf: spaceUnit.sf,
            multiplier: spaceUnitWithMultiplier.multiplier,
            circulationType: $de19929da7609a73$var$CIRCULATION_TYPE.AMENITY // in Spacer Pro, all support parts have amenity circulation type
        };
        program.support.push(supportUnit);
    });
}
function $de19929da7609a73$var$getAmenityKitOfPartsWithMultiplier(amenityKitOfParts, program) {
    $f1q41.forEach(amenityKitOfParts, (spaceUnitWithMultiplier)=>{
        const spaceUnit = $de19929da7609a73$var$getSpaceUnit(spaceUnitWithMultiplier);
        const amenityUnit = {
            name: spaceUnit.displayName,
            category: spaceUnit.category,
            sf: spaceUnit.sf,
            circulationType: spaceUnit.circulationType,
            multiplier: spaceUnitWithMultiplier.multiplier,
            minSF: spaceUnit.minSF || 0,
            maxSF: spaceUnit.maxSF || 0
        };
        program.amenity.push(amenityUnit);
    });
}
function $de19929da7609a73$var$getProfileAssumptions(collaborationRatio, program) {
    program = {
        ...program,
        assumptions: {
            sharingPopulation: 1,
            collaborationRatio: collaborationRatio,
            assignedSeating: true
        }
    };
    return program;
}
function $de19929da7609a73$var$getKitOfPartsWithMultiplierAndAssumptions(profileKitOfParts, collaborationRatio) {
    let program = {
        me: [],
        sharedFocus: [],
        support: [],
        amenity: [],
        assumptions: {}
    };
    $de19929da7609a73$var$getMeKitOfPartsWithMultiplier(profileKitOfParts[$de19929da7609a73$var$CATEGORY.ME], program);
    $de19929da7609a73$var$getSharedFocusKitOfPartsWithMultiplier(profileKitOfParts[$de19929da7609a73$var$CATEGORY.SHARED_FOCUS], program);
    $de19929da7609a73$var$getSupportKitOfPartsWithMultiplier(profileKitOfParts[$de19929da7609a73$var$CATEGORY.SUPPORT], program);
    $de19929da7609a73$var$getAmenityKitOfPartsWithMultiplier(profileKitOfParts[$de19929da7609a73$var$CATEGORY.AMENITY], program);
    program = $de19929da7609a73$var$getProfileAssumptions(collaborationRatio, program);
    return program;
}
function $de19929da7609a73$var$getTemplateWithoutOrder(profileMapId) {
    const profileInfo = $de19929da7609a73$var$profileMap[profileMapId];
    return {
        // the substring(4) is to chop of `The ` from the beginning of the name, ex: `The Optimizer` -> `Optimizer`
        name: profileInfo.displayName.substring(4),
        id: profileInfo.id,
        templateType: 'population',
        program: $de19929da7609a73$var$getKitOfPartsWithMultiplierAndAssumptions(profileInfo.kitOfPartsWithMultipliers[$de19929da7609a73$var$US_REGULAR], profileInfo.collaborationLevels[$de19929da7609a73$var$US_REGULAR][$de19929da7609a73$var$MEDIUM])
    };
}
// All profiles based off Spacer Free US_Regular profiles, blank template only has basic support rows
module.exports = [
    $de19929da7609a73$var$POPULATION_BLANK_TEMPLATE,
    $de19929da7609a73$var$getTemplateWithoutOrder($de19929da7609a73$require$profileNameIds.EFFICIENT),
    $de19929da7609a73$var$getTemplateWithoutOrder($de19929da7609a73$require$profileNameIds.WHITE_COLLAR),
    $de19929da7609a73$var$getTemplateWithoutOrder($de19929da7609a73$require$profileNameIds.WHITE_GLOVE),
    $de19929da7609a73$var$getTemplateWithoutOrder($de19929da7609a73$require$profileNameIds.OPEN_OFFICE),
    $de19929da7609a73$var$getTemplateWithoutOrder($de19929da7609a73$require$profileNameIds.WORKPLACE_360),
    $de19929da7609a73$var$getTemplateWithoutOrder($de19929da7609a73$require$profileNameIds.CAMPUS),
    $de19929da7609a73$var$getTemplateWithoutOrder($de19929da7609a73$require$profileNameIds.STARTUP),
    $de19929da7609a73$var$getTemplateWithoutOrder($de19929da7609a73$require$profileNameIds.ENG_CREATIVE)
];

});

parcelRegister("72KKs", function(module, exports) {

const { CIRCULATION_TYPE: $0152ca404e668937$var$CIRCULATION_TYPE, CATEGORY: $0152ca404e668937$var$CATEGORY } = (parcelRequire("aB89e")).shared.spaceUnit;

const { LOCATION_BLANK_TEMPLATE: $0152ca404e668937$var$LOCATION_BLANK_TEMPLATE } = (parcelRequire("aB89e")).spacerPro.blankTemplatePopulationLocation;
module.exports = [
    $0152ca404e668937$var$LOCATION_BLANK_TEMPLATE,
    {
        id: 'single_floor',
        name: 'Single Floor',
        templateType: 'location',
        program: {
            me: [],
            sharedFocus: [],
            we: [],
            support: [
                {
                    name: 'Copy/Print/Supplies',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 2,
                    sf: 120,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY,
                    isFloorDependent: true
                },
                {
                    name: 'Pantry/Break Room',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY,
                    isFloorDependent: true
                },
                {
                    name: 'General Storage',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 2,
                    sf: 120,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY,
                    isFloorDependent: true
                },
                {
                    name: 'File Room',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 2,
                    sf: 120,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: '3H Drawer Lateral Files',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 3,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Lockers',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 2,
                    sf: 2,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Wellness Room',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 0.5,
                    sf: 100,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Mothers\'s Room',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 0.5,
                    sf: 100,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'IT Help Desk/Storage',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 0.25,
                    sf: 200,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Floor Elevator Lobby',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 300,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY,
                    isFloorDependent: true
                },
                {
                    name: "Caf\xe9",
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 4.5,
                    sf: 1200,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Coats',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 0.1,
                    sf: 40,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                }
            ],
            amenity: [
                {
                    name: 'Multi-Purpose (Auditorium Style Seats)',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 4.7,
                    minSf: 1250,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Training (Class Seating w/ Tables)',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 4.7,
                    minSf: 1250,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Reception',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 2.5,
                    minSf: 800,
                    maxSf: 2500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Receptionist',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.5,
                    minSf: 150,
                    maxSf: 300,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Mail Center',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.5,
                    minSf: 200,
                    maxSf: 1200,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                }
            ]
        }
    },
    {
        id: 'multiple_floors',
        name: 'Multiple Floors',
        templateType: 'location',
        program: {
            me: [],
            sharedFocus: [],
            we: [],
            support: [
                {
                    name: 'Copy/Print/Supplies',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 2,
                    sf: 120,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY,
                    isFloorDependent: true
                },
                {
                    name: 'Pantry/Break Room',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY,
                    isFloorDependent: true
                },
                {
                    name: 'General Storage',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1.5,
                    sf: 120,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY,
                    isFloorDependent: true
                },
                {
                    name: 'File Room',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 2,
                    sf: 120,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: '3H Drawer Lateral Files',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 3,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Lockers',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 2,
                    sf: 2,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Wellness Room',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 0.5,
                    sf: 100,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Mothers\'s Room',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 0.5,
                    sf: 100,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'IT Help Desk/Storage',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 0.25,
                    sf: 200,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Floor Elevator Lobby',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 300,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY,
                    isFloorDependent: true
                },
                {
                    name: "Caf\xe9",
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 4.5,
                    sf: 1200,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Grab-N-Go/Micro Market',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 0.78,
                    sf: 500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Juice/Coffee Bar',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 750,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Breakout Room (8-10 seats)',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 275,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Training (Class Seating w/ Tables)',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 4.7,
                    sf: 1250,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Training (60 seats at tables)',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 2.2,
                    sf: 2400,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Coats',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 0.1,
                    sf: 40,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Internal Stair',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY,
                    isFloorDependent: true
                }
            ],
            amenity: [
                {
                    name: 'Full Food Service',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 10.6,
                    minSf: 0,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'IT Help Desk',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 2.5,
                    minSf: 500,
                    maxSf: 1500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Boardroom (18 Seats)',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 2.5,
                    minSf: 525,
                    maxSf: 750,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Fitness Center',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 6.25,
                    minSf: 0,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Conference Center',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 6,
                    minSf: 1500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Breakout Space',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 2,
                    minSf: 500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Multi-Purpose (Auditorium Style Seats)',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 4.7,
                    minSf: 1250,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Auditorium',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 2.2,
                    minSf: 1500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Audio/Visual',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.25,
                    minSf: 150,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Furniture Storage',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.25,
                    minSf: 150,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Reception',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 2.5,
                    minSf: 800,
                    maxSf: 2500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Receptionist',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.5,
                    minSf: 150,
                    maxSf: 300,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Mail Center',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.5,
                    minSf: 200,
                    maxSf: 1200,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Reproduction Room',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.8,
                    minSf: 400,
                    maxSf: 1200,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Security Control Room',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.5,
                    minSf: 200,
                    maxSf: 1000,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Data Center',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 1.5,
                    minSf: 500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Building Support Services',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 2.1,
                    minSf: 0,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                }
            ]
        }
    },
    {
        id: 'headquarters',
        name: 'Headquarters',
        templateType: 'location',
        program: {
            me: [],
            sharedFocus: [],
            we: [],
            support: [
                {
                    name: 'Copy/Print/Supplies',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 2,
                    sf: 120,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY,
                    isFloorDependent: true
                },
                {
                    name: 'Pantry/Break Room',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY,
                    isFloorDependent: true
                },
                {
                    name: 'General Storage',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1.5,
                    sf: 120,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY,
                    isFloorDependent: true
                },
                {
                    name: 'File Room',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 2,
                    sf: 120,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: '3H Drawer Lateral Files',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 3,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Lockers',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 2,
                    sf: 2,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Wellness Room',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 0.5,
                    sf: 100,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Mothers\'s Room',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 0.5,
                    sf: 100,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'IT Help Desk/Storage',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 0.25,
                    sf: 200,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Floor Elevator Lobby',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 300,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY,
                    isFloorDependent: true
                },
                {
                    name: "Caf\xe9",
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 4.5,
                    sf: 1200,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Grab-N-Go/Micro Market',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 0.78,
                    sf: 500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Juice/Coffee Bar',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 750,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Breakout Room (8-10 seats)',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 275,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Training (Class Seating w/ Tables)',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 4.7,
                    sf: 1250,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Training (60 seats at tables)',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 2.2,
                    sf: 2400,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Coats',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 0.1,
                    sf: 40,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Internal Stair',
                    category: $0152ca404e668937$var$CATEGORY.SUPPORT,
                    multiplier: 1,
                    sf: 500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY,
                    isFloorDependent: true
                }
            ],
            amenity: [
                {
                    name: 'Full Food Service',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 10.6,
                    minSf: 0,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Executive Dining',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.6,
                    minSf: 0,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'IT Help Desk',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 2.5,
                    minSf: 500,
                    maxSf: 1500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Boardroom (18 Seats)',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 2.5,
                    minSf: 525,
                    maxSf: 750,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Fitness Center',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 6.25,
                    minSf: 0,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Health Center',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 1,
                    minSf: 0,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Child Care',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 5,
                    minSf: 0,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Dry Cleaning/Laundry',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.8,
                    minSf: 0,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Conference Center',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 6,
                    minSf: 1500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Breakout Space',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 2,
                    minSf: 500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Multi-Purpose (Auditorium Style Seats)',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 4.7,
                    minSf: 1250,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Auditorium',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 2.2,
                    minSf: 1500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Audio/Visual',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.25,
                    minSf: 150,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Furniture Storage',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.25,
                    minSf: 150,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Reception',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 2.5,
                    minSf: 800,
                    maxSf: 2500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Receptionist',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.5,
                    minSf: 150,
                    maxSf: 300,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Mail Center',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.5,
                    minSf: 200,
                    maxSf: 1200,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Reproduction Room',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.8,
                    minSf: 400,
                    maxSf: 1200,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Security Control Room',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 0.5,
                    minSf: 200,
                    maxSf: 1000,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Data Center',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 1.5,
                    minSf: 500,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                },
                {
                    name: 'Building Support Services',
                    category: $0152ca404e668937$var$CATEGORY.AMENITY,
                    multiplier: 2.1,
                    minSf: 0,
                    circulationType: $0152ca404e668937$var$CIRCULATION_TYPE.AMENITY
                }
            ]
        }
    }
];

});

parcelRegister("lhxnV", function(module, exports) {

const { CIRCULATION_TYPE: $f7e515094633b4c5$var$CIRCULATION_TYPE, CATEGORY: $f7e515094633b4c5$var$CATEGORY } = (parcelRequire("aB89e")).shared.spaceUnit;
module.exports = {
    POPULATION_SUPPORT_AUTOFILL_OPTIONS: [
        {
            name: 'File Room',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 2,
            sf: 120,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: '3H Drawer Lateral Files',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 1,
            sf: 3,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Lockers',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 2,
            sf: 2,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Wellness Room',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 0.5,
            sf: 100,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Mothers\'s Room',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 0.5,
            sf: 100,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'IT Help Desk/Storage',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 0.25,
            sf: 200,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Conference Center',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 6,
            minSf: 1500,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Breakout Space',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 2,
            minSf: 500,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Breakout Room (8-10 seats)',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 1,
            sf: 275,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Multi-Purpose (Auditorium Style Seats)',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 4.7,
            minSf: 1250,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Training (Class Seating w/ Tables)',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 4.7,
            sf: 1250,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Training (60 seats at tables)',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 2.2,
            sf: 2400,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Auditorium',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 2.2,
            minSf: 1500,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Audio/Visual',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 0.25,
            minSf: 150,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Furniture Storage',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 0.25,
            minSf: 150,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Coats',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 0.1,
            sf: 40,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        }
    ],
    LOCATION_AUTOFILL_OPTIONS: [
        {
            name: 'Copy/Print/Supplies',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 2,
            sf: 120,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY,
            isFloorDependent: true
        },
        {
            name: 'Pantry/Break Room',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 1,
            sf: 500,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY,
            isFloorDependent: true
        },
        {
            name: 'General Storage',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 1.5,
            sf: 120,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY,
            isFloorDependent: true
        },
        {
            name: 'File Room',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 2,
            sf: 120,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: '3H Drawer Lateral Files',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 1,
            sf: 3,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Lockers',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 2,
            sf: 2,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Wellness Room',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 0.5,
            sf: 100,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Mothers\'s Room',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 0.5,
            sf: 100,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'IT Work/Storage',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 0.25,
            sf: 200,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Floor Elevator Lobby',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 1,
            sf: 300,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY,
            isFloorDependent: true
        },
        {
            name: "Caf\xe9",
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 4.5,
            sf: 1200,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Grab-N-Go/Micro Market',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 0.78,
            sf: 500,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Juice/Coffee Bar',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 1,
            sf: 750,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Full Food Service',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 10.6,
            minSf: 0,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Cafeteria Kitchen',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 2.58,
            minSf: 0,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Food Service Support',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 1,
            minSf: 0,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Cafeteria Dining',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 5,
            minSf: 0,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Servery',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 3.19,
            minSf: 0,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Executive Dining',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 0.6,
            minSf: 0,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'IT Help Desk',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 2.5,
            minSf: 500,
            maxSf: 1500,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Boardroom (18 Seats)',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 2.5,
            minSf: 525,
            maxSf: 750,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Fitness Center',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 6.25,
            minSf: 0,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Health Center',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 1,
            minSf: 0,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Child Care',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 5,
            minSf: 0,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Dry Cleaning/Laundry',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 0.8,
            minSf: 0,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Conference Center',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 6,
            minSf: 1500,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Breakout Space',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 2,
            minSf: 500,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Breakout Room (8-10 seats)',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 1,
            sf: 275,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Multi-Purpose (Auditorium Style Seats)',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 4.7,
            minSf: 1250,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Training (Class Seating w/ Tables)',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 4.7,
            sf: 1250,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Training (60 seats at tables)',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 2.2,
            sf: 2400,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Auditorium',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 2.2,
            minSf: 1500,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Audio/Visual',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 0.25,
            minSf: 150,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Furniture Storage',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 0.25,
            minSf: 150,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Coats',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 0.1,
            sf: 40,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Reception',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 2.5,
            minSf: 800,
            maxSf: 2500,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Receptionist',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 0.5,
            minSf: 150,
            maxSf: 300,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Mail Center',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 0.5,
            minSf: 200,
            maxSf: 1200,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Reproduction Room',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 0.8,
            minSf: 400,
            maxSf: 1200,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Security Control Room',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 0.5,
            minSf: 200,
            maxSf: 1000,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Data Center',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 1.5,
            minSf: 500,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Building Support Services',
            category: $f7e515094633b4c5$var$CATEGORY.AMENITY,
            multiplier: 2.1,
            minSf: 0,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY
        },
        {
            name: 'Internal Stair',
            category: $f7e515094633b4c5$var$CATEGORY.SUPPORT,
            multiplier: 1,
            sf: 500,
            circulationType: $f7e515094633b4c5$var$CIRCULATION_TYPE.AMENITY,
            isFloorDependent: true
        }
    ]
};

});

parcelRegister("jEhAf", function(module, exports) {

var $aB89e = parcelRequire("aB89e");
var $e4df64808ef9f3a9$require$constants = $aB89e.spacerFree;
const $e4df64808ef9f3a9$var$brokerEmailTypeToSubject = {
    [$e4df64808ef9f3a9$require$constants.contact.SPACER_SUPPORT_CONTACT_TYPES.SAVE_OTH]: 'OTH - Spacer Referral: New Saved Program',
    [$e4df64808ef9f3a9$require$constants.contact.SPACER_SUPPORT_CONTACT_TYPES.SAVE_EMEA]: 'EMEA - Spacer Referral: New Saved Program',
    [$e4df64808ef9f3a9$require$constants.contact.SPACER_SUPPORT_CONTACT_TYPES.SAVE_US]: 'US - Spacer Referral: New Saved Program',
    [$e4df64808ef9f3a9$require$constants.contact.SPACER_SUPPORT_CONTACT_TYPES.SAVE_APAC]: 'APAC - Spacer Referral: New Saved Program'
};
module.exports = {
    brokerEmailTypeToSubject: $e4df64808ef9f3a9$var$brokerEmailTypeToSubject
};

});

parcelRegister("3w8Fq", function(module, exports) {

const { CIRCULATION_TYPE: $28fb1558bef5d46b$var$CIRCULATION_TYPE, CATEGORY: $28fb1558bef5d46b$var$CATEGORY } = (parcelRequire("aB89e")).shared.spaceUnit;
module.exports = {
    SHARED_FOCUS_AUTOFILL_OPTIONS: [
        {
            name: 'Focus Room',
            category: $28fb1558bef5d46b$var$CATEGORY.SHARED_FOCUS,
            ratio: 20,
            sf: 120,
            seats: 1,
            circulationType: $28fb1558bef5d46b$var$CIRCULATION_TYPE.ENCLOSED
        },
        {
            name: 'Library Seating Area',
            category: $28fb1558bef5d46b$var$CATEGORY.SHARED_FOCUS,
            ratio: 150,
            sf: 500,
            seats: 10,
            circulationType: $28fb1558bef5d46b$var$CIRCULATION_TYPE.OPEN
        }
    ]
};

});

parcelRegister("3owcF", function(module, exports) {

var $4Ds5C = parcelRequire("4Ds5C");

var $4MjDQ = parcelRequire("4MjDQ");
var $278c97e7c3324bd9$require$profileNameIds = $4MjDQ.profileNameIds;

var $f1q41 = parcelRequire("f1q41");

const { CATEGORY: $278c97e7c3324bd9$var$CATEGORY } = (parcelRequire("aB89e")).shared.spaceUnit;

var $4ICSb = parcelRequire("4ICSb");

const { US_REGULAR: $278c97e7c3324bd9$var$US_REGULAR } = (parcelRequire("aB89e")).spacerFree.calculator.PROFILE_TYPE;

const { MEDIUM: $278c97e7c3324bd9$var$MEDIUM } = (parcelRequire("aB89e")).spacerFree.calculator.COLLABORATION_LEVEL;

const { COLLABORATION_BLANK_TEMPLATE: $278c97e7c3324bd9$var$COLLABORATION_BLANK_TEMPLATE } = (parcelRequire("aB89e")).spacerPro.blankTemplatePopulationLocation;
const $278c97e7c3324bd9$var$profileMap = $f1q41.cloneDeep($4ICSb);
function $278c97e7c3324bd9$var$getWeKitOfPartsWithMultiplier(weKitOfParts, program) {
    $f1q41.forEach(weKitOfParts, (spaceUnitWithMultiplier)=>{
        const spaceUnit = $4Ds5C[spaceUnitWithMultiplier.spaceUnitId];
        const weUnit = {
            name: spaceUnit.displayName,
            category: spaceUnit.category,
            sf: spaceUnit.sf,
            circulationType: spaceUnit.circulationType,
            seats: spaceUnit.seats,
            multiplier: spaceUnitWithMultiplier.multiplier
        };
        program.we.push(weUnit);
    });
}
function $278c97e7c3324bd9$var$getKitOfPartsWithMultiplierAndAssumptions(profileKitOfParts, collaborationRatio) {
    let program = {
        me: [],
        we: [],
        sharedFocus: [],
        support: [],
        amenity: [],
        assumptions: {}
    };
    $278c97e7c3324bd9$var$getWeKitOfPartsWithMultiplier(profileKitOfParts[$278c97e7c3324bd9$var$CATEGORY.WE], program);
    program = {
        ...program,
        assumptions: {
            sharingPopulation: 1,
            collaborationRatio: collaborationRatio,
            assignedSeating: true
        }
    };
    return program;
}
function $278c97e7c3324bd9$var$getTemplateWithoutOrder(profileMapId) {
    const profileInfo = $278c97e7c3324bd9$var$profileMap[profileMapId];
    return {
        // the substring(4) is to chop of `The ` from the beginning of the name, ex: `The Optimizer` -> `Optimizer`
        name: profileInfo.displayName.substring(4),
        id: profileInfo.id,
        templateType: 'collaboration',
        program: $278c97e7c3324bd9$var$getKitOfPartsWithMultiplierAndAssumptions(profileInfo.kitOfPartsWithMultipliers[$278c97e7c3324bd9$var$US_REGULAR], profileInfo.collaborationLevels[$278c97e7c3324bd9$var$US_REGULAR][$278c97e7c3324bd9$var$MEDIUM])
    };
}
// All profiles based off Spacer Free US_Regular profiles, blank template only has basic support rows
module.exports = [
    $278c97e7c3324bd9$var$COLLABORATION_BLANK_TEMPLATE,
    $278c97e7c3324bd9$var$getTemplateWithoutOrder($278c97e7c3324bd9$require$profileNameIds.EFFICIENT),
    $278c97e7c3324bd9$var$getTemplateWithoutOrder($278c97e7c3324bd9$require$profileNameIds.WHITE_COLLAR),
    $278c97e7c3324bd9$var$getTemplateWithoutOrder($278c97e7c3324bd9$require$profileNameIds.WHITE_GLOVE),
    $278c97e7c3324bd9$var$getTemplateWithoutOrder($278c97e7c3324bd9$require$profileNameIds.OPEN_OFFICE),
    $278c97e7c3324bd9$var$getTemplateWithoutOrder($278c97e7c3324bd9$require$profileNameIds.WORKPLACE_360),
    $278c97e7c3324bd9$var$getTemplateWithoutOrder($278c97e7c3324bd9$require$profileNameIds.CAMPUS),
    $278c97e7c3324bd9$var$getTemplateWithoutOrder($278c97e7c3324bd9$require$profileNameIds.STARTUP),
    $278c97e7c3324bd9$var$getTemplateWithoutOrder($278c97e7c3324bd9$require$profileNameIds.ENG_CREATIVE)
];

});



parcelRegister("hjiT0", function(module, exports) {

var $aB89e = parcelRequire("aB89e");
var $c9a2dc67d37b0712$require$constants = $aB89e.spacerFree;

var $aB89e = parcelRequire("aB89e");
var $c9a2dc67d37b0712$require$sharedConstants = $aB89e.shared;

var $f1q41 = parcelRequire("f1q41");
function $c9a2dc67d37b0712$var$isUSA(country) {
    // the majority of US locations will have a country of "USA"
    // however, there are edge cases like "Arlington, VA, USA (Arlington County)" which we parse as having a country of "USA (Arlington County)"
    return country.indexOf('USA') === 0;
}
function $c9a2dc67d37b0712$var$isCanada(country) {
    return country === 'CAN';
}
function $c9a2dc67d37b0712$var$isUK(country) {
    return country === 'GBR';
}
function $c9a2dc67d37b0712$var$isGermany(country) {
    return country === 'DEU';
}
function $c9a2dc67d37b0712$var$isSpain(country) {
    return country === 'ESP';
}
function $c9a2dc67d37b0712$var$isLondon(location) {
    return location === 'London, England, GBR';
}
function $c9a2dc67d37b0712$var$isJapan(country) {
    return country === 'JPN';
}
function $c9a2dc67d37b0712$var$isFrance(country) {
    return country === 'FRA';
}
function $c9a2dc67d37b0712$var$isSlovakia(country) {
    return country === 'SVK';
}
function $c9a2dc67d37b0712$var$isPoland(country) {
    return country === 'POL';
}
function $c9a2dc67d37b0712$var$isHungary(country) {
    return country === 'HUN';
}
function $c9a2dc67d37b0712$var$isNetherland(country) {
    return country === 'NLD';
}
function $c9a2dc67d37b0712$var$isColombia(country) {
    return country === 'COL';
}
function $c9a2dc67d37b0712$var$isCalifornia(state, country) {
    return state === 'CA' && $c9a2dc67d37b0712$var$isUSA(country);
}
function $c9a2dc67d37b0712$var$isEuropeanEconomicArea(country) {
    // https://www.gov.uk/eu-eea
    return [
        'AUT',
        'BEL',
        'BGR',
        'CYP',
        'CZE',
        'DEU',
        'DNK',
        'EST',
        'ESP',
        'FIN',
        'FRA',
        'GBR',
        'GRC',
        'HRV',
        'HUN',
        'NLD',
        'IRL',
        'ISL',
        'ITA',
        'LIE',
        'LVA',
        'LTU',
        'LUX',
        'MLT',
        'NOR',
        'NLD',
        'POL',
        'PRT',
        'ROU',
        'SVK',
        'SVN',
        'SWE'
    ].indexOf(country) >= 0;
}
function $c9a2dc67d37b0712$var$isAfrica(country) {
    return [
        'DZA',
        'AGO',
        'BEN',
        'BWA',
        'BFA',
        'BDI',
        'CMR',
        'CPV',
        'CAF',
        'COM',
        'COD',
        'DJI',
        'EGY',
        'GNQ',
        'ERI',
        'ETH',
        'GAB',
        'GMB',
        'GHA',
        'GIN',
        'GNB',
        'CIV',
        'KEN',
        'LSO',
        'LBR',
        'LBY',
        'MDG',
        'MWI',
        'MRT',
        'MUS',
        'MAR',
        'MOZ',
        'NAM',
        'NER',
        'NGA',
        'COG',
        'REU',
        'RWA',
        'SHN',
        'STP',
        'SEN',
        'SYC',
        'SLE',
        'SOM',
        'ZAF',
        'SSD',
        'SDN',
        'SWZ',
        'TZA',
        'TGO',
        'TUN',
        'UGA',
        'ESH',
        'ZMB',
        'ZWE'
    ].indexOf(country) >= 0;
}
function $c9a2dc67d37b0712$var$isMiddleEast(country) {
    return [
        'ARM',
        'AZE',
        'BHR',
        'GEO',
        'IRN',
        'IRQ',
        'ISR',
        'JOR',
        'KWT',
        'LBN',
        'NTZ',
        'OMN',
        'QAT',
        'SAU',
        'SYR',
        'TUR',
        'TKM',
        'ARE',
        'YEM'
    ].indexOf(country) >= 0;
}
function $c9a2dc67d37b0712$var$isEMEA(country) {
    return $c9a2dc67d37b0712$var$isEuropeanEconomicArea(country) || $c9a2dc67d37b0712$var$isAfrica(country) || $c9a2dc67d37b0712$var$isMiddleEast(country);
}
function $c9a2dc67d37b0712$var$isAPAC(country) {
    // https://www.imf.org/external/oap/about.htm#asiaregion
    return [
        'AUS',
        'BGD',
        'BTN',
        'BRN',
        'KHM',
        'CHN',
        'HKG',
        'MAC',
        'FJI',
        'IND',
        'IDN',
        'JPN',
        'KIR',
        'KOR',
        'LAO',
        'MYS',
        'MDV',
        'MHL',
        'FSM',
        'MNG',
        'MMR',
        'NPL',
        'NZL',
        'PLW',
        'PNG',
        'PHL',
        'WSM',
        'SGP',
        'SLB',
        'LKA',
        'THA',
        'TLS',
        'TON',
        'TUV',
        'VUT',
        'VNM'
    ].indexOf(country) >= 0;
}
function $c9a2dc67d37b0712$var$getCityStateCountry(location) {
    let locationParts = location.split(',');
    locationParts = locationParts.map((loc)=>$f1q41.trim(loc));
    const country = locationParts[locationParts.length - 1];
    const [city, state] = locationParts;
    // Example bad format: Butt Butt, Butt Butt County, BT, USA (for USA we expect CITY, STATE, COUNTRY)
    const nonStandardUSAFormat = $c9a2dc67d37b0712$var$isUSA(country) && locationParts.length !== 3;
    return {
        city: city,
        state: state,
        country: country,
        nonStandardUSAFormat: nonStandardUSAFormat
    };
}
function $c9a2dc67d37b0712$var$getMeasurementSystemForLocation(location) {
    const { country: country } = $c9a2dc67d37b0712$var$getCityStateCountry(location);
    if ($c9a2dc67d37b0712$var$isUSA(country) || $c9a2dc67d37b0712$var$isCanada(country) || $c9a2dc67d37b0712$var$isLondon(location)) return $c9a2dc67d37b0712$require$sharedConstants.calculator.MEASUREMENT_SYSTEM.IMPERIAL;
    if ($c9a2dc67d37b0712$var$isJapan(country)) return $c9a2dc67d37b0712$require$sharedConstants.calculator.MEASUREMENT_SYSTEM.TSUBO;
    return $c9a2dc67d37b0712$require$sharedConstants.calculator.MEASUREMENT_SYSTEM.METRIC;
}
function $c9a2dc67d37b0712$var$getSFTypeForLocation(location) {
    const { country: country } = $c9a2dc67d37b0712$var$getCityStateCountry(location);
    if ($c9a2dc67d37b0712$var$isUK(country) || $c9a2dc67d37b0712$var$isAPAC(country)) return $c9a2dc67d37b0712$require$constants.calculator.SF_TYPE.NIA;
    return $c9a2dc67d37b0712$require$constants.calculator.SF_TYPE.RSF;
}
// to restrict the plans public links to 2D version  , Add countries here in future to enable for other countries
function $c9a2dc67d37b0712$var$is2DExampleLinkLocation(location) {
    const { country: country } = $c9a2dc67d37b0712$var$getCityStateCountry(location);
    return $c9a2dc67d37b0712$var$isNetherland(country);
}
module.exports = {
    isUSA: // countries
    $c9a2dc67d37b0712$var$isUSA,
    isUK: $c9a2dc67d37b0712$var$isUK,
    isJapan: $c9a2dc67d37b0712$var$isJapan,
    isGermany: $c9a2dc67d37b0712$var$isGermany,
    isSpain: $c9a2dc67d37b0712$var$isSpain,
    isFrance: $c9a2dc67d37b0712$var$isFrance,
    isSlovakia: $c9a2dc67d37b0712$var$isSlovakia,
    isPoland: $c9a2dc67d37b0712$var$isPoland,
    isHungary: $c9a2dc67d37b0712$var$isHungary,
    isNetherland: $c9a2dc67d37b0712$var$isNetherland,
    isColombia: $c9a2dc67d37b0712$var$isColombia,
    isCalifornia: // US states
    $c9a2dc67d37b0712$var$isCalifornia,
    isEuropeanEconomicArea: // regions
    $c9a2dc67d37b0712$var$isEuropeanEconomicArea,
    isAfrica: $c9a2dc67d37b0712$var$isAfrica,
    isMiddleEast: $c9a2dc67d37b0712$var$isMiddleEast,
    isEMEA: $c9a2dc67d37b0712$var$isEMEA,
    isAPAC: $c9a2dc67d37b0712$var$isAPAC,
    getCityStateCountry: // other util functions
    $c9a2dc67d37b0712$var$getCityStateCountry,
    getMeasurementSystemForLocation: $c9a2dc67d37b0712$var$getMeasurementSystemForLocation,
    getSFTypeForLocation: $c9a2dc67d37b0712$var$getSFTypeForLocation,
    is2DExampleLinkLocation: $c9a2dc67d37b0712$var$is2DExampleLinkLocation
};

});

parcelRegister("jJqAQ", function(module, exports) {
/* eslint-disable react-hooks/rules-of-hooks */ 
const { CIRCULATION_TYPE: $e5d6d926da4f786d$var$CIRCULATION_TYPE, STANDARD_CIRCULATION_MAP: $e5d6d926da4f786d$var$STANDARD_CIRCULATION_MAP, HIGH_CIRCULATION_MAP: $e5d6d926da4f786d$var$HIGH_CIRCULATION_MAP, APAC_CIRCULATION_MAP: $e5d6d926da4f786d$var$APAC_CIRCULATION_MAP, COUNTRIES_CIRCULATION_MAP: $e5d6d926da4f786d$var$COUNTRIES_CIRCULATION_MAP } = (parcelRequire("aB89e")).shared.spaceUnit;

var $hjiT0 = parcelRequire("hjiT0");
/*
    The Shared Program Calculator is a module that returns a set of functions for program calculations.

    Initially, the module only returns the "init" function.

    Once "init" has been called:
      - all other calculation functions become publicly available
      - the module has local access to metrics including: work seats, group seats, headcount, and blended circulation percentage
*/ // *************************************
//  PRIVATE
// *************************************
// Program-Specific Variables
const $e5d6d926da4f786d$var$programMetrics = {
    headcount: 0,
    workSeats: 0,
    groupSeats: 0,
    officeDensity: null,
    blendedCircPercentage: null
};
let $e5d6d926da4f786d$var$calculatorIsInited = false;
let $e5d6d926da4f786d$var$country_var;
const $e5d6d926da4f786d$var$programFunctions = {
    // gets defined during init, custom functions can be passed in
    getCirculationPercentageFromCircType: ()=>null,
    getCirculationTypeFromProgramPart: ()=>null
};
// *************************************
//  PUBLIC
// *************************************
const $e5d6d926da4f786d$var$calculateUSF = (nsf, unitCircType)=>{
    const circulationPercentage = $e5d6d926da4f786d$var$programFunctions.getCirculationPercentageFromCircType(unitCircType);
    return Math.round(nsf / (1 - circulationPercentage));
};
const $e5d6d926da4f786d$var$calculateMeSharedFocusWeSupportProgramPartNSFAndUSF = ({ quantity: quantity, unitSF: unitSF, unitCircType: unitCircType })=>{
    const nsf = quantity * unitSF;
    const usf = $e5d6d926da4f786d$var$calculateUSF(nsf, unitCircType);
    return {
        nsf: nsf,
        usf: usf
    };
};
const $e5d6d926da4f786d$var$calculateMeProgramPart = ({ multiplier: multiplier, unitSF: unitSF, unitCircType: unitCircType })=>{
    const quantity = Math.round(multiplier * $e5d6d926da4f786d$var$programMetrics.workSeats);
    const { nsf: nsf, usf: usf } = $e5d6d926da4f786d$var$calculateMeSharedFocusWeSupportProgramPartNSFAndUSF({
        quantity: quantity,
        unitSF: unitSF,
        unitCircType: unitCircType
    });
    return {
        quantity: quantity,
        nsf: nsf,
        usf: usf
    };
};
const $e5d6d926da4f786d$var$calculateSharedFocusProgramPart = ({ unitSF: unitSF, unitCircType: unitCircType, ratio: ratio, totalOpenMeSeats: totalOpenMeSeats })=>{
    const quantity = ratio ? Math.round(totalOpenMeSeats / ratio) : 0;
    const { nsf: nsf, usf: usf } = $e5d6d926da4f786d$var$calculateMeSharedFocusWeSupportProgramPartNSFAndUSF({
        quantity: quantity,
        unitSF: unitSF,
        unitCircType: unitCircType
    });
    return {
        quantity: quantity,
        nsf: nsf,
        usf: usf
    };
};
const $e5d6d926da4f786d$var$calculateWeProgramPart = ({ multiplier: multiplier, unitSeats: unitSeats, unitSF: unitSF, unitCircType: unitCircType, ratio: ratio, totalMeSeats: totalMeSeats })=>{
    let quantity;
    if (ratio === 0) quantity = 0;
    else if (ratio > 0) quantity = Math.round(totalMeSeats / ratio);
    else quantity = Math.round(multiplier * $e5d6d926da4f786d$var$programMetrics.groupSeats / unitSeats);
    const { nsf: nsf, usf: usf } = $e5d6d926da4f786d$var$calculateMeSharedFocusWeSupportProgramPartNSFAndUSF({
        quantity: quantity,
        unitSF: unitSF,
        unitCircType: unitCircType
    });
    return {
        quantity: quantity,
        nsf: nsf,
        usf: usf
    };
};
const $e5d6d926da4f786d$var$calculateSupportProgramPart = ({ multiplier: multiplier, unitSF: unitSF, unitCircType: unitCircType, isFloorDependent: isFloorDependent, floors: floors })=>{
    let quantity;
    if (isFloorDependent) quantity = Math.round((floors || 0) * multiplier); // we round here after multiplying not before - this causes display discrepancies
    else {
        const calculatedQuantity = Math.round($e5d6d926da4f786d$var$programMetrics.headcount * multiplier / unitSF);
        quantity = Math.max(calculatedQuantity, 1);
    }
    const { nsf: nsf, usf: usf } = $e5d6d926da4f786d$var$calculateMeSharedFocusWeSupportProgramPartNSFAndUSF({
        quantity: quantity,
        unitSF: unitSF,
        unitCircType: unitCircType
    });
    return {
        quantity: quantity,
        nsf: nsf,
        usf: usf
    };
};
const $e5d6d926da4f786d$var$calculateAmenityProgramPart = ({ multiplier: multiplier, unitSF: unitSF, unitCircType: unitCircType, unitMinSF: unitMinSF, unitMaxSF: unitMaxSF })=>{
    const quantity = 1;
    let nsf = multiplier ? Math.round($e5d6d926da4f786d$var$programMetrics.headcount * multiplier) : Math.round(unitSF);
    if (unitMinSF && nsf < unitMinSF) nsf = unitMinSF;
    else if (unitMaxSF && nsf > unitMaxSF) nsf = unitMaxSF;
    const usf = $e5d6d926da4f786d$var$calculateUSF(nsf, unitCircType);
    return {
        quantity: quantity,
        usf: usf,
        nsf: nsf
    };
};
const $e5d6d926da4f786d$var$updateProgramMetrics = ({ headcount: headcount, workSeats: workSeats, groupSeats: groupSeats, blendedCircPercentage: blendedCircPercentage })=>{
    // check if the value was passed with typeof instead of !! (in case the value is being set to zero)
    if (typeof headcount !== 'undefined') $e5d6d926da4f786d$var$programMetrics.headcount = headcount;
    if (typeof workSeats !== 'undefined') $e5d6d926da4f786d$var$programMetrics.workSeats = workSeats;
    if (typeof groupSeats !== 'undefined') $e5d6d926da4f786d$var$programMetrics.groupSeats = groupSeats;
    if (typeof blendedCircPercentage !== 'undefined') $e5d6d926da4f786d$var$programMetrics.blendedCircPercentage = blendedCircPercentage;
};
const $e5d6d926da4f786d$var$getProgramMetrics = ()=>$e5d6d926da4f786d$var$programMetrics;
const $e5d6d926da4f786d$var$calculateCategoryUSFTotals = ({ meSpaces: meSpaces, weSpaces: weSpaces, amenitySpaces: amenitySpaces })=>{
    // Suggested or calculated
    let totalMeSF = 0;
    let totalWeSF = 0;
    let totalAmenitySF = 0;
    // User adjusted
    let totalCustomMeSF = 0;
    let totalCustomWeSF = 0;
    let totalCustomAmenitySF = 0;
    meSpaces.forEach((space)=>{
        totalMeSF += space.usf;
        totalCustomMeSF += space.customUSF || space.usf;
    });
    weSpaces.forEach((space)=>{
        totalWeSF += space.usf;
        totalCustomWeSF += space.customUSF || space.usf;
    });
    amenitySpaces.forEach((space)=>{
        totalAmenitySF += space.usf;
        totalCustomAmenitySF += space.customUSF || space.usf;
    });
    const totalSF = totalMeSF + totalWeSF + totalAmenitySF;
    const totalCustomSF = totalCustomMeSF + totalCustomWeSF + totalCustomAmenitySF;
    const areaTotals = {
        totalMeSF: totalMeSF,
        totalWeSF: totalWeSF,
        totalAmenitySF: totalAmenitySF,
        totalSF: totalSF
    };
    if (totalMeSF !== totalCustomMeSF) areaTotals.totalCustomMeSF = totalCustomMeSF;
    if (totalWeSF !== totalCustomWeSF) areaTotals.totalCustomWeSF = totalCustomWeSF;
    if (totalAmenitySF !== totalCustomAmenitySF) areaTotals.totalCustomAmenitySF = totalCustomAmenitySF;
    if (totalSF !== totalCustomSF) areaTotals.totalCustomSF = totalCustomSF;
    return areaTotals;
};
const $e5d6d926da4f786d$var$getCirculationPercentageFromCircTypeWithStandardCirculationMap = (circType)=>{
    let standard_circulation_map;
    const circulation_map = $e5d6d926da4f786d$var$COUNTRIES_CIRCULATION_MAP[$e5d6d926da4f786d$var$country_var];
    if (circulation_map) standard_circulation_map = circulation_map['STANDARD_CIRCULATION_MAP'];
    else standard_circulation_map = $e5d6d926da4f786d$var$STANDARD_CIRCULATION_MAP;
    if (circType === $e5d6d926da4f786d$var$CIRCULATION_TYPE.BLENDED) return $e5d6d926da4f786d$var$programMetrics.blendedCircPercentage;
    return standard_circulation_map[circType];
};
const $e5d6d926da4f786d$var$getCirculationPercentageFromCircTypeWithHighCirculationMap = (circType)=>{
    let high_circulation_map;
    const circulation_map = $e5d6d926da4f786d$var$COUNTRIES_CIRCULATION_MAP[$e5d6d926da4f786d$var$country_var];
    if (circulation_map) high_circulation_map = circulation_map['HIGH_CIRCULATION_MAP'];
    else high_circulation_map = $e5d6d926da4f786d$var$HIGH_CIRCULATION_MAP;
    if (circType === $e5d6d926da4f786d$var$CIRCULATION_TYPE.BLENDED) return $e5d6d926da4f786d$var$programMetrics.blendedCircPercentage;
    return high_circulation_map[circType];
};
// with custom circulation maps, treat blended circulation spaces as if they had amenity circulation
const $e5d6d926da4f786d$var$useCustomCirculationMap = (customCirculationMap)=>{
    $e5d6d926da4f786d$var$programFunctions.getCirculationPercentageFromCircType = (circType)=>{
        if (circType === $e5d6d926da4f786d$var$CIRCULATION_TYPE.BLENDED) return customCirculationMap[$e5d6d926da4f786d$var$CIRCULATION_TYPE.AMENITY];
        return customCirculationMap[circType];
    };
};
const $e5d6d926da4f786d$var$isCalculatorInited = ()=>$e5d6d926da4f786d$var$calculatorIsInited;
const $e5d6d926da4f786d$var$postInitPublicCalcFunctions = {
    calculateMeProgramPart: // Program Part
    $e5d6d926da4f786d$var$calculateMeProgramPart,
    calculateSharedFocusProgramPart: $e5d6d926da4f786d$var$calculateSharedFocusProgramPart,
    calculateWeProgramPart: $e5d6d926da4f786d$var$calculateWeProgramPart,
    calculateAmenityProgramPart: $e5d6d926da4f786d$var$calculateAmenityProgramPart,
    calculateSupportProgramPart: $e5d6d926da4f786d$var$calculateSupportProgramPart,
    calculateUSF: // Program Part NSF and USF
    $e5d6d926da4f786d$var$calculateUSF,
    calculateMeSharedFocusWeSupportProgramPartNSFAndUSF: $e5d6d926da4f786d$var$calculateMeSharedFocusWeSupportProgramPartNSFAndUSF,
    updateProgramMetrics: // Util
    $e5d6d926da4f786d$var$updateProgramMetrics,
    useCustomCirculationMap: $e5d6d926da4f786d$var$useCustomCirculationMap,
    getProgramMetrics: $e5d6d926da4f786d$var$getProgramMetrics,
    calculateCategoryUSFTotals: $e5d6d926da4f786d$var$calculateCategoryUSFTotals
};
// customCirculationMap, if it exists, is expected to follow layout of STANDARD_CIRCULATION_MAP and define values for open, enclosed and amenity circulation
const $e5d6d926da4f786d$var$publicCalcFunctions = {};
$e5d6d926da4f786d$var$publicCalcFunctions.init = ({ workSeats: workSeats = 0, groupSeats: groupSeats = 0, headcount: headcount = 0, officeDensity: officeDensity, officeLocation: officeLocation = 'USA', getCirculationTypeFromProgramPart: getCirculationTypeFromProgramPart, customCirculationMap: customCirculationMap })=>{
    $e5d6d926da4f786d$var$calculatorIsInited = true;
    // Define program-specific variables and functions
    $e5d6d926da4f786d$var$programMetrics.headcount = headcount;
    $e5d6d926da4f786d$var$programMetrics.workSeats = workSeats;
    $e5d6d926da4f786d$var$programMetrics.groupSeats = groupSeats;
    $e5d6d926da4f786d$var$programMetrics.officeDensity = officeDensity;
    $e5d6d926da4f786d$var$programFunctions.getCirculationTypeFromProgramPart = getCirculationTypeFromProgramPart || ((programPart)=>programPart.circulationType);
    // APAC spaces have special APAC_CIRCULATION (unless customCirculationMap is specifically passed in)
    const { country: country } = $hjiT0.getCityStateCountry(officeLocation);
    $e5d6d926da4f786d$var$country_var = country;
    const isAPAC = $hjiT0.isAPAC(country);
    if (isAPAC) customCirculationMap = customCirculationMap || $e5d6d926da4f786d$var$APAC_CIRCULATION_MAP;
    if (customCirculationMap) $e5d6d926da4f786d$var$useCustomCirculationMap(customCirculationMap);
    else $e5d6d926da4f786d$var$programFunctions.getCirculationPercentageFromCircType = $e5d6d926da4f786d$var$programMetrics.officeDensity === 2 ? $e5d6d926da4f786d$var$getCirculationPercentageFromCircTypeWithHighCirculationMap : $e5d6d926da4f786d$var$getCirculationPercentageFromCircTypeWithStandardCirculationMap;
    // Add all other functions to public calc object
    Object.assign($e5d6d926da4f786d$var$publicCalcFunctions, $e5d6d926da4f786d$var$postInitPublicCalcFunctions);
};
$e5d6d926da4f786d$var$publicCalcFunctions.isCalculatorInited = $e5d6d926da4f786d$var$isCalculatorInited;
module.exports = $e5d6d926da4f786d$var$publicCalcFunctions;

});

parcelRegister("3GYAO", function(module, exports) {

$parcel$export(module.exports, "GAInitialize", () => $2b044bca4f499e79$export$1d6dd4e5e565d1a8);
$parcel$export(module.exports, "GATrackRoute", () => $2b044bca4f499e79$export$b60d474022572a13);
$parcel$export(module.exports, "GAEvent", () => $2b044bca4f499e79$export$7a7e272aa17eec54);

var $lKQ61 = parcelRequire("lKQ61");

var $7YV43 = parcelRequire("7YV43");
const $2b044bca4f499e79$var$isDev = (0, (/*@__PURE__*/$parcel$interopDefault($7YV43))).IS_DEV;
const $2b044bca4f499e79$export$1d6dd4e5e565d1a8 = ()=>{
    if ($2b044bca4f499e79$var$isDev) console.log("[GA] Initialize | trackingId:", window.SERVER_DATA.featureFlags.googleId);
    if (window.SERVER_DATA.featureFlags.isGoogleAnalyticsEnabled == "true") {
        (0, (/*@__PURE__*/$parcel$interopDefault($lKQ61))).initialize([
            {
                trackingId: window.SERVER_DATA.featureFlags.googleId
            }
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($lKQ61))).ga("set", "anonymizeIp", true);
    }
};
const $2b044bca4f499e79$export$b60d474022572a13 = (path, title)=>{
    if ($2b044bca4f499e79$var$isDev) console.log("[GA] Pageview | path:", path, "| title:", title);
    if (window.SERVER_DATA.featureFlags.isGoogleAnalyticsEnabled == "true") (0, (/*@__PURE__*/$parcel$interopDefault($lKQ61))).send({
        hitType: "pageview",
        page: path,
        title: title
    });
};
const $2b044bca4f499e79$export$7a7e272aa17eec54 = (category, action, label, value = 0)=>{
    if ($2b044bca4f499e79$var$isDev) console.log("[GA] Event | category:", category, "| action:", action, "| label:", label, "| value:", value);
    if (window.SERVER_DATA.featureFlags.isGoogleAnalyticsEnabled == "true") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: action,
            event_category: category,
            event_label: label,
            value: value
        });
    }
};

});
parcelRegister("lKQ61", function(module, exports) {
"use strict";
function $fd664e149db4c2ea$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fd664e149db4c2ea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fd664e149db4c2ea$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.ReactGAImplementation = void 0;

var $fd664e149db4c2ea$var$_ga = $fd664e149db4c2ea$var$_interopRequireWildcard((parcelRequire("hdGlG")));
function $fd664e149db4c2ea$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($fd664e149db4c2ea$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $fd664e149db4c2ea$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $fd664e149db4c2ea$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $fd664e149db4c2ea$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $fd664e149db4c2ea$var$ReactGAImplementation = $fd664e149db4c2ea$var$_ga.GA4;
module.exports.ReactGAImplementation = $fd664e149db4c2ea$var$ReactGAImplementation;
var $fd664e149db4c2ea$var$_default = $fd664e149db4c2ea$var$_ga["default"];
module.exports["default"] = $fd664e149db4c2ea$var$_default;

});
parcelRegister("hdGlG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.GA4 = void 0;

var $c8948021b554a410$var$_gtag = $c8948021b554a410$var$_interopRequireDefault((parcelRequire("brtX6")));

var $c8948021b554a410$var$_format = $c8948021b554a410$var$_interopRequireDefault((parcelRequire("k0qU7")));
var $c8948021b554a410$var$_excluded = [
    "eventCategory",
    "eventAction",
    "eventLabel",
    "eventValue",
    "hitType"
], $c8948021b554a410$var$_excluded2 = [
    "title",
    "location"
], $c8948021b554a410$var$_excluded3 = [
    "page",
    "hitType"
];
function $c8948021b554a410$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c8948021b554a410$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c8948021b554a410$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c8948021b554a410$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c8948021b554a410$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c8948021b554a410$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c8948021b554a410$var$_typeof(obj);
}
function $c8948021b554a410$var$_toConsumableArray(arr) {
    return $c8948021b554a410$var$_arrayWithoutHoles(arr) || $c8948021b554a410$var$_iterableToArray(arr) || $c8948021b554a410$var$_unsupportedIterableToArray(arr) || $c8948021b554a410$var$_nonIterableSpread();
}
function $c8948021b554a410$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c8948021b554a410$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c8948021b554a410$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c8948021b554a410$var$_arrayLikeToArray(arr);
}
function $c8948021b554a410$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c8948021b554a410$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c8948021b554a410$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c8948021b554a410$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c8948021b554a410$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c8948021b554a410$var$_slicedToArray(arr, i) {
    return $c8948021b554a410$var$_arrayWithHoles(arr) || $c8948021b554a410$var$_iterableToArrayLimit(arr, i) || $c8948021b554a410$var$_unsupportedIterableToArray(arr, i) || $c8948021b554a410$var$_nonIterableRest();
}
function $c8948021b554a410$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c8948021b554a410$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c8948021b554a410$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c8948021b554a410$var$_arrayLikeToArray(o, minLen);
}
function $c8948021b554a410$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c8948021b554a410$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $c8948021b554a410$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c8948021b554a410$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c8948021b554a410$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c8948021b554a410$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c8948021b554a410$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c8948021b554a410$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c8948021b554a410$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c8948021b554a410$var$_defineProperty(obj, key, value) {
    key = $c8948021b554a410$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c8948021b554a410$var$_toPropertyKey(arg) {
    var key = $c8948021b554a410$var$_toPrimitive(arg, "string");
    return $c8948021b554a410$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c8948021b554a410$var$_toPrimitive(input, hint) {
    if ($c8948021b554a410$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c8948021b554a410$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/ /**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */ /**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */ /**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */ var $c8948021b554a410$var$GA4 = /*#__PURE__*/ function() {
    function GA4() {
        var _this = this;
        $c8948021b554a410$var$_classCallCheck(this, GA4);
        $c8948021b554a410$var$_defineProperty(this, "reset", function() {
            _this.isInitialized = false;
            _this._testMode = false;
            _this._currentMeasurementId;
            _this._hasLoadedGA = false;
            _this._isQueuing = false;
            _this._queueGtag = [];
        });
        $c8948021b554a410$var$_defineProperty(this, "_gtag", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!_this._testMode) {
                if (_this._isQueuing) _this._queueGtag.push(args);
                else $c8948021b554a410$var$_gtag["default"].apply(void 0, args);
            } else _this._queueGtag.push(args);
        });
        $c8948021b554a410$var$_defineProperty(this, "_loadGA", function(GA_MEASUREMENT_ID, nonce) {
            var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
            if (typeof window === "undefined" || typeof document === "undefined") return;
            if (!_this._hasLoadedGA) {
                // Global Site Tag (gtag.js) - Google Analytics
                var script = document.createElement("script");
                script.async = true;
                script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
                if (nonce) script.setAttribute("nonce", nonce);
                document.body.appendChild(script);
                window.dataLayer = window.dataLayer || [];
                window.gtag = function gtag() {
                    window.dataLayer.push(arguments);
                };
                _this._hasLoadedGA = true;
            }
        });
        $c8948021b554a410$var$_defineProperty(this, "_toGtagOptions", function(gaOptions) {
            if (!gaOptions) return;
            var mapFields = {
                // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
                // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
                cookieUpdate: "cookie_update",
                cookieExpires: "cookie_expires",
                cookieDomain: "cookie_domain",
                cookieFlags: "cookie_flags",
                // must be in set method?
                userId: "user_id",
                clientId: "client_id",
                anonymizeIp: "anonymize_ip",
                // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
                contentGroup1: "content_group1",
                contentGroup2: "content_group2",
                contentGroup3: "content_group3",
                contentGroup4: "content_group4",
                contentGroup5: "content_group5",
                // https://support.google.com/analytics/answer/9050852?hl=en
                allowAdFeatures: "allow_google_signals",
                allowAdPersonalizationSignals: "allow_ad_personalization_signals",
                nonInteraction: "non_interaction",
                page: "page_path",
                hitCallback: "event_callback"
            };
            var gtagOptions = Object.entries(gaOptions).reduce(function(prev, _ref) {
                var _ref2 = $c8948021b554a410$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                if (mapFields[key]) prev[mapFields[key]] = value;
                else prev[key] = value;
                return prev;
            }, {});
            return gtagOptions;
        });
        $c8948021b554a410$var$_defineProperty(this, "initialize", function(GA_MEASUREMENT_ID) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (!GA_MEASUREMENT_ID) throw new Error("Require GA_MEASUREMENT_ID");
            var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [
                {
                    trackingId: GA_MEASUREMENT_ID
                }
            ] : GA_MEASUREMENT_ID;
            _this._currentMeasurementId = initConfigs[0].trackingId;
            var gaOptions = options.gaOptions, gtagOptions = options.gtagOptions, nonce = options.nonce, _options$testMode = options.testMode, testMode = _options$testMode === void 0 ? false : _options$testMode, gtagUrl = options.gtagUrl;
            _this._testMode = testMode;
            if (!testMode) _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
            if (!_this.isInitialized) {
                _this._gtag("js", new Date());
                initConfigs.forEach(function(config) {
                    var mergedGtagOptions = $c8948021b554a410$var$_objectSpread($c8948021b554a410$var$_objectSpread($c8948021b554a410$var$_objectSpread({}, _this._toGtagOptions($c8948021b554a410$var$_objectSpread($c8948021b554a410$var$_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
                    if (Object.keys(mergedGtagOptions).length) _this._gtag("config", config.trackingId, mergedGtagOptions);
                    else _this._gtag("config", config.trackingId);
                });
            }
            _this.isInitialized = true;
            if (!testMode) {
                var queues = $c8948021b554a410$var$_toConsumableArray(_this._queueGtag);
                _this._queueGtag = [];
                _this._isQueuing = false;
                while(queues.length){
                    var queue = queues.shift();
                    _this._gtag.apply(_this, $c8948021b554a410$var$_toConsumableArray(queue));
                    if (queue[0] === "get") _this._isQueuing = true;
                }
            }
        });
        $c8948021b554a410$var$_defineProperty(this, "set", function(fieldsObject) {
            if (!fieldsObject) {
                console.warn("`fieldsObject` is required in .set()");
                return;
            }
            if ($c8948021b554a410$var$_typeof(fieldsObject) !== "object") {
                console.warn("Expected `fieldsObject` arg to be an Object");
                return;
            }
            if (Object.keys(fieldsObject).length === 0) console.warn("empty `fieldsObject` given to .set()");
            _this._gaCommand("set", fieldsObject);
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommandSendEvent", function(eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
            _this._gtag("event", eventAction, $c8948021b554a410$var$_objectSpread($c8948021b554a410$var$_objectSpread({
                event_category: eventCategory,
                event_label: eventLabel,
                value: eventValue
            }, fieldsObject && {
                non_interaction: fieldsObject.nonInteraction
            }), _this._toGtagOptions(fieldsObject)));
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommandSendEventParameters", function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            if (typeof args[0] === "string") _this._gaCommandSendEvent.apply(_this, $c8948021b554a410$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$ = args[0], eventCategory = _args$.eventCategory, eventAction = _args$.eventAction, eventLabel = _args$.eventLabel, eventValue = _args$.eventValue, hitType = _args$.hitType, rest = $c8948021b554a410$var$_objectWithoutProperties(_args$, $c8948021b554a410$var$_excluded);
                _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
            }
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommandSendTiming", function(timingCategory, timingVar, timingValue, timingLabel) {
            _this._gtag("event", "timing_complete", {
                name: timingVar,
                value: timingValue,
                event_category: timingCategory,
                event_label: timingLabel
            });
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommandSendPageview", function(page, fieldsObject) {
            if (fieldsObject && Object.keys(fieldsObject).length) {
                var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject), title = _this$_toGtagOptions.title, location = _this$_toGtagOptions.location, rest = $c8948021b554a410$var$_objectWithoutProperties(_this$_toGtagOptions, $c8948021b554a410$var$_excluded2);
                _this._gtag("event", "page_view", $c8948021b554a410$var$_objectSpread($c8948021b554a410$var$_objectSpread($c8948021b554a410$var$_objectSpread($c8948021b554a410$var$_objectSpread({}, page && {
                    page_path: page
                }), title && {
                    page_title: title
                }), location && {
                    page_location: location
                }), rest));
            } else if (page) _this._gtag("event", "page_view", {
                page_path: page
            });
            else _this._gtag("event", "page_view");
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommandSendPageviewParameters", function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            if (typeof args[0] === "string") _this._gaCommandSendPageview.apply(_this, $c8948021b554a410$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$2 = args[0], page = _args$2.page, hitType = _args$2.hitType, rest = $c8948021b554a410$var$_objectWithoutProperties(_args$2, $c8948021b554a410$var$_excluded3);
                _this._gaCommandSendPageview(page, rest);
            }
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommandSend", function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
            switch(hitType){
                case "event":
                    _this._gaCommandSendEventParameters.apply(_this, args);
                    break;
                case "pageview":
                    _this._gaCommandSendPageviewParameters.apply(_this, args);
                    break;
                case "timing":
                    _this._gaCommandSendTiming.apply(_this, $c8948021b554a410$var$_toConsumableArray(args.slice(1)));
                    break;
                case "screenview":
                case "transaction":
                case "item":
                case "social":
                case "exception":
                    console.warn("Unsupported send command: ".concat(hitType));
                    break;
                default:
                    console.warn("Send command doesn't exist: ".concat(hitType));
            }
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommandSet", function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            if (typeof args[0] === "string") args[0] = $c8948021b554a410$var$_defineProperty({}, args[0], args[1]);
            _this._gtag("set", _this._toGtagOptions(args[0]));
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommand", function(command) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            switch(command){
                case "send":
                    _this._gaCommandSend.apply(_this, args);
                    break;
                case "set":
                    _this._gaCommandSet.apply(_this, args);
                    break;
                default:
                    console.warn("Command doesn't exist: ".concat(command));
            }
        });
        $c8948021b554a410$var$_defineProperty(this, "ga", function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            if (typeof args[0] === "string") _this._gaCommand.apply(_this, args);
            else {
                var readyCallback = args[0];
                _this._gtag("get", _this._currentMeasurementId, "client_id", function(clientId) {
                    _this._isQueuing = false;
                    var queues = _this._queueGtag;
                    readyCallback({
                        get: function get(property) {
                            return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
                        }
                    });
                    while(queues.length){
                        var queue = queues.shift();
                        _this._gtag.apply(_this, $c8948021b554a410$var$_toConsumableArray(queue));
                    }
                });
                _this._isQueuing = true;
            }
            return _this.ga;
        });
        $c8948021b554a410$var$_defineProperty(this, "event", function(optionsOrName, params) {
            if (typeof optionsOrName === "string") _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
            else {
                var action = optionsOrName.action, category = optionsOrName.category, label = optionsOrName.label, value = optionsOrName.value, nonInteraction = optionsOrName.nonInteraction, transport = optionsOrName.transport;
                if (!category || !action) {
                    console.warn("args.category AND args.action are required in event()");
                    return;
                }
                // Required Fields
                var fieldObject = {
                    hitType: "event",
                    eventCategory: (0, $c8948021b554a410$var$_format["default"])(category),
                    eventAction: (0, $c8948021b554a410$var$_format["default"])(action)
                };
                // Optional Fields
                if (label) fieldObject.eventLabel = (0, $c8948021b554a410$var$_format["default"])(label);
                if (typeof value !== "undefined") {
                    if (typeof value !== "number") console.warn("Expected `args.value` arg to be a Number.");
                    else fieldObject.eventValue = value;
                }
                if (typeof nonInteraction !== "undefined") {
                    if (typeof nonInteraction !== "boolean") console.warn("`args.nonInteraction` must be a boolean.");
                    else fieldObject.nonInteraction = nonInteraction;
                }
                if (typeof transport !== "undefined") {
                    if (typeof transport !== "string") console.warn("`args.transport` must be a string.");
                    else {
                        if ([
                            "beacon",
                            "xhr",
                            "image"
                        ].indexOf(transport) === -1) console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
                        fieldObject.transport = transport;
                    }
                }
                _this._gaCommand("send", fieldObject);
            }
        });
        $c8948021b554a410$var$_defineProperty(this, "send", function(fieldObject) {
            _this._gaCommand("send", fieldObject);
        });
        this.reset();
    }
    $c8948021b554a410$var$_createClass(GA4, [
        {
            key: "gtag",
            value: function gtag() {
                this._gtag.apply(this, arguments);
            }
        }
    ]);
    return GA4;
}();
module.exports.GA4 = $c8948021b554a410$var$GA4;
var $c8948021b554a410$var$_default = new $c8948021b554a410$var$GA4();
module.exports["default"] = $c8948021b554a410$var$_default;

});
parcelRegister("brtX6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $85497333f8cbed81$var$gtag = function gtag() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof window !== "undefined") {
        var _window;
        if (typeof window.gtag === "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
        }
        (_window = window).gtag.apply(_window, args);
    }
};
var $85497333f8cbed81$var$_default = $85497333f8cbed81$var$gtag;
module.exports["default"] = $85497333f8cbed81$var$_default;

});

parcelRegister("k0qU7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $e908ad5c0df5df0a$var$format;
var $e908ad5c0df5df0a$var$smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function $e908ad5c0df5df0a$var$toTitleCase(string) {
    return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
        if (index > 0 && index + match.length !== title.length && match.search($e908ad5c0df5df0a$var$smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) return match.toLowerCase();
        if (match.substr(1).search(/[A-Z]|\../) > -1) return match;
        return match.charAt(0).toUpperCase() + match.substr(1);
    });
}
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function $e908ad5c0df5df0a$var$mightBeEmail(s) {
    // There's no point trying to validate rfc822 fully, just look for ...@...
    return typeof s === "string" && s.indexOf("@") !== -1;
}
var $e908ad5c0df5df0a$var$redacted = "REDACTED (Potential Email Address)";
function $e908ad5c0df5df0a$var$redactEmail(string) {
    if ($e908ad5c0df5df0a$var$mightBeEmail(string)) {
        console.warn("This arg looks like an email address, redacting.");
        return $e908ad5c0df5df0a$var$redacted;
    }
    return string;
}
function $e908ad5c0df5df0a$var$format() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _str = s || "";
    if (titleCase) _str = $e908ad5c0df5df0a$var$toTitleCase(s);
    if (redactingEmail) _str = $e908ad5c0df5df0a$var$redactEmail(_str);
    return _str;
}

});



parcelRegister("7YV43", function(module, exports) {
const $5cfa66c93d0144a9$var$clientConstants = {};
$5cfa66c93d0144a9$var$clientConstants.IS_DEV = !(window.SERVER_DATA && window.SERVER_DATA.featureFlags && window.SERVER_DATA.featureFlags.isProduction);
$5cfa66c93d0144a9$var$clientConstants.IS_IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.platform);
$5cfa66c93d0144a9$var$clientConstants.IS_IE = typeof navigator !== 'undefined' && /Trident/.test(navigator.userAgent);
$5cfa66c93d0144a9$var$clientConstants.IS_EDGE = typeof navigator !== 'undefined' && /Edge/.test(navigator.userAgent);
$5cfa66c93d0144a9$var$clientConstants.IS_IE_OR_EDGE = $5cfa66c93d0144a9$var$clientConstants.IS_IE || $5cfa66c93d0144a9$var$clientConstants.IS_EDGE;
$5cfa66c93d0144a9$var$clientConstants.IS_FIREFOX = typeof navigator !== 'undefined' && /firefox/.test(navigator.userAgent.toLowerCase());
$5cfa66c93d0144a9$var$clientConstants.IS_SAFARI = typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
module.exports = $5cfa66c93d0144a9$var$clientConstants;

});


parcelRegister("56juP", function(module, exports) {

var $7YV43 = parcelRequire("7YV43");
function $3b6ca2d30542b146$var$getSpaceBelow(domElement) {
    return window.innerHeight - domElement.getBoundingClientRect().bottom;
}
function $3b6ca2d30542b146$var$isScreenMobileSize() {
    return window.innerWidth < 768;
}
function $3b6ca2d30542b146$var$isScreenTabletSize() {
    return window.innerWidth < 1023 && window.innerWidth >= 768;
}
function $3b6ca2d30542b146$var$scrollY(y) {
    if ($7YV43.IS_IE_OR_EDGE) window.scrollTo(0, y);
    else window.scroll({
        top: y,
        behavior: 'smooth'
    });
}
function $3b6ca2d30542b146$var$scrollToWithNavbar(domElement) {
    const navbar = document.getElementsByClassName('navbar')[0];
    const elementDistFromTopOfViewPort = domElement.getBoundingClientRect().top - navbar.offsetHeight;
    const alreadyScrolledDistance = window.pageYOffset;
    $3b6ca2d30542b146$var$scrollY(elementDistFromTopOfViewPort + alreadyScrolledDistance);
}
module.exports = {
    scrollY: $3b6ca2d30542b146$var$scrollY,
    scrollToWithNavbar: $3b6ca2d30542b146$var$scrollToWithNavbar,
    getSpaceBelow: $3b6ca2d30542b146$var$getSpaceBelow,
    isScreenMobileSize: $3b6ca2d30542b146$var$isScreenMobileSize,
    isScreenTabletSize: $3b6ca2d30542b146$var$isScreenTabletSize
};

});

parcelRegister("8NdSf", function(module, exports) {

$parcel$export(module.exports, "withRouter", () => $4c2cd31e50baeb2f$export$369b6b2b30582e8e);

var $ayMG0 = parcelRequire("ayMG0");
const $4c2cd31e50baeb2f$var$React = 'react';

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $4c2cd31e50baeb2f$require$useLocation = $lzNIT.useLocation;
var $4c2cd31e50baeb2f$require$useNavigate = $lzNIT.useNavigate;
var $4c2cd31e50baeb2f$require$useParams = $aphAM.useParams;
function $4c2cd31e50baeb2f$export$369b6b2b30582e8e(Component) {
    function ComponentWithRouterProp(props) {
        const location = $4c2cd31e50baeb2f$require$useLocation();
        const navigate = $4c2cd31e50baeb2f$require$useNavigate();
        const params = $4c2cd31e50baeb2f$require$useParams();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
            ...props,
            location: location,
            history: navigate,
            params: params
        });
    }
    return ComponentWithRouterProp;
}

});

parcelRegister("8HpaJ", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $04d1d38acc4b386f$var$LoadingPage() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "loading-page",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "loader"
        })
    });
}
module.exports = $04d1d38acc4b386f$var$LoadingPage;

});

parcelRegister("85x8Z", function(module, exports) {

var $f1q41 = parcelRequire("f1q41");

var $aB89e = parcelRequire("aB89e");
var $5e38800bea6a2050$require$constants = $aB89e.spacerFree;

var $hjiT0 = parcelRequire("hjiT0");

var $460e9 = parcelRequire("460e9");
const $5e38800bea6a2050$var$REGIONS = $5e38800bea6a2050$require$constants.calculator.RSF_REGIONS;
const $5e38800bea6a2050$var$regionToCityList = {
    [$5e38800bea6a2050$var$REGIONS.NYC]: $5e38800bea6a2050$require$constants.geography.CITIES_OF_NY,
    [$5e38800bea6a2050$var$REGIONS.USA_METRO]: $5e38800bea6a2050$require$constants.geography.MOST_POPULATED_US_CITIES
};
const $5e38800bea6a2050$var$nycUSFFactor = 1.15;
const $5e38800bea6a2050$var$regionToDefaultLossFactor = {
    [$5e38800bea6a2050$var$REGIONS.NYC]: 0.27,
    [$5e38800bea6a2050$var$REGIONS.USA_METRO]: 0.175,
    [$5e38800bea6a2050$var$REGIONS.USA_SMALL]: 0.15,
    [$5e38800bea6a2050$var$REGIONS.DEFAULT_INTL]: 0.175,
    [$5e38800bea6a2050$var$REGIONS.UK]: 0.13,
    [$5e38800bea6a2050$var$REGIONS.DEFAULT_USA]: 0.15,
    [$5e38800bea6a2050$var$REGIONS.GE]: 0.23,
    [$5e38800bea6a2050$var$REGIONS.APAC]: 0.13,
    [$5e38800bea6a2050$var$REGIONS.FR]: 0.2912
};
function $5e38800bea6a2050$var$getRegion(location) {
    // TODO: reevaluate this when we go international.
    const { city: city, state: state, country: country, nonStandardUSAFormat: nonStandardUSAFormat } = $hjiT0.getCityStateCountry(location);
    if ($hjiT0.isUK(country)) return $5e38800bea6a2050$var$REGIONS.UK;
    // If the location is outside the USA or not an expected format for USA, use appropriate default regions
    if ($hjiT0.isAPAC(country)) return $5e38800bea6a2050$var$REGIONS.APAC;
    if ($hjiT0.isGermany(country)) return $5e38800bea6a2050$var$REGIONS.GE;
    if ($hjiT0.isFrance(country)) return $5e38800bea6a2050$var$REGIONS.FR;
    if (!$hjiT0.isUSA(country)) return $5e38800bea6a2050$var$REGIONS.DEFAULT_INTL;
    if (nonStandardUSAFormat) return $5e38800bea6a2050$var$REGIONS.DEFAULT_USA;
    if ((state === 'NY' || state === 'New York') && $5e38800bea6a2050$var$regionToCityList[$5e38800bea6a2050$var$REGIONS.NYC].indexOf(city) !== -1) return $5e38800bea6a2050$var$REGIONS.NYC;
    const metroLocation = $f1q41.find($5e38800bea6a2050$var$regionToCityList[$5e38800bea6a2050$var$REGIONS.USA_METRO], {
        city: city
    });
    if (metroLocation && (state === metroLocation.state || state === $5e38800bea6a2050$require$constants.geography.STATE_ABBREVIATION_TO_FULL[metroLocation.state])) return $5e38800bea6a2050$var$REGIONS.USA_METRO;
    return $5e38800bea6a2050$var$REGIONS.USA_SMALL;
}
function $5e38800bea6a2050$var$getDefaultLossFactorForSpecficLocation(location) {
    const { state: state, nonStandardUSAFormat: nonStandardUSAFormat } = $hjiT0.getCityStateCountry(location);
    if (nonStandardUSAFormat) return null;
    // New Jersey - 18%
    if (state === 'NJ' || state === 'New Jersey') return 0.18;
    return null;
}
function $5e38800bea6a2050$var$getDefaultLossFactor(location) {
    // First, check if there's a specific default loss factor for the location
    const lossFactor = $5e38800bea6a2050$var$getDefaultLossFactorForSpecficLocation(location);
    // If not, return the default loss factor for the region
    if (lossFactor) return lossFactor;
    return $5e38800bea6a2050$var$regionToDefaultLossFactor[$5e38800bea6a2050$var$getRegion(location)];
}
function $5e38800bea6a2050$var$getRSFForLocation(location, usf, lossFactor) {
    lossFactor = $f1q41.isUndefined(lossFactor) ? $5e38800bea6a2050$var$getDefaultLossFactor(location) : lossFactor; // so 0 could be a legit lossFactor input
    const region = $5e38800bea6a2050$var$getRegion(location);
    switch(region){
        case $5e38800bea6a2050$var$REGIONS.NYC:
            return usf / (1 - lossFactor);
        case $5e38800bea6a2050$var$REGIONS.USA_METRO:
        case $5e38800bea6a2050$var$REGIONS.USA_SMALL:
        case $5e38800bea6a2050$var$REGIONS.DEFAULT_USA:
        case $5e38800bea6a2050$var$REGIONS.UK:
        case $5e38800bea6a2050$var$REGIONS.GE:
        case $5e38800bea6a2050$var$REGIONS.FR:
        case $5e38800bea6a2050$var$REGIONS.APAC:
        case $5e38800bea6a2050$var$REGIONS.DEFAULT_INTL:
            // These cases may get different formulas as workplace finds its life
            return usf * (1 + lossFactor);
        default:
            throw new Error('Girl your region is trash what are you doing');
    }
}
function $5e38800bea6a2050$var$getUSFForLocation(location, standardUSF) {
    return $5e38800bea6a2050$var$getRegion(location) === $5e38800bea6a2050$var$REGIONS.NYC ? standardUSF * $5e38800bea6a2050$var$nycUSFFactor : standardUSF;
}
function $5e38800bea6a2050$var$getNIAForLocation(location, usf, fitFactor) {
    const smallBOMArsf = usf * 1.15;
    return smallBOMArsf * (1 - fitFactor);
}
function $5e38800bea6a2050$var$getNIAInTsubo(usf) {
    return Math.round($460e9.convertSqFeetToTsubo(usf) * 0.87);
}
function $5e38800bea6a2050$var$getRSFRange(rsf) {
    return {
        min: 0.95 * rsf,
        max: 1.15 * rsf
    };
}
// returns usf or rsf for given sf based on location and loss factor
function $5e38800bea6a2050$var$getAreaForContext(sf, sfType, location, lossFactor) {
    const usf = $5e38800bea6a2050$var$getUSFForLocation(location, sf);
    switch(sfType){
        case $5e38800bea6a2050$require$constants.calculator.SF_TYPE.USF:
            return usf;
        case $5e38800bea6a2050$require$constants.calculator.SF_TYPE.RSF:
            return $5e38800bea6a2050$var$getRSFForLocation(location, usf, lossFactor);
        case $5e38800bea6a2050$require$constants.calculator.SF_TYPE.NIA:
            return $5e38800bea6a2050$var$getNIAForLocation(location, sf, lossFactor);
        default:
            console.log('That SF Type does not exist, sorry');
            return null;
    }
}
module.exports = {
    nycUSFFactor: $5e38800bea6a2050$var$nycUSFFactor,
    getRegion: $5e38800bea6a2050$var$getRegion,
    getDefaultLossFactor: $5e38800bea6a2050$var$getDefaultLossFactor,
    getRSFForLocation: $5e38800bea6a2050$var$getRSFForLocation,
    getUSFForLocation: $5e38800bea6a2050$var$getUSFForLocation,
    getRSFRange: $5e38800bea6a2050$var$getRSFRange,
    getAreaForContext: $5e38800bea6a2050$var$getAreaForContext,
    getNIAInTsubo: $5e38800bea6a2050$var$getNIAInTsubo
};

});
parcelRegister("460e9", function(module, exports) {

var $f1q41 = parcelRequire("f1q41");

const $2fb7e614fcd2df40$var$MEASUREMENT_SYSTEM = (parcelRequire("aB89e")).shared.calculator.MEASUREMENT_SYSTEM;
const $2fb7e614fcd2df40$var$units = {};
const $2fb7e614fcd2df40$var$IMPERIAL_TO_METRIC_COPY = {
    SF: 'SM',
    USF: 'USM',
    RSF: 'RSM',
    NSF: 'NSM',
    NIA: 'NIA',
    feet: 'meters',
    Feet: 'Meters',
    footage: 'meters',
    Footage: 'Meters',
    'sqft.': 'sqm.',
    foot: 'meter'
};
const $2fb7e614fcd2df40$var$FEET_TO_METERS = 0.3048;
const $2fb7e614fcd2df40$var$SQ_FEET_TO_SQ_METERS = $2fb7e614fcd2df40$var$FEET_TO_METERS * $2fb7e614fcd2df40$var$FEET_TO_METERS;
const $2fb7e614fcd2df40$var$TSUBO_TO_SQ_METERS = 3.305785;
const $2fb7e614fcd2df40$var$TSUBO_TO_SQ_FEET = 35.58;
$2fb7e614fcd2df40$var$units.isImperial = function(system) {
    return system === $2fb7e614fcd2df40$var$MEASUREMENT_SYSTEM.IMPERIAL;
};
$2fb7e614fcd2df40$var$units.isMetric = function(system) {
    return system === $2fb7e614fcd2df40$var$MEASUREMENT_SYSTEM.METRIC;
};
$2fb7e614fcd2df40$var$units.isTsubo = function(system) {
    return system === $2fb7e614fcd2df40$var$MEASUREMENT_SYSTEM.TSUBO;
};
$2fb7e614fcd2df40$var$units.getCopyForMeasurementSystem = function(imperialCopy, system) {
    if ($2fb7e614fcd2df40$var$units.isImperial(system)) return imperialCopy;
    if ($2fb7e614fcd2df40$var$units.isTsubo(system) && imperialCopy !== 'NIA') return 'Tsubo';
    return $2fb7e614fcd2df40$var$IMPERIAL_TO_METRIC_COPY[imperialCopy];
};
/* Exact same function as getCopyForMeasurementSystem, but renamed for clarity to indicate that the
   returned value serves as a token for Spacer Free to use, whereas in SpacerPro,
   getCopyForMeasurementSystem is rendered directly into the components. */ $2fb7e614fcd2df40$var$units.getTokenKeyForMeasurementSystem = function(imperialCopy, system) {
    return $2fb7e614fcd2df40$var$units.getCopyForMeasurementSystem(imperialCopy, system);
};
$2fb7e614fcd2df40$var$units.getNumberForMeasurementSystem = function(squareFootage, system, opts = {
    precisionForMeter: 0,
    precisionForFeet: 0,
    precisionForTsubo: 0
}) {
    switch(system){
        case $2fb7e614fcd2df40$var$MEASUREMENT_SYSTEM.METRIC:
            return $f1q41.round(squareFootage * $2fb7e614fcd2df40$var$SQ_FEET_TO_SQ_METERS, opts.precisionForMeter);
        case $2fb7e614fcd2df40$var$MEASUREMENT_SYSTEM.TSUBO:
            return $f1q41.round(squareFootage / $2fb7e614fcd2df40$var$TSUBO_TO_SQ_FEET, opts.precisionForTsubo);
        case $2fb7e614fcd2df40$var$MEASUREMENT_SYSTEM.IMPERIAL:
        default:
            return $f1q41.round(squareFootage, opts.precisionForFeet);
    }
};
$2fb7e614fcd2df40$var$units.getSqFeetForMeasurementSystem = function(value, system) {
    switch(system){
        case $2fb7e614fcd2df40$var$MEASUREMENT_SYSTEM.METRIC:
            return $2fb7e614fcd2df40$var$units.convertSqMetersToSqFeet(value);
        case $2fb7e614fcd2df40$var$MEASUREMENT_SYSTEM.TSUBO:
            return $2fb7e614fcd2df40$var$units.convertTsuboToSqFeet(value);
        case $2fb7e614fcd2df40$var$MEASUREMENT_SYSTEM.IMPERIAL:
        default:
            return value;
    }
};
$2fb7e614fcd2df40$var$units.convertSqMetersToSqFeet = function(squareMeters) {
    return Math.round(squareMeters / $2fb7e614fcd2df40$var$SQ_FEET_TO_SQ_METERS);
};
$2fb7e614fcd2df40$var$units.convertSqMetersToTsubo = function(squareMeters) {
    return Math.round(squareMeters / $2fb7e614fcd2df40$var$TSUBO_TO_SQ_METERS);
};
$2fb7e614fcd2df40$var$units.convertSqFeetToTsubo = function(squareFeet) {
    return Math.round(squareFeet / $2fb7e614fcd2df40$var$TSUBO_TO_SQ_FEET);
};
$2fb7e614fcd2df40$var$units.convertTsuboToSqFeet = function(tsubo) {
    return Math.round(tsubo * $2fb7e614fcd2df40$var$TSUBO_TO_SQ_FEET);
};
module.exports = $2fb7e614fcd2df40$var$units;

});


parcelRegister("ijNBi", function(module, exports) {
module.exports = {
    dashOrValue (displayDash, formattedValue) {
        return displayDash ? "\u2014" : formattedValue;
    }
};

});

parcelRegister("jxSY2", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
let $155a580b1a3f9e12$var$segmentStyle = null;
function $155a580b1a3f9e12$var$computeSubTitleStyles(percentage, isMobileScreen, subtitle, isGroupSpace) {
    if (isMobileScreen) {
        const percent = Number(percentage.slice(0, -1));
        if (percent < 20 && subtitle && isGroupSpace) {
            if (percent < 5) return 'group-space-xs';
            return 'group-space-small';
        }
        if (subtitle && !isGroupSpace) {
            if (percent < 21) {
                if (percent < 5) return 'not-group-space-xs';
                return 'not-group-space-small';
            }
            return 'not-group-space';
        }
    }
    return '';
}
function $155a580b1a3f9e12$var$BarChartSegment(props) {
    if (props.isMobileScreen) $155a580b1a3f9e12$var$segmentStyle = {
        width: `calc(${props.percentage} + 10%)`
    };
    else $155a580b1a3f9e12$var$segmentStyle = {
        width: props.percentage
    };
    const barClasses = `program-bar-chart-bar is-${props.colorClass}`;
    let titleClasses = 'title is-half-spaced has-text-weight-bold program-bar-chart-segment-percentage';
    const subtitleClasses = `subtitle is-6 program-bar-chart-segment-subtitle has-text-${props.colorClass} has-margin-bottom-6 ${$155a580b1a3f9e12$var$computeSubTitleStyles(props.percentage, props.isMobileScreen, props.percentageSubtitle, props.isGroupSpace)}`;
    if (props.isMobileScreen) titleClasses += ` has-text-${props.colorClass}`;
    else titleClasses += ' has-text-white';
    let subtitle = props.percentageSubtitle ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: subtitleClasses,
        title: props.percentageSubtitle,
        children: [
            " ",
            props.percentageSubtitle
        ]
    }, "1") : null;
    let percentage = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: titleClasses,
        children: [
            props.percentage.slice(0, -1),
            "%"
        ]
    });
    let bar = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: barClasses,
        children: percentage
    }, "2");
    let segmentMarkup = [
        subtitle,
        bar
    ];
    if (props.isMobileScreen) {
        subtitle = props.percentageSubtitle ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: subtitleClasses,
            children: [
                " ",
                props.percentageSubtitle.split(' ')[0]
            ]
        }, "1") : null;
        bar = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: barClasses
        }, "2");
        percentage = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: titleClasses,
            children: [
                props.percentage.slice(0, -1),
                "%"
            ]
        }, "3");
        segmentMarkup = [
            percentage,
            bar,
            subtitle
        ];
    }
    const segmentClasses = 'has-text-centered program-bar-chart-segment';
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: segmentClasses,
        style: $155a580b1a3f9e12$var$segmentStyle,
        children: segmentMarkup
    });
}
$155a580b1a3f9e12$var$BarChartSegment.propTypes = {
    colorClass: $c9Z8w.string.isRequired,
    percentage: $c9Z8w.string.isRequired,
    percentageSubtitle: $c9Z8w.string,
    isMobileScreen: $c9Z8w.bool,
    isGroupSpace: $c9Z8w.bool
};
$155a580b1a3f9e12$var$BarChartSegment.defaultProps = {
    isMobileScreen: false,
    isGroupSpace: false,
    percentageSubtitle: ''
};
module.exports = $155a580b1a3f9e12$var$BarChartSegment;

});

parcelRegister("5sKyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3ae484854b431$export$2e2bcd8739ae039);

var $aZg8W = parcelRequire("aZg8W");

var $7qKRb = parcelRequire("7qKRb");

var $2uohp = parcelRequire("2uohp");
function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $aZg8W.default).randomUUID && !buf && !options) return (0, $aZg8W.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $7qKRb.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $2uohp.unsafeStringify)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;

});
parcelRegister("aZg8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffc1f94643dc7e4$export$2e2bcd8739ae039);
const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};

});

parcelRegister("7qKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f4ee4022ba00e$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}

});

parcelRegister("2uohp", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $1d0137947e8554ce$export$8fb373d660548968);

var $64ZUg = parcelRequire("64ZUg");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $64ZUg.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

});
parcelRegister("64ZUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d323206dcbf256$export$2e2bcd8739ae039);

var $4meF0 = parcelRequire("4meF0");
function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $4meF0.default).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;

});
parcelRegister("4meF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c496bfb6c27b56$export$2e2bcd8739ae039);
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});





//# sourceMappingURL=spacerFree.4317c135.js.map
